var Cn = Object.defineProperty;
var Rn = (n, e, t) => e in n ? Cn(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var Q = (n, e, t) => Rn(n, typeof e != "symbol" ? e + "" : e, t);
import { parseRecordId as Un, calendarDateToUtcDate as ft, addCalendarDays as Fn, toCalendarDateInput as jn, resolveTimeZone as Jn, endOfCalendarDayInTimeZone as Ln, calendarDateInTimeZone as ht, formatInvoiceNo as D, SUBSCRIPTION_TIER_LABELS as Bn, ACTIVE_JOB_STATUSES as le, resolveInvoiceNumberArg as ce, resolveCustomAnswers as sn, assignFormToolSlugs as an, MEMORY_MAX_MARKDOWN_BYTES as Be, MEMORY_MAX_UPLOAD_BYTES as yt, MEMORY_DEFAULT_LIMIT_BYTES as qn, MEMORY_TREE_TOOLS as Yn, isValidKnowledgeDocName as st, parseMemoryCard as Hn, memoryCardEntries as Vn, RESERVED_OUTREACH_KEYS as Wn, validateOutreachFieldValueRecord as pt, parseOutreachFormFields as Kn, OUTREACH_PAGE_LINKS as It, MEMORY_BUCKET as zn } from "@tenfour/contracts";
const Gn = 500;
function Qn(n, e, t) {
  const i = new Date(n);
  if (e === "DAILY") i.setUTCDate(i.getUTCDate() + t);
  else if (e === "WEEKLY") i.setUTCDate(i.getUTCDate() + 7 * t);
  else if (e === "MONTHLY") {
    const o = i.getUTCDate();
    i.setUTCDate(1), i.setUTCMonth(i.getUTCMonth() + t);
    const r = new Date(Date.UTC(i.getUTCFullYear(), i.getUTCMonth() + 1, 0)).getUTCDate();
    i.setUTCDate(Math.min(o, r));
  } else if (e === "YEARLY") {
    const o = i.getUTCDate(), r = i.getUTCMonth();
    i.setUTCDate(1), i.setUTCFullYear(i.getUTCFullYear() + t);
    const a = new Date(Date.UTC(i.getUTCFullYear(), r + 1, 0)).getUTCDate();
    i.setUTCDate(Math.min(o, a));
  }
  return i;
}
function Zn(n, e) {
  const t = n.endAt.getTime() - n.startAt.getTime(), i = e.getTime() - t - n.startAt.getTime();
  return i <= 0 ? 0 : n.recurrence === "DAILY" ? Math.floor(i / 864e5) : n.recurrence === "WEEKLY" ? Math.floor(i / (7 * 864e5)) : n.recurrence === "MONTHLY" ? Math.max(0, Math.floor(i / (31 * 864e5)) - 1) : n.recurrence === "YEARLY" ? Math.max(0, Math.floor(i / (366 * 864e5)) - 1) : 0;
}
function es(n, e, t) {
  const i = n.endAt.getTime() - n.startAt.getTime(), o = [];
  if (n.recurrence === "NONE")
    return n.startAt <= t && n.endAt >= e && o.push({ eventId: n.id, occurrenceStartAt: n.startAt, occurrenceEndAt: n.endAt, event: n }), o;
  let r = Zn(n, e);
  for (let a = 0; a < Gn; a++, r++) {
    const s = Qn(n.startAt, n.recurrence, r);
    if (s > t) break;
    const c = new Date(s.getTime() + i);
    c >= e && o.push({ eventId: n.id, occurrenceStartAt: s, occurrenceEndAt: c, event: n });
  }
  return o;
}
function ts(n, e, t) {
  return {
    accountId: n,
    startAt: { lte: t },
    OR: [{ endAt: { gte: e } }, { recurrence: { not: "NONE" } }]
  };
}
const gt = 14, Xn = 40;
function Y(n, e, t) {
  try {
    return new Intl.DateTimeFormat("en-US", { timeZone: e, ...t }).format(n);
  } catch {
    return new Intl.DateTimeFormat("en-US", { timeZone: "UTC", ...t }).format(n);
  }
}
function ns(n) {
  const { now: e, timezone: t } = n, i = { weekday: "short", month: "short", day: "numeric" }, o = { hour: "numeric", minute: "2-digit" }, r = Y(e, t, { ...i, year: "numeric" }), a = Y(e, t, o), s = /* @__PURE__ */ new Set(), c = [...n.busy].filter((u) => u.endAt.getTime() >= e.getTime()).sort((u, l) => u.startAt.getTime() - l.startAt.getTime()).filter((u) => {
    const l = `${u.startAt.getTime()}:${u.endAt.getTime()}:${u.title}`;
    return s.has(l) ? !1 : (s.add(l), !0);
  }).slice(0, Xn);
  return [
    `Today: ${r}, ${a} (${t}).`,
    c.length === 0 ? `Owner's calendar: no busy blocks in the next ${gt} days.` : `Owner's calendar — BUSY (next ${gt} days):`,
    ...c.map((u) => {
      const l = Y(u.startAt, t, i);
      if (u.allDay) return `- ${l}: all day — ${u.title}`;
      const f = Y(u.endAt, t, i) === l ? Y(u.endAt, t, o) : `${Y(u.endAt, t, i)} ${Y(u.endAt, t, o)}`;
      return `- ${l} ${Y(u.startAt, t, o)}–${f} — ${u.title}`;
    })
  ].join(`
`);
}
async function xn(n, e) {
  const t = await n.account.findMany({
    where: { role: "ADMIN" },
    select: { id: !0, oncallActive: !0, adminSmsEnabled: !0, ownerPhone: !0 }
  });
  if (t.length === 0) return;
  const i = e.aggregateType ?? "admin_notification", o = e.priority ?? 10;
  for (const r of t) {
    const a = {
      accountId: r.id,
      kind: e.kind,
      title: e.title,
      body: e.body,
      deepLink: e.deepLink
    };
    if (await n.outbox.upsert({
      where: { idempotencyKey: `${e.kind}:${r.id}:${e.entityId}` },
      create: {
        aggregateType: i,
        aggregateId: e.entityId,
        eventType: "push.notify",
        payload: a,
        idempotencyKey: `${e.kind}:${r.id}:${e.entityId}`,
        accountId: r.id,
        priority: o
      },
      update: {}
    }), (r.oncallActive || r.adminSmsEnabled) && r.ownerPhone) {
      const s = { adminId: r.id, to: r.ownerPhone, body: `${e.title}: ${e.body}` };
      await n.outbox.upsert({
        where: { idempotencyKey: `${e.kind}.sms:${r.id}:${e.entityId}` },
        create: {
          aggregateType: i,
          aggregateId: e.entityId,
          eventType: "admin.sms",
          payload: s,
          idempotencyKey: `${e.kind}.sms:${r.id}:${e.entityId}`,
          accountId: r.id,
          priority: o
        },
        update: {}
      });
    }
  }
}
const wt = "admin.review_item.created", vt = "admin.invoice.pending_review_email";
async function os(n, e) {
  const t = `${wt}:${e.interactionLogId}:${e.toolCallIndex}`;
  await n.outbox.upsert({
    where: { idempotencyKey: t },
    create: {
      aggregateType: "inference_review",
      aggregateId: `${e.interactionLogId}:${e.toolCallIndex}`,
      eventType: wt,
      payload: e,
      idempotencyKey: t,
      accountId: e.accountId,
      priority: 30
    },
    update: {}
  });
}
async function cn(n, e) {
  const t = `${vt}:${e.invoiceId}`;
  await n.outbox.upsert({
    where: { idempotencyKey: t },
    create: {
      aggregateType: "invoice",
      aggregateId: e.invoiceId,
      eventType: vt,
      payload: e,
      idempotencyKey: t,
      accountId: e.accountId,
      priority: 30
    },
    update: {}
  });
}
const Ze = (n) => Math.round((n + Number.EPSILON) * 100) / 100;
function un(n, e, t) {
  if (e <= 0 || t <= 0) return n;
  const i = n - t * (n / e);
  return i > 0 ? Ze(i) : 0;
}
function Xe(n, e, t = 0) {
  let i = 0, o = 0, r = 0, a = 0;
  for (const l of n) {
    const f = (l.quantity ?? 1) * l.unitPrice, h = String(l.type ?? "").trim().toLowerCase();
    h === "labor" ? i += f : h === "part" ? o += f : r += f, l.taxable && (a += f);
  }
  const s = i + o + r, c = un(a, s, t), d = Ze(c * e), u = Ze(s - t + d);
  return { laborTotal: i, partsTotal: o, servicesTotal: r, subtotal: s, taxableAmount: a, discountAmount: t, taxBase: c, taxAmount: d, total: u };
}
function xe(n) {
  if (!n.showSalesTax) return "Sales tax is off for this account — none applied.";
  if (n.taxableAmount <= 0) return "Sales tax is on, but no line items are marked taxable — $0 tax.";
  if (n.taxRate > 0) {
    const e = (n.taxRate * 100).toFixed(2).replace(/\.?0+$/, ""), t = [n.taxState, n.zip].filter(Boolean).join(" ") || "the job's location";
    return `Sales tax on — ${e}% for ${t} via Zip.tax.`;
  }
  return n.zip ? "Sales tax on, but Zip.tax returned no rate for this address — $0 recorded, verify before sending." : "Sales tax on, but no job address is on file — $0 recorded.";
}
const bt = (n) => Math.round((n + Number.EPSILON) * 100) / 100;
function eo(n) {
  const e = Number(n.subtotal) || 0, t = Number(n.discountAmount) || 0, i = Number(n.rakePercent) || 0, o = bt(Math.max(e - t, 0)), r = bt(o * (i / 100));
  return {
    taxRate: 0,
    taxAmount: 0,
    taxState: null,
    taxWarning: null,
    taxBasis: xe({ showSalesTax: !1, taxableAmount: 0, taxRate: 0, taxState: null, zip: null }),
    total: o,
    rakeAmount: r
  };
}
function rs(n) {
  const e = (t) => typeof t == "number" ? t : t.toNumber();
  return e(n.taxAmount) > 0 || e(n.taxRate) > 0 || n.taxState != null && n.taxState !== "";
}
async function is(n, e) {
  const t = await n.invoice.findMany({
    where: {
      accountId: e,
      status: "DRAFT",
      OR: [{ taxAmount: { gt: 0 } }, { taxRate: { gt: 0 } }, { taxState: { not: null } }]
    },
    select: { id: !0, subtotal: !0, discountAmount: !0, rakePercent: !0 }
  }), i = [];
  for (const o of t) {
    const r = eo({
      subtotal: Number(o.subtotal),
      discountAmount: Number(o.discountAmount),
      rakePercent: Number(o.rakePercent)
    });
    (await n.invoice.updateMany({ where: { id: o.id, status: "DRAFT" }, data: r })).count === 1 && i.push(o.id);
  }
  return { invoiceIds: i };
}
class be extends Error {
  constructor(e) {
    super(e), this.name = "InvoiceInputError";
  }
}
function to(n, e = {}) {
  var o;
  for (const r of n ?? []) {
    const a = ((o = r == null ? void 0 : r.name) == null ? void 0 : o.trim()) || "line item";
    if ((r == null ? void 0 : r.unitPrice) != null && (!Number.isFinite(r.unitPrice) || r.unitPrice < 0))
      throw new be(`"${a}" has a negative or invalid price.`);
    if ((r == null ? void 0 : r.quantity) != null && (!Number.isFinite(r.quantity) || r.quantity < 0))
      throw new be(`"${a}" has a negative or invalid quantity.`);
  }
  const { discountPercent: t, discountAmount: i } = e;
  if (t != null && (!Number.isFinite(t) || t < 0 || t > 100))
    throw new be("Discount percent must be between 0 and 100.");
  if (i != null && (!Number.isFinite(i) || i < 0))
    throw new be("Discount amount cannot be negative.");
}
async function no(n, e, t) {
  await n.customer.update({
    where: { id: e },
    data: {
      totalJobs: { increment: 1 },
      totalBilled: { increment: t },
      lastJobAt: /* @__PURE__ */ new Date()
    }
  });
}
const ss = 20, as = [
  { key: "all", label: "All" },
  { key: "CUSTOMER", label: "Customers" },
  { key: "PROSPECT", label: "Prospects" },
  { key: "INACTIVE", label: "Inactive" }
];
function Nt(n) {
  return n.status === "INACTIVE";
}
function dn(n, e) {
  return e === "INACTIVE" ? Nt(n) : Nt(n) ? !1 : e === "all" || n.contactStatus === e;
}
function cs(n, e, t) {
  return e === n ? { sortKey: n, sortDir: t === "asc" ? "desc" : "asc" } : { sortKey: n, sortDir: "asc" };
}
function us(n, e) {
  return n.filter((t) => dn(t, e)).length;
}
function oo(n, e, t, i) {
  let o = 0;
  switch (t) {
    case "name":
      o = n.name.localeCompare(e.name);
      break;
    case "phone":
      o = n.phone.localeCompare(e.phone);
      break;
    case "totalSpent":
      o = n.totalSpent - e.totalSpent;
      break;
    case "totalJobs":
      o = n.totalJobs - e.totalJobs;
      break;
    case "contactStatus":
      o = (n.contactStatus ?? "").localeCompare(e.contactStatus ?? "");
      break;
    case "lastJobAt": {
      const r = n.lastJobAt ? new Date(n.lastJobAt).getTime() : 0, a = e.lastJobAt ? new Date(e.lastJobAt).getTime() : 0;
      o = r - a;
      break;
    }
  }
  return i === "asc" ? o : -o;
}
function ds(n, {
  statusFilter: e,
  search: t,
  sortKey: i,
  sortDir: o
}) {
  let r = n.filter((a) => dn(a, e));
  if (t) {
    const a = t.toLowerCase();
    r = r.filter(
      (s) => s.name.toLowerCase().includes(a) || s.phone.includes(a) || s.address && s.address.toLowerCase().includes(a)
    );
  }
  return r.sort((a, s) => oo(a, s, i, o)), r;
}
const ls = 20, ms = [
  { key: "all", label: "All invoices" },
  { key: "draft", label: "Drafts & pending" },
  { key: "quotes", label: "Quotes" },
  { key: "sent", label: "Sent" },
  { key: "overdue", label: "Overdue" },
  { key: "paid", label: "Paid" }
];
function fs(n, e, t) {
  return e === n ? { sortKey: n, sortDir: t === "asc" ? "desc" : "asc" } : { sortKey: n, sortDir: "asc" };
}
function et(n) {
  return n.dueDate ?? n.overdueAt ?? void 0;
}
const ro = {
  draft: ["Draft", "In review", "On its way"],
  quotes: ["Quote"],
  sent: ["Sent"],
  overdue: ["Overdue"]
};
function ln(n, e) {
  return e === "all" ? !0 : e === "paid" ? !!n.isFullyPaid : !!n.displayStatus && ro[e].includes(n.displayStatus);
}
const io = 864e5;
function Tt(n, e, t) {
  if (!e) return !0;
  if (!n) return !1;
  const i = new Date(n).getTime();
  if (Number.isNaN(i)) return !1;
  if (e.kind === "relative")
    return i >= t.getTime() - e.days * io && i <= t.getTime();
  if (e.from) {
    const o = (/* @__PURE__ */ new Date(`${e.from}T00:00:00.000Z`)).getTime();
    if (!Number.isNaN(o) && i < o) return !1;
  }
  if (e.to) {
    const o = (/* @__PURE__ */ new Date(`${e.to}T23:59:59.999Z`)).getTime();
    if (!Number.isNaN(o) && i > o) return !1;
  }
  return !0;
}
function so(n, e) {
  return e ? !(e.min !== void 0 && n.total < e.min || e.max !== void 0 && n.total > e.max) : !0;
}
function mn(n, e, t = /* @__PURE__ */ new Date()) {
  let i = n;
  if (e.status && (i = i.filter((o) => o.displayStatus === e.status)), e.search) {
    const o = e.search.toLowerCase(), r = Un(e.search), a = (r == null ? void 0 : r.kind) != null;
    i = i.filter(
      (s) => a ? r.kind !== "customer" && s.invoiceNumber === r.number : s.customerName.toLowerCase().includes(o) || s.invoiceNumber != null && String(s.invoiceNumber).includes(o) || s.customerPhone && s.customerPhone.includes(o)
    );
  }
  return i = i.filter(
    (o) => Tt(o.createdAt, e.created, t) && Tt(et(o), e.due, t) && so(o, e.total)
  ), i;
}
function hs(n, e, t, i = /* @__PURE__ */ new Date()) {
  return mn(n, t, i).filter((o) => ln(o, e)).length;
}
function ao(n, e, t, i) {
  let o = 0;
  switch (t) {
    case "total":
      o = n.total - e.total;
      break;
    case "invoiceNumber": {
      if (n.invoiceNumber == null && e.invoiceNumber == null) return 0;
      if (n.invoiceNumber == null) return 1;
      if (e.invoiceNumber == null) return -1;
      o = n.invoiceNumber - e.invoiceNumber;
      break;
    }
    case "customer":
      o = n.customerName.localeCompare(e.customerName);
      break;
    case "due": {
      const r = et(n), a = et(e);
      o = (r ? new Date(r).getTime() : 0) - (a ? new Date(a).getTime() : 0);
      break;
    }
    case "created":
      o = new Date(n.createdAt).getTime() - new Date(e.createdAt).getTime();
      break;
  }
  return i === "asc" ? o : -o;
}
function ys(n, e, t = /* @__PURE__ */ new Date()) {
  return [...mn(n, e, t).filter((o) => ln(o, e.stage))].sort((o, r) => ao(o, r, e.sortKey, e.sortDir));
}
function ps(n, e = /* @__PURE__ */ new Date()) {
  return !n.isFullyPaid && (n.status === "OVERDUE" || n.status === "SENT" && !!n.overdueAt && new Date(n.overdueAt).getTime() < e.getTime()) ? "overdue" : n.status === "DRAFT" ? "awaiting_ok" : null;
}
const co = 10080 * 60 * 1e3;
function Is(n, e = /* @__PURE__ */ new Date()) {
  let t = 0, i = 0, o = 0;
  const r = e.getTime() - co;
  for (const a of n) {
    (a.status === "SENT" || a.status === "OVERDUE") && !a.isFullyPaid && (t += a.balanceDue ?? a.total, i += 1);
    for (const s of a.payments ?? [])
      s.kind !== "PAYMENT" || s.status !== "COMPLETED" || new Date(s.paidAt).getTime() >= r && (o += s.amount);
  }
  return { outstanding: t, outstandingCount: i, paidThisWeek: o };
}
function gs(n, e) {
  return e ? "unavailable" : n === void 0 ? "loading" : "ready";
}
function ws(n, e = /* @__PURE__ */ new Date()) {
  if (!n) return !1;
  const t = new Date(e);
  return t.setHours(23, 59, 59, 999), new Date(n).getTime() <= t.getTime();
}
function vs(n) {
  return [...n].sort((e, t) => e.tier - t.tier || t.at.localeCompare(e.at));
}
const uo = 7 * 864e5;
function At(n, e, t) {
  return e ? n <= e.at && t - e.snoozedAtMs < uo : !1;
}
const lo = (/* @__PURE__ */ new Date(0)).toISOString();
function mo(n) {
  return n.unreadCount === 0 && !n.hasPendingAction ? null : {
    itemId: `conversation:${n.id}`,
    at: n.lastMessageAt ?? n.lastCallAt ?? lo
  };
}
function bs(n, e, t, i, o = Date.now()) {
  const r = mo(n);
  if (r)
    return i.has(r.itemId) || At(r.at, t[r.itemId], o) ? null : { kind: "conversation", ...r };
  const a = e.filter(
    (s) => !s.read && s.eventType === "customer.relay" && s.entityType === "conversation" && s.entityId === n.id
  ).sort(
    (s, c) => c.createdAt.localeCompare(s.createdAt) || c.id.localeCompare(s.id)
  );
  for (const s of a) {
    const c = `relay:${s.id}`;
    if (!(i.has(c) || At(s.createdAt, t[c], o)))
      return {
        kind: "relay",
        itemId: c,
        notificationId: s.id,
        at: s.createdAt
      };
  }
  return null;
}
const fn = [
  { key: "tradeDescription", label: "What you do" },
  // "Business address" is one field to and four columns to the account row.
  // Listed apart so the card can name the line that is actually blank rather
  // than sending the owner back to re-read an address that is nearly complete.
  { key: "street", label: "Street" },
  { key: "city", label: "City" },
  { key: "state", label: "State" },
  { key: "zip", label: "ZIP" }
];
function fo(n) {
  return !n || !n.trim();
}
function ho(n) {
  return fn.filter((e) => fo(n[e.key])).map((e) => e.key);
}
function Ns(n) {
  return ho(n).length === 0;
}
function Ts(n) {
  const e = new Map(fn.map((t) => [t.key, t.label]));
  return n.map((t) => e.get(t) ?? t);
}
const hn = [
  {
    key: "finish-profile",
    title: "Finish your business profile",
    detail: "What you do and where you work — Lyra and Aria cannot answer a customer well without it.",
    href: "/settings",
    actionLabel: "Add business details",
    dismissible: !0,
    isDone: (n) => n.profileComplete
  },
  {
    key: "connect-payments",
    title: "Connect payments",
    detail: "Finish connecting Stripe so customers can pay invoice links.",
    href: "/settings/payments",
    actionLabel: "Go to Payments",
    dismissible: !0,
    // `stripeOnboardingComplete` can be true while Stripe still refuses charges
    // (pending verification). The owner's question is "can I get paid", so the
    // item tracks the answer to that and not the paperwork.
    isDone: (n) => n.stripeChargesEnabled
  },
  {
    key: "add-services",
    title: "Add your services and rates",
    detail: "Review the services and prices Ten Four can quote to customers.",
    href: "/settings/services",
    actionLabel: "Go to Services",
    dismissible: !0,
    isDone: (n) => n.serviceCount > 0
  },
  {
    key: "test-text",
    title: "Send your first test text",
    detail: "Text your new Ten Four number to see what a customer sees.",
    href: "/messages",
    actionLabel: "Go to Messages",
    dismissible: !0,
    isDone: (n) => n.inboundMessageCount > 0
  }
], As = hn.map((n) => n.key), yo = new Map(
  hn.map((n) => [n.key, n])
);
function po(n) {
  return n ? yo.get(n) ?? null : null;
}
function Ss(n) {
  return po(n) !== null;
}
function Es(n, e, t) {
  return n.isDone(t) ? "DONE" : e === "DISMISSED" ? "DISMISSED" : "TODO";
}
function ks(n) {
  return n.length > 0 && n.every((e) => e === "DONE" || e === "DISMISSED");
}
function Os(n) {
  return n.filter((e) => e === "TODO").length;
}
const St = "outreach-setup:", Io = /* @__PURE__ */ new Set([
  "finish-profile",
  "connect-payments",
  "add-services",
  "business-hours",
  "test-text"
]);
function _s(n) {
  if (!n || !n.startsWith(St)) return !1;
  const e = n.slice(St.length), t = e.lastIndexOf(":");
  return t < 1 || t === e.length - 1 ? !1 : Io.has(e.slice(t + 1));
}
function $s(n) {
  switch (n) {
    case "COMPLETE":
    case "ACTIVE":
    case "DONE":
    case "COMPLETED":
      return "done";
    case "SENT":
      return "invoice_sent";
    case "PAID":
    case "PAID_MANUAL":
      return "paid";
    case "PENDING":
    case "PENDING_REVIEW":
    case "PENDING_TRIAGE":
    case "IN_PROGRESS":
      return "pending_review";
    case "TRIAL":
    case "PENDING_CONFIRMATION":
      return "pending_confirmation";
    case "PAST_DUE":
    case "CANCELED":
    case "VOID":
    case "OVERDUE":
      return "canceled";
    default:
      return "default";
  }
}
function yn(n) {
  return n.type === "VOICE" || n.lastCallAt && (!n.lastMessageAt || n.lastCallAt > n.lastMessageAt) ? "call" : "text";
}
function pn(n) {
  return n.lastMessageAt && n.lastCallAt ? n.lastMessageAt > n.lastCallAt ? n.lastMessageAt : n.lastCallAt : n.lastMessageAt ?? n.lastCallAt ?? null;
}
function Ds(n, e) {
  const { jobs: t, conversations: i, notifications: o, reminders: r = [] } = n, a = e !== "activity", s = a ? t[0] ?? null : null;
  if (e === "jobs")
    return {
      upNext: s,
      rows: t.slice(1).map((u) => ({ kind: "job", at: u.createdAt, job: u }))
    };
  const c = [], d = /* @__PURE__ */ new Set();
  if (a) {
    s && d.add(`job:${s.id}`);
    for (const u of t.slice(1))
      d.add(`job:${u.id}`), c.push({ kind: "job", at: u.createdAt, job: u });
  }
  for (const u of i) {
    const l = pn(u);
    l && (d.add(`conversation:${u.id}`), c.push({ kind: yn(u), at: l, conversation: u }));
  }
  if (e === "everything")
    for (const u of r)
      d.add(`reminder:${u.id}`), c.push({ kind: "reminder", at: u.dueAt ?? u.createdAt, reminder: u });
  for (const u of o) {
    const { entityType: l, entityId: m } = u;
    l && m && d.has(`${l}:${m}`) || c.push({ kind: "update", at: u.createdAt, notification: u });
  }
  return c.sort((u, l) => l.at.localeCompare(u.at)), { upNext: s, rows: c };
}
function go(n) {
  return n.endedAt ?? n.startedAt ?? n.scheduledStartAt ?? n.createdAt;
}
const wo = 8;
function Ps(n, e = {}) {
  const { jobs: t = [], invoices: i = [], payments: o = [], meetings: r = [], conversation: a } = n, s = e.limit ?? wo, c = [], d = (l) => {
    l != null && l.at && c.push({ row: l, seq: c.length });
  };
  for (const l of t)
    d({ kind: "job_created", at: l.createdAt, job: l }), l.completedAt && d({ kind: "job_completed", at: l.completedAt, job: l });
  for (const l of i)
    d({ kind: "invoice_created", at: l.createdAt, invoice: l });
  for (const l of o)
    d({ kind: "payment", at: l.paidAt, payment: l });
  for (const l of r)
    l.status !== "CANCELED" && d({ kind: "meeting_held", at: go(l), meeting: l });
  if (a) {
    const l = pn(a);
    l && d({ kind: yn(a), at: l, conversation: a });
  }
  c.sort((l, m) => m.row.at.localeCompare(l.row.at) || l.seq - m.seq);
  const u = c.map(({ row: l }) => l);
  return s >= 0 ? u.slice(0, s) : u;
}
function Ms(n, e) {
  const t = e.customerId ?? null, i = e.owner ?? { kind: "all" };
  return t === null && i.kind === "all" ? n : n.filter((o) => t !== null && o.customerId !== t ? !1 : i.kind === "unassigned" ? o.kind === "job" && !o.assignedUserId : i.kind === "user" ? o.kind === "job" && o.assignedUserId === i.userId : !0);
}
function Et(n) {
  return typeof n == "number" ? n : n.toNumber();
}
function ge(n) {
  return Math.round((n + Number.EPSILON) * 100) / 100;
}
function tt(n, e) {
  const t = ge(typeof n == "number" ? n : n.toNumber()), i = e.filter((d) => d.status === "COMPLETED"), o = ge(
    i.filter((d) => d.kind === "PAYMENT").reduce((d, u) => d + Et(u.amount), 0)
  ), r = ge(
    i.filter((d) => d.kind === "REFUND" || d.kind === "VOID_ADJUSTMENT").reduce((d, u) => d + Et(u.amount), 0)
  ), a = ge(o - r), s = ge(Math.max(0, t - a)), c = s === 0 && a > 0 && t > 0;
  return { paidAmount: o, refundedAmount: r, netPaid: a, balanceDue: s, isFullyPaid: c };
}
const Cs = /* @__PURE__ */ new Set([
  "SENDING",
  "SENT",
  "OVERDUE",
  "PAID_PARTIAL"
]);
async function vo(n, e) {
  const t = await n.invoiceTemplate.findUnique({
    where: { accountId: e },
    select: { id: !0 }
  });
  if (t) return t;
  const i = await n.account.findUniqueOrThrow({
    where: { id: e },
    select: {
      logoUrl: !0,
      invoiceFooterText: !0,
      brandPrimaryColor: !0,
      brandAccentColor: !0
    }
  });
  return n.invoiceTemplate.create({
    data: {
      accountId: e,
      logoUrl: i.logoUrl,
      footerText: i.invoiceFooterText,
      brandPrimaryColor: i.brandPrimaryColor,
      brandAccentColor: i.brandAccentColor,
      overdueAfterDays: 30
    },
    select: { id: !0 }
  });
}
function bo(n, e) {
  try {
    return ht(n, e || "UTC");
  } catch {
    return ht(n, "UTC");
  }
}
async function No(n, e) {
  const t = await vo(n, e.accountId), i = await n.invoiceTemplate.findUniqueOrThrow({
    where: { id: t.id },
    select: {
      id: !0,
      defaultMemo: !0,
      overdueAfterDays: !0,
      lineItems: {
        orderBy: { sortOrder: "asc" },
        select: {
          type: !0,
          name: !0,
          description: !0,
          quantity: !0,
          unitPrice: !0,
          taxable: !0
        }
      }
    }
  }), o = e.sentAt ?? /* @__PURE__ */ new Date(), r = bo(o, e.timeZone), a = ft(r), s = Fn(r, i.overdueAfterDays), c = e.dueDate ? jn(e.dueDate) : s;
  if (!c) throw new RangeError("Expected a valid due calendar date");
  const d = ft(c), u = Jn(e.dueTimezone, e.timeZone), l = Ln(c, u), m = e.lineItems && e.lineItems.length > 0 ? e.lineItems.map((f) => ({
    type: f.type,
    name: f.name,
    description: f.description ?? null,
    quantity: f.quantity ?? 1,
    unitPrice: f.unitPrice,
    taxable: f.taxable ?? !1
  })) : i.lineItems.map((f) => ({
    type: f.type,
    name: f.name,
    description: f.description,
    quantity: f.quantity.toNumber(),
    unitPrice: f.unitPrice.toNumber(),
    taxable: f.taxable
  }));
  return {
    templateId: i.id,
    invoiceDate: a,
    dueDate: d,
    dueTimezone: u,
    overdueAt: l,
    memo: e.memo ?? i.defaultMemo ?? null,
    footerOverride: e.footerOverride ?? null,
    items: m
  };
}
const To = {
  JOB_QUEUED: "Added a job to your queue",
  CALL_HANDLED: "Handled an inbound call",
  SMS_REPLIED: "Replied to a customer text",
  INVOICE_BUILT: "Built an invoice for review",
  PAYMENT_LINK_SENT: "Sent a payment link",
  PAYMENT_RECEIVED: "Collected a payment"
};
async function In(n, e) {
  const t = await n.accountActivity.create({
    data: {
      accountId: e.accountId,
      type: e.type,
      title: e.title ?? To[e.type],
      text: e.text ?? "",
      customerName: e.customerName ?? null,
      refType: e.refType ?? null,
      refId: e.refId ?? null
    },
    select: { id: !0 }
  });
  await n.outbox.create({
    data: {
      aggregateType: "account",
      aggregateId: e.accountId,
      eventType: "activity.summarize",
      payload: { accountId: e.accountId, activityId: t.id },
      idempotencyKey: `activity.summarize:${t.id}`,
      accountId: e.accountId,
      // Below SMS (10) and invoices (20) — the recap is cosmetic and must never
      // delay customer-facing work.
      priority: 30
    }
  });
}
const Ao = 6e4;
async function So(n, e) {
  if (e.stripePaymentIntentId) {
    if (await n.invoicePayment.findFirst({
      where: {
        invoiceId: e.invoiceId,
        stripePaymentIntentId: e.stripePaymentIntentId
      },
      select: { id: !0 }
    })) return null;
  } else if (e.kind === "PAYMENT" && await n.invoicePayment.findFirst({
    where: {
      invoiceId: e.invoiceId,
      kind: "PAYMENT",
      method: e.method,
      amount: e.amount,
      createdAt: { gte: new Date(Date.now() - Ao) }
    },
    select: { id: !0 }
  }))
    return null;
  const t = await n.invoicePayment.create({
    data: {
      invoiceId: e.invoiceId,
      accountId: e.accountId,
      kind: e.kind,
      method: e.method,
      status: "COMPLETED",
      amount: e.amount,
      paidAt: e.paidAt ?? /* @__PURE__ */ new Date(),
      stripePaymentIntentId: e.stripePaymentIntentId ?? null
    },
    select: { id: !0 }
  });
  e.kind === "PAYMENT" && await n.platformFee.upsert({
    where: { invoiceId: e.invoiceId },
    create: {
      invoiceId: e.invoiceId,
      chargeId: e.chargeId ?? e.stripePaymentIntentId ?? null,
      rakeAmount: e.rakeAmount,
      laborSubtotal: e.laborSubtotal,
      serviceSubtotal: e.serviceSubtotal,
      materialSubtotal: e.materialSubtotal,
      accountId: e.accountId
    },
    update: {}
  });
  const i = await n.invoicePayment.findMany({
    where: { invoiceId: e.invoiceId },
    select: { kind: !0, status: !0, amount: !0 }
  }), r = tt(e.invoiceTotal, i).isFullyPaid, a = e.kind === "PAYMENT" && !r;
  return r && e.customerId && await no(n, e.customerId, e.invoiceTotal), e.kind === "PAYMENT" && (await n.accountActivity.findFirst({
    where: {
      accountId: e.accountId,
      type: "PAYMENT_RECEIVED",
      refId: e.invoiceId
    },
    select: { id: !0 }
  }) || await In(n, {
    accountId: e.accountId,
    type: "PAYMENT_RECEIVED",
    text: `${D(e.invoiceNumber)} · $${e.invoiceTotal.toFixed(2)}`,
    customerName: e.customerName,
    refType: "invoice",
    refId: e.invoiceId
  })), { paymentId: t.id, isFullyPaid: r, isPartial: a };
}
const Eo = [
  "invoice.created",
  "sms.reply",
  "invoice.delivery_watchdog"
];
async function ko(n, e, t, i) {
  return (await n.outbox.updateMany({
    where: {
      eventType: { in: [...Eo] },
      status: { in: ["PENDING", "RETRY"] },
      AND: [
        { payload: { path: ["invoiceId"], equals: e } },
        { payload: { path: ["deliveryAttemptId"], equals: t } }
      ]
    },
    data: {
      status: "DEAD",
      lastError: i,
      processedAt: /* @__PURE__ */ new Date(),
      lockedAt: null,
      lockedUntil: null,
      lockedBy: null
    }
  })).count;
}
async function at(n, e) {
  const {
    accountId: t,
    customerId: i,
    jobId: o,
    formTemplateId: r,
    description: a,
    expiresAt: s,
    prefill: c,
    customPrefill: d,
    extraContext: u
  } = e, l = (a == null ? void 0 : a.trim()) ?? "", m = wn(c), f = {
    ...u ?? {},
    ...l ? { description: l } : {},
    ...m ? { prefill: m } : {},
    ...d && d.length ? { customPrefill: d } : {}
  };
  return n.bookingToken.create({
    data: {
      accountId: t,
      customerId: i,
      jobId: o ?? null,
      formTemplateId: r ?? null,
      context: f,
      expiresAt: s ?? new Date(Date.now() + 2880 * 60 * 1e3)
    },
    select: { token: !0 }
  });
}
async function gn(n, e, t) {
  const { context: i, prefill: o, customPrefill: r } = t, a = i && typeof i == "object" ? { ...i } : {}, s = wn(o);
  s ? a.prefill = s : delete a.prefill, r && r.length ? a.customPrefill = r : delete a.customPrefill, await n.bookingToken.update({
    where: { token: e },
    data: { context: a }
  });
}
function wn(n) {
  if (!n) return null;
  const e = Object.entries(n).map(([t, i]) => [t, typeof i == "string" ? i.trim() : i]).filter(([, t]) => typeof t == "string" && t.length > 0);
  return e.length > 0 ? Object.fromEntries(e) : null;
}
function Rs(n) {
  var e, t;
  return !!(!n || !n.intakeComplete || n.name === n.phone || n.name.startsWith("+") || !((e = n.street) != null && e.trim()) || !((t = n.city) != null && t.trim()));
}
function Us(n, e) {
  const t = n.trim();
  if (!t || t === e || t.startsWith("+"))
    return { firstName: "", lastName: "" };
  const i = t.split(/\s+/);
  return {
    firstName: i[0] ?? "",
    lastName: i.slice(1).join(" ")
  };
}
function Fs(n, e) {
  if (e === "WEEKLY")
    return new Date(n.getTime() + 10080 * 60 * 1e3);
  const t = new Date(n), i = t.getUTCDate();
  return t.setUTCMonth(t.getUTCMonth() + 1), t.getUTCDate() < i && t.setUTCDate(0), t;
}
const js = ["MONTHLY", "ANNUAL"], qe = 10, ct = 12;
function Fe(n) {
  return Math.round(n * 100) / 100;
}
function Oo(n) {
  const e = new Date(n), t = e.getUTCDate();
  return e.setUTCFullYear(e.getUTCFullYear() + 1), e.getUTCDate() < t && e.setUTCDate(0), e;
}
function ut(n, e) {
  const t = Number.isFinite(e) ? Math.min(100, Math.max(0, e)) : 0;
  return Fe(n * ct * (1 - t / 100));
}
function _o(n, e) {
  return Fe(n * ct - ut(n, e));
}
function $o(n, e) {
  return Fe(ut(n, e) / ct);
}
function Do(n) {
  const e = new Date(n), t = e.getUTCDate();
  return e.setUTCFullYear(e.getUTCFullYear() - 1), e.getUTCDate() < t && e.setUTCDate(0), e;
}
function Js(n) {
  const { annualFeeUsd: e, prepaidThrough: t, asOf: i } = n;
  if (t == null || !Number.isFinite(e) || e <= 0) return 0;
  const o = Do(t).getTime(), r = t.getTime() - o;
  if (r <= 0) return 0;
  const a = t.getTime() - i.getTime(), s = Math.min(1, Math.max(0, a / r));
  return Fe(Math.min(e, Math.max(0, e * s)));
}
function Ls(n) {
  const { interval: e, accountSubscriptionFeeUsd: t, prepaidThrough: i, cycleEnd: o, isBeta: r } = n;
  return r ? { subscriptionFeeUsd: 0, advancePrepaidThroughTo: null } : e !== "ANNUAL" ? { subscriptionFeeUsd: t, advancePrepaidThroughTo: null } : i != null && o.getTime() < i.getTime() ? { subscriptionFeeUsd: 0, advancePrepaidThroughTo: null } : {
    subscriptionFeeUsd: t,
    advancePrepaidThroughTo: Oo(i ?? o)
  };
}
const F = (n) => Math.round(n * 100) / 100, Po = (n, e) => n.startsAt <= e && (n.endsAt === null || n.endsAt > e);
function Bs(n) {
  const e = n.discounts.filter((s) => Po(s, n.asOf)), t = F(n.subscriptionAmount), i = F(n.perInvoiceFee * Math.max(0, n.invoiceCount));
  let o = t, r = i;
  const a = [];
  for (const s of e) {
    if (s.percent <= 0) continue;
    const c = Math.min(100, Math.max(0, s.percent)) / 100, d = s.appliesTo.includes("subscription") ? F(o * c) : 0, u = s.appliesTo.includes("per_invoice") ? F(r * c) : 0;
    o = F(o - d), r = F(r - u), (d > 0 || u > 0) && a.push({ discountType: "percent", subscriptionDelta: d, perInvoiceDelta: u });
  }
  for (const s of e) {
    if (s.amount <= 0) continue;
    const c = s.appliesTo.includes("subscription") ? Math.min(o, F(s.amount)) : 0, d = s.appliesTo.includes("per_invoice") ? Math.min(r, F(s.amount)) : 0;
    o = F(o - c), r = F(r - d), (c > 0 || d > 0) && a.push({ discountType: "fixed", subscriptionDelta: c, perInvoiceDelta: d });
  }
  return o < 0 && (o = 0), r < 0 && (r = 0), {
    subscriptionBase: t,
    subscriptionDiscount: F(t - o),
    subscriptionFinal: o,
    perInvoiceBase: i,
    perInvoiceDiscount: F(i - r),
    perInvoiceFinal: r,
    total: F(o + r),
    appliedDiscounts: a
  };
}
const vn = ["GROWTH", "PRO", "MAX"];
function qs(n) {
  return vn.indexOf(n);
}
function Ys(n, e) {
  return e;
}
const Mo = [
  "draft_invoice",
  "create_invoice",
  "write_invoice",
  "get_queue",
  "summarize_today",
  "list_pending_invoices",
  "message_customer",
  "create_reminder"
], dt = 5;
function Hs(n, e) {
  return n != null && n > 0 ? n : e != null && e > 0 ? e : dt;
}
function Vs(n) {
  return new Date(Date.UTC(n.getUTCFullYear(), n.getUTCMonth(), 1));
}
function Co(n) {
  return `${n.getUTCFullYear()}-${String(n.getUTCMonth() + 1).padStart(2, "0")}`;
}
const Ro = {
  all_voices: {
    key: "all_voices",
    label: "Full voice library",
    description: "Every TTS voice, including ElevenLabs, in the voice picker."
  },
  birthday_texts: {
    key: "birthday_texts",
    label: "Birthday texts",
    description: "Automatic birthday messages to opted-in customers."
  },
  review_followups: {
    key: "review_followups",
    label: "Review follow-ups",
    description: "Google/Facebook/Yelp review requests after a job completes."
  },
  customer_subscriptions: {
    key: "customer_subscriptions",
    label: "Customer subscriptions",
    description: "Recurring customer plans with member perks (Stripe Connect)."
  },
  concierge_coverage: {
    key: "concierge_coverage",
    label: "Concierge coverage",
    description: "Weekly schedule of when the Ten Four concierge covers escalated calls, plus a backup contact (config only for now)."
  },
  custom_forms: {
    key: "custom_forms",
    label: "Custom forms",
    description: "Create and publish additional forms beyond the booking form, with public links and response collection."
  }
}, Uo = Object.keys(Ro);
function Ce(n) {
  return n != null && n > 0;
}
function Ws(n, e) {
  const t = e.includedVoiceMinutesOverride, i = e.includedSmsMessagesOverride;
  return t == null && i == null ? n : {
    ...n,
    includedVoiceMinutes: t ?? n.includedVoiceMinutes,
    includedSmsMessages: i ?? n.includedSmsMessages
  };
}
function Ks(n, e, t) {
  return e != null && e > 0 ? e : n.source === "custom" ? n.llmBudgetUsd : n.tier === "GROWTH" ? t != null && t > 0 ? t : dt : n.llmBudgetUsd;
}
const ue = {
  GROWTH: {
    tier: "GROWTH",
    monthlyFeeUsd: 0,
    annualDiscountPercent: qe,
    features: {
      all_voices: !1,
      birthday_texts: !1,
      review_followups: !1,
      customer_subscriptions: !1,
      concierge_coverage: !1,
      custom_forms: !1
    },
    includedVoiceMinutes: null,
    includedSmsMessages: null,
    llmBudgetUsd: dt,
    voiceOverageRatePerHourUsd: null,
    smsOverageRatePer100Usd: null,
    maxGroupChats: 1,
    monthlyAiMeetings: 5,
    source: "bundled"
  },
  PRO: {
    tier: "PRO",
    monthlyFeeUsd: 99,
    annualDiscountPercent: qe,
    features: {
      all_voices: !0,
      birthday_texts: !1,
      review_followups: !1,
      customer_subscriptions: !1,
      concierge_coverage: !1,
      custom_forms: !0
    },
    includedVoiceMinutes: null,
    includedSmsMessages: null,
    llmBudgetUsd: null,
    voiceOverageRatePerHourUsd: null,
    smsOverageRatePer100Usd: null,
    maxGroupChats: null,
    monthlyAiMeetings: null,
    source: "bundled"
  },
  MAX: {
    tier: "MAX",
    monthlyFeeUsd: 199,
    annualDiscountPercent: qe,
    features: {
      all_voices: !0,
      birthday_texts: !0,
      review_followups: !0,
      customer_subscriptions: !0,
      concierge_coverage: !0,
      custom_forms: !0
    },
    includedVoiceMinutes: null,
    includedSmsMessages: null,
    llmBudgetUsd: null,
    voiceOverageRatePerHourUsd: null,
    smsOverageRatePer100Usd: null,
    maxGroupChats: null,
    monthlyAiMeetings: null,
    source: "bundled"
  }
};
function Fo(n) {
  const e = Number(n);
  return Number.isFinite(e) ? e : 0;
}
function ke(n) {
  if (n == null) return null;
  const e = Number(n);
  return Number.isFinite(e) ? e : null;
}
function jo(n, e) {
  const t = { ...n };
  if (e != null && typeof e == "object" && !Array.isArray(e))
    for (const i of Uo) {
      const o = e[i];
      typeof o == "boolean" && (t[i] = o);
    }
  return t;
}
function zs(n) {
  const e = { ...ue };
  for (const t of n) {
    const i = t.tier, o = ue[i];
    o && (e[i] = {
      tier: i,
      monthlyFeeUsd: Fo(t.monthlyFeeUsd),
      // A missing/garbage column falls back to the bundled discount rather than
      // to 0 — a row saved before the annual migration must not silently start
      // charging annual customers full price.
      annualDiscountPercent: ke(t.annualDiscountPercent ?? null) ?? o.annualDiscountPercent,
      features: jo(o.features, t.features),
      includedVoiceMinutes: t.includedVoiceMinutes,
      includedSmsMessages: t.includedSmsMessages,
      llmBudgetUsd: ke(t.llmBudgetUsd ?? null),
      voiceOverageRatePerHourUsd: ke(t.voiceOverageRatePerHourUsd),
      smsOverageRatePer100Usd: ke(t.smsOverageRatePer100Usd),
      // Like includedVoiceMinutes: the row's value verbatim — a custom row's
      // null is an explicit "unlimited", never a fall-through to bundled.
      maxGroupChats: t.maxGroupChats,
      monthlyAiMeetings: t.monthlyAiMeetings,
      source: "custom"
    });
  }
  return e;
}
function Jo(n, e, t) {
  var i;
  return ((i = n[e]) == null ? void 0 : i.features[t]) === !0;
}
function je(n, e) {
  var t;
  return ((t = n[e]) == null ? void 0 : t.monthlyFeeUsd) ?? ue[e].monthlyFeeUsd;
}
function lt(n, e) {
  var t;
  return ((t = n[e]) == null ? void 0 : t.annualDiscountPercent) ?? ue[e].annualDiscountPercent;
}
function Lo(n, e) {
  return ut(
    je(n, e),
    lt(n, e)
  );
}
function Gs(n, e) {
  return _o(
    je(n, e),
    lt(n, e)
  );
}
function Qs(n, e) {
  return $o(
    je(n, e),
    lt(n, e)
  );
}
function Zs(n, e, t) {
  return t === "ANNUAL" ? Lo(n, e) : je(n, e);
}
function Xs(n, e) {
  return (n[e] ?? ue[e]).maxGroupChats;
}
function xs(n, e) {
  return (n[e] ?? ue[e]).monthlyAiMeetings;
}
function ea(n, e) {
  return vn.filter((t) => Jo(n, t, e));
}
function ta(n, e, t) {
  return {
    voice: {
      usedMinutes: e,
      includedMinutes: n.includedVoiceMinutes,
      overageRatePerHourUsd: n.voiceOverageRatePerHourUsd,
      exhausted: n.includedVoiceMinutes != null && e >= n.includedVoiceMinutes
    },
    sms: {
      usedMessages: t,
      includedMessages: n.includedSmsMessages,
      overageRatePer100Usd: n.smsOverageRatePer100Usd,
      exhausted: n.includedSmsMessages != null && t >= n.includedSmsMessages
    }
  };
}
function na(n) {
  return n.voice.exhausted && !Ce(n.voice.overageRatePerHourUsd) || n.sms.exhausted && !Ce(n.sms.overageRatePer100Usd);
}
function kt(n) {
  return Math.round(n * 100) / 100;
}
function oa(n, e, t) {
  const i = n.includedVoiceMinutes != null ? Math.max(0, e - n.includedVoiceMinutes) : 0, o = Ce(n.voiceOverageRatePerHourUsd), r = o ? Math.ceil(i / 60) : 0, a = o ? kt(r * n.voiceOverageRatePerHourUsd) : 0, s = n.includedSmsMessages != null ? Math.max(0, t - n.includedSmsMessages) : 0, c = Ce(n.smsOverageRatePer100Usd), d = c ? Math.ceil(s / 100) : 0, u = c ? kt(d * n.smsOverageRatePer100Usd) : 0;
  return {
    voiceOverageMinutes: i,
    voiceOverageHours: r,
    voiceOverageUsd: a,
    smsOverageCount: s,
    smsOverageBlocks: d,
    smsOverageUsd: u
  };
}
function ra(n) {
  const t = ["GROWTH", "PRO", "MAX"].map((i) => n[i]).filter((i) => !!i).map((i) => {
    const o = Bn[i.tier], r = Bo(i.monthlyFeeUsd), a = i.annualDiscountPercent > 0 ? ` Paying yearly saves ${i.annualDiscountPercent}%.` : "", s = i.monthlyFeeUsd <= 0 ? " No card required." : "";
    return `- ${o} — ${r}.${s}${a}`;
  });
  return t.length === 0 ? "" : [
    "# Current plans and prices",
    "These are read live from Ten Four's plan catalog. Quote them exactly, and",
    "never quote a price that is not on this list.",
    "",
    ...t,
    "",
    "Ten Four Concierge is a separate, human-staffed service line — it is not",
    "one of these plans and is not sold here. If they want it, point them at",
    "the site to talk to us."
  ].join(`
`);
}
function Bo(n) {
  if (n <= 0) return "$0/month";
  const e = Math.round(n * 100) / 100;
  return `$${Number.isInteger(e) ? String(e) : e.toFixed(2)}/month`;
}
const Ot = 5;
async function ia(n, e) {
  const t = Co(e.now ?? /* @__PURE__ */ new Date());
  if (await n.findUnique({
    where: { meetingId: e.meetingId },
    select: { id: !0 }
  })) return { granted: !0, monthKey: t };
  for (let o = 0; o < Ot; o++) {
    const r = await n.count({ where: { accountId: e.accountId, monthKey: t } });
    if (e.limit !== null && r >= e.limit) return { granted: !1, monthKey: t };
    try {
      return await n.create({
        data: {
          accountId: e.accountId,
          monthKey: t,
          slot: r,
          meetingId: e.meetingId
        }
      }), { granted: !0, monthKey: t };
    } catch (a) {
      if (!qo(a)) throw a;
      if (await n.findUnique({
        where: { meetingId: e.meetingId },
        select: { id: !0 }
      })) return { granted: !0, monthKey: t };
    }
  }
  throw new Error(
    `meeting AI quota claim for ${e.meetingId} did not converge after ${Ot} attempts`
  );
}
function qo(n) {
  return (n == null ? void 0 : n.code) === "P2002";
}
function bn(n) {
  const e = n.replace(/\D/g, "");
  return e.startsWith("1") && e.length > 10 ? e.slice(1) : e;
}
function sa(n) {
  const e = bn(n).slice(0, 10);
  return e.length === 0 ? "" : e.length <= 3 ? `(${e}` : e.length <= 6 ? `(${e.slice(0, 3)}) ${e.slice(3)}` : `(${e.slice(0, 3)}) ${e.slice(3, 6)}-${e.slice(6)}`;
}
function aa(n) {
  return bn(n).length === 10;
}
function Nn(n) {
  const e = n.replace(/\D/g, "");
  if (e.length === 10)
    return `+1${e}`;
  if (e.length === 11 && e.startsWith("1"))
    return `+${e}`;
  throw new Error(`Cannot normalize phone number: "${n}"`);
}
function Re(n, e) {
  if (!n || !e) return !1;
  if (n === e) return !0;
  const t = _t(n), i = _t(e);
  return t !== null && i !== null && t === i;
}
function _t(n) {
  try {
    return Nn(n);
  } catch {
    return null;
  }
}
function ca(n) {
  const e = [n.city, n.state].filter(Boolean).join(", ");
  return [n.street, e, n.zip].filter((i) => i && String(i).trim()).join(" ").trim() || null;
}
function ua(n, e = {}) {
  return !(n.participantType === "CONTRACTOR" || Re(n.customerPhone, e.tenFourPhone) || Re(n.customerPhone, e.ownerPhone));
}
function da(n, e) {
  var t;
  if (!n)
    return (t = e[0]) == null ? void 0 : t.id;
}
function la(n) {
  return [...n].sort(
    (e, t) => new Date(t.createdAt).getTime() - new Date(e.createdAt).getTime()
  );
}
function ma(n, e) {
  if (!(!n || e.length === 0)) {
    if (n.customerId) {
      const t = e.find((i) => i.customerId === n.customerId);
      if (t) return t;
    }
    if (n.customerPhone)
      return e.find((t) => Re(t.customerPhone, n.customerPhone));
  }
}
function Je(n) {
  switch (n) {
    case "DONE":
      return "Done";
    case "CANCELED":
      return "Canceled";
    case "ACTIVE":
    default:
      return "Active";
  }
}
function Tn(n) {
  switch (n) {
    case "DRAFT":
      return "Draft — needs your approval";
    case "SENDING":
      return "On its way — awaiting carrier delivery";
    case "QUOTE":
      return "Quote";
    case "SENT":
      return "Sent — awaiting payment";
    case "PAID_PARTIAL":
      return "Partially paid";
    case "PAID":
      return "Paid";
    case "OVERDUE":
      return "Overdue";
    case "CANCELED":
      return "Canceled";
    default:
      return "Open";
  }
}
function Le(n) {
  var t, i;
  const e = {
    customer: n.customerName,
    description: ((t = n.description) == null ? void 0 : t.trim()) || "",
    stage: Je(n.status)
  };
  if ((i = n.customerAddress) != null && i.trim() && (e.address = n.customerAddress.trim()), n.urgency && n.urgency !== "NORMAL" && (e.urgency = n.urgency.toLowerCase()), n.createdAt) {
    const o = n.createdAt instanceof Date ? n.createdAt : new Date(n.createdAt);
    Number.isNaN(o.getTime()) || (e.queuedAt = o.toISOString());
  }
  return e;
}
function Yo(n) {
  var i;
  const e = typeof ((i = n.total) == null ? void 0 : i.toNumber) == "function" ? n.total.toNumber().toFixed(2) : String(n.total), t = {
    invoiceNumber: n.invoiceNumber,
    customer: n.customerName,
    total: e,
    stage: Tn(n.status)
  };
  if (n.createdAt) {
    const o = n.createdAt instanceof Date ? n.createdAt : new Date(n.createdAt);
    Number.isNaN(o.getTime()) || (t.createdAt = o.toISOString());
  }
  return t;
}
function ae(n, e) {
  var t, i;
  (i = n.recordReference) == null || i.call(n, {
    kind: "customer",
    id: e.id,
    title: ((t = e.name) == null ? void 0 : t.trim()) || "Customer",
    subtitle: "Customer"
  });
}
function me(n, e) {
  var o, r, a;
  const t = (o = e.customerName) == null ? void 0 : o.trim(), i = (r = e.description) == null ? void 0 : r.trim();
  (a = n.recordReference) == null || a.call(n, {
    kind: "job",
    id: e.id,
    title: i || (t ? `Job for ${t}` : "Job"),
    subtitle: [t, e.status ? Je(e.status) : null].filter(Boolean).join(" · ") || "Job"
  });
}
function ee(n, e) {
  var i, o;
  const t = e.isQuote ?? e.status === "QUOTE";
  (o = n.recordReference) == null || o.call(n, {
    kind: "invoice",
    id: e.id,
    title: D(e.invoiceNumber, { quote: t }),
    subtitle: [
      (i = e.customerName) == null ? void 0 : i.trim(),
      e.status ? Tn(e.status) : null
    ].filter(Boolean).join(" · ") || (t ? "Quote" : "Invoice")
  });
}
function Ho(n, e) {
  var t, i;
  (i = n.recordReference) == null || i.call(n, {
    kind: "conversation",
    id: e.id,
    title: ((t = e.customerName) == null ? void 0 : t.trim()) || "Customer conversation",
    subtitle: "Message sent"
  });
}
function Vo(n) {
  if (!(n != null && n.trim())) return null;
  const e = n.replace(/\D/g, ""), t = e.startsWith("1") && e.length === 11 ? e.slice(1) : e;
  return t.length !== 10 ? n.trim() : `(${t.slice(0, 3)}) ${t.slice(3, 6)}-${t.slice(6)}`;
}
function Wo(n, e) {
  const t = n == null ? void 0 : n.trim();
  return t ? t.length <= e ? t : `${t.slice(0, e - 1)}…` : null;
}
function fa(n, e) {
  return `${n.replace(/\/$/, "")}/invoices/${e}`;
}
function ha(n) {
  var o, r, a;
  const e = ((o = n.customerName) == null ? void 0 : o.trim()) || "Unknown", t = [
    "Ten Four — invoice drafted",
    "",
    D(n.invoiceNumber),
    `Customer: ${e}`
  ], i = Vo(n.customerPhone);
  if (i && t.push(`Phone: ${i}`), t.push(`Total: $${n.total}`), t.push("Status: Draft — approve it to send to your customer"), n.lineItems.length > 0) {
    t.push("", "Line items:");
    for (const s of n.lineItems) {
      const c = s.quantity ?? 1, d = s.type ? `${s.type.charAt(0).toUpperCase()}${s.type.slice(1)}: ` : "";
      t.push(`- ${d}${s.name} (${c} × $${s.unitPrice} = $${s.total})`);
    }
  }
  if (n.job) {
    const s = Wo(n.job.description, 150), c = (r = n.job.address) == null ? void 0 : r.trim(), d = (a = n.job.stage) == null ? void 0 : a.trim();
    (s || c || d) && (t.push("", "Job:"), s && t.push(`Issue: ${s}`), c && t.push(`Location: ${c}`), d && t.push(`Stage: ${d}`));
  }
  return t.push("", "View invoice:", n.viewUrl), t.join(`
`);
}
function ya(n) {
  var t;
  const e = ((t = n.customerName) == null ? void 0 : t.trim()) || "Unknown";
  return [
    "Ten Four — invoice in review",
    "",
    D(n.invoiceNumber),
    `Customer: ${e}`,
    `Total: $${n.total}`,
    "",
    "We're reviewing it to make sure it's right. You'll get a text to approve it shortly."
  ].join(`
`);
}
function Oe(n, e) {
  let t = 3735928559 ^ e, i = 1103547991 ^ e;
  for (let o = 0; o < n.length; o++) {
    const r = n.charCodeAt(o);
    t = Math.imul(t ^ r, 2654435761), i = Math.imul(i ^ r, 1597334677);
  }
  return t = Math.imul(t ^ t >>> 16, 2246822507) ^ Math.imul(i ^ i >>> 13, 3266489909), (t >>> 0).toString(16).padStart(8, "0");
}
function Ko(n) {
  const e = `account-sms:${n}`, t = Oe(e, 1) + Oe(e, 2) + Oe(e, 3) + Oe(e, 4);
  return `${t.slice(0, 8)}-${t.slice(8, 12)}-${t.slice(12, 16)}-${t.slice(16, 20)}-${t.slice(20, 32)}`;
}
async function zo(n, e) {
  const t = `sms:${e.toPhone}`, i = await n.conversation.upsert({
    where: { accountId_threadKey: { accountId: e.accountId, threadKey: t } },
    create: {
      accountId: e.accountId,
      participantPhone: e.toPhone,
      participantType: "CONTRACTOR",
      type: "SMS",
      threadKey: t,
      state: "NEW",
      lastMessageAt: /* @__PURE__ */ new Date(),
      stateChangedAt: /* @__PURE__ */ new Date()
    },
    update: { lastMessageAt: /* @__PURE__ */ new Date() },
    select: { id: !0 }
  }), o = Ko(e.idempotencyKey);
  return await n.message.upsert({
    where: { id: o },
    create: {
      id: o,
      conversationId: i.id,
      accountId: e.accountId,
      direction: "OUTBOUND",
      senderType: "SYSTEM",
      fromNumber: e.fromPhone,
      toNumber: e.toPhone,
      body: e.body,
      status: "processing"
    },
    update: {}
  }), await n.outbox.upsert({
    where: { idempotencyKey: e.idempotencyKey },
    create: {
      aggregateType: "message",
      aggregateId: o,
      eventType: "sms.reply",
      // messageId ties the send to the tracked Message (handler sends un-gated +
      // stamps the sid). recipientType lets the admin feed tag the audience.
      payload: {
        to: e.toPhone,
        from: e.fromPhone,
        body: e.body,
        accountId: e.accountId,
        recipientType: "account",
        messageId: o
      },
      idempotencyKey: e.idempotencyKey,
      accountId: e.accountId,
      priority: e.priority ?? 15
    },
    update: {}
  }), { messageId: o };
}
const Go = 5, Qo = 500, Zo = "Ten Four — invoice";
function pa(n, e) {
  var c;
  const t = (e == null ? void 0 : e.maxMessages) ?? Go, i = (e == null ? void 0 : e.maxChars) ?? Qo, o = [];
  for (let d = n.length - 1; d >= 0; d--) {
    const u = n[d];
    if (u.direction === "OUTBOUND" && ((c = u.body) != null && c.startsWith(Zo))) break;
    o.unshift(u);
  }
  const r = o.filter((d) => d.direction === "INBOUND").map((d) => {
    var u;
    return (u = d.body) == null ? void 0 : u.trim();
  }).filter((d) => !!d);
  if (r.length === 0) return;
  const a = r.slice(-t).join(" · ");
  if (a.length <= i) return a;
  const s = "… ";
  return s + a.slice(a.length - (i - s.length));
}
const Xo = "sms-tool:get-queue";
async function xo(n, e, t, i = {}) {
  var c, d;
  const o = typeof e.limit == "number" && e.limit > 0 ? Math.min(e.limit, 100) : 25, r = {
    accountId: t.accountId
  };
  t.userId && (r.OR = [{ assignedUserId: t.userId }, { assignedUserId: null }]), e.status ? r.status = e.status : r.status = { in: [...le] };
  const a = await n.job.findMany({
    where: r,
    orderBy: { createdAt: "asc" },
    take: o,
    select: {
      id: !0,
      customerName: !0,
      customerAddress: !0,
      description: !0,
      status: !0,
      urgency: !0,
      createdAt: !0
    }
  });
  if ((d = (c = i.logger) == null ? void 0 : c.log) == null || d.call(c, Xo, "get_queue", { status: e.status ?? "active", limit: o, found: a.length }), a.length === 0)
    return JSON.stringify({ jobs: [], message: "Your queue is empty." });
  const s = a.map((u) => Le(u));
  for (const u of a) me(i, u);
  return JSON.stringify({ jobs: s });
}
async function er(n, e, t, i = {}) {
  var a, s;
  const o = await n.customer.findMany({
    where: {
      accountId: t.accountId,
      name: { contains: e.name, mode: "insensitive" }
    },
    orderBy: { lastSeenAt: "desc" },
    take: 5,
    select: { id: !0, name: !0, phone: !0, address: !0, totalJobs: !0 }
  });
  if ((s = (a = i.logger) == null ? void 0 : a.log) == null || s.call(a, "sms-tool:lookup-customer", "lookup_customer", {
    query: e.name,
    found: o.length
  }), o.length === 0)
    return JSON.stringify({ customers: [], message: `No customers found matching "${e.name}"` });
  for (const c of o) ae(i, c);
  const r = await Promise.all(
    o.map(async (c) => {
      const d = await n.job.findMany({
        where: {
          accountId: t.accountId,
          customerId: c.id,
          status: { in: [...le] }
        },
        orderBy: { createdAt: "desc" },
        take: 5,
        select: {
          customerName: !0,
          description: !0,
          customerAddress: !0,
          status: !0,
          createdAt: !0,
          urgency: !0
        }
      }), u = await n.job.findMany({
        where: { accountId: t.accountId, customerId: c.id, status: { not: "CANCELED" } },
        orderBy: { createdAt: "desc" },
        take: 5,
        select: {
          description: !0,
          status: !0,
          createdAt: !0,
          invoice: { select: { invoiceNumber: !0, status: !0 } }
        }
      }), l = await n.invoice.findMany({
        where: {
          accountId: t.accountId,
          customerId: c.id,
          status: { in: ["SENT", "OVERDUE", "PAID_PARTIAL"] }
        },
        orderBy: { createdAt: "desc" },
        take: 5,
        select: { invoiceNumber: !0, total: !0, status: !0 }
      });
      return {
        name: c.name,
        phone: c.phone,
        address: c.address,
        totalJobs: c.totalJobs,
        activeJobs: d.map((m) => Le(m)),
        recentJobs: u.map((m) => {
          var f;
          return {
            description: ((f = m.description) == null ? void 0 : f.trim()) || "",
            stage: Je(m.status),
            invoiced: !!m.invoice && m.invoice.status !== "CANCELED",
            ...m.invoice && m.invoice.status !== "CANCELED" ? { invoiceNumber: m.invoice.invoiceNumber } : {},
            ...m.createdAt ? { queuedAt: m.createdAt.toISOString() } : {}
          };
        }),
        billing: "Job status never blocks billing (a Done job is the normal one to bill). Each job holds at most one invoice; if every job here is already invoiced, ask before starting new work.",
        openInvoices: l.map((m) => ({
          invoiceNumber: m.invoiceNumber,
          total: Number(m.total),
          status: m.status
        }))
      };
    })
  );
  return JSON.stringify({ customers: r });
}
const tr = "sms-tool:create-customer";
async function nr(n, e, t, i = {}) {
  var w, b, g, S, A, E, k;
  const o = (e.name ?? "").trim();
  if (!o) return JSON.stringify({ error: "A name is required to create a customer." });
  const r = (e.phone ?? "").trim();
  if (!r)
    return JSON.stringify({ error: "A phone number is required — it is how the invoice reaches the customer." });
  let a;
  try {
    a = Nn(r);
  } catch {
    return JSON.stringify({ error: `"${r}" is not a valid US phone number.` });
  }
  const s = await n.customer.findFirst({
    where: { accountId: t.accountId, OR: [{ phone: a }, { identityId: a }] },
    select: { id: !0, name: !0 }
  });
  if (s)
    return ae(i, s), JSON.stringify({
      success: !0,
      existing: !0,
      customerId: s.id,
      name: s.name,
      message: `${s.name} is already a customer.`
    });
  const c = ((w = e.street) == null ? void 0 : w.trim()) || null, d = ((b = e.city) == null ? void 0 : b.trim()) || null, u = ((g = e.state) == null ? void 0 : g.trim()) || null, l = ((S = e.zip) == null ? void 0 : S.trim()) || null, m = [c, d, u, l].filter(Boolean).join(", ") || null, h = (await n.account.update({
    where: { id: t.accountId },
    data: { nextCustomerNumber: { increment: 1 } },
    select: { nextCustomerNumber: !0 }
  })).nextCustomerNumber - 1;
  let I;
  try {
    I = await n.customer.create({
      data: {
        accountId: t.accountId,
        customerNumber: h,
        name: o,
        phone: a,
        identityId: a,
        email: ((A = e.email) == null ? void 0 : A.trim()) || null,
        street: c,
        city: d,
        state: u,
        zip: l,
        address: m,
        contactStatus: "CUSTOMER",
        // Intake is complete only when the contractor supplied a real service
        // address — a bare name+phone driveway customer still needs intake, so
        // the booking form (customerNeedsBookingIntake) should re-prompt them.
        intakeComplete: !!(c && d)
        // No SMS consent — creating a record is NOT opt-in (TCPA). Consent is
        // collected explicitly (booking form / keyword), never implied here.
      },
      select: { id: !0, name: !0 }
    });
  } catch (O) {
    if ((O == null ? void 0 : O.code) === "P2002") {
      const N = await n.customer.findFirst({
        where: { accountId: t.accountId, OR: [{ phone: a }, { identityId: a }] },
        select: { id: !0, name: !0 }
      });
      if (N)
        return ae(i, N), JSON.stringify({
          success: !0,
          existing: !0,
          customerId: N.id,
          name: N.name,
          message: `${N.name} is already a customer.`
        });
    }
    throw O;
  }
  return (k = (E = i.logger) == null ? void 0 : E.log) == null || k.call(E, tr, "customer created", { accountId: t.accountId, customerId: I.id }), ae(i, I), JSON.stringify({ success: !0, customerId: I.id, name: I.name });
}
const or = "sms-tool:create-job", $t = ["REPAIR", "INSTALL", "MAINTENANCE", "INSPECTION", "QUOTE", "OTHER"], Dt = ["LOW", "MEDIUM", "HIGH", "EMERGENCY"];
async function rr(n, e, t, i = {}) {
  var c, d, u, l, m, f;
  if (!e.customerId && !((c = e.customerName) != null && c.trim()))
    return JSON.stringify({ error: "A job needs a customer. Provide the customer id or name (create the customer first)." });
  let o = null;
  if (e.customerId)
    o = await n.customer.findFirst({
      where: { id: e.customerId, accountId: t.accountId },
      select: { id: !0, name: !0, phone: !0, address: !0 }
    });
  else if ((d = e.customerName) != null && d.trim()) {
    const h = await n.customer.findMany({
      where: { accountId: t.accountId, name: { contains: e.customerName.trim(), mode: "insensitive" } },
      take: 2,
      select: { id: !0, name: !0, phone: !0, address: !0 }
    });
    if (h.length > 1)
      return JSON.stringify({
        error: `More than one customer matches "${e.customerName}". Say the full name, or create the customer first.`
      });
    o = h[0] ?? null;
  }
  if (!o)
    return JSON.stringify({ error: "No matching customer. Create the customer first, then the job." });
  const r = (e.type ?? "OTHER").trim().toUpperCase();
  if (!$t.includes(r))
    return JSON.stringify({ error: `"${r}" is not a valid job type. Use one of: ${$t.join(", ")}.` });
  const a = (e.urgency ?? "LOW").trim().toUpperCase();
  if (!Dt.includes(a))
    return JSON.stringify({ error: `"${a}" is not a valid urgency. Use one of: ${Dt.join(", ")}.` });
  const s = await n.job.create({
    data: {
      accountId: t.accountId,
      customerId: o.id,
      customerName: o.name,
      customerPhone: o.phone,
      customerAddress: o.address,
      description: ((u = e.description) == null ? void 0 : u.trim()) || "",
      type: r,
      urgency: a,
      status: "ACTIVE"
    },
    select: { id: !0 }
  });
  return (m = (l = i.logger) == null ? void 0 : l.log) == null || m.call(l, or, "job created", { accountId: t.accountId, jobId: s.id, customerId: o.id }), me(i, {
    id: s.id,
    customerName: o.name,
    description: e.description,
    status: "ACTIVE"
  }), JSON.stringify({
    success: !0,
    jobId: s.id,
    customerName: o.name,
    description: ((f = e.description) == null ? void 0 : f.trim()) || null,
    type: r,
    urgency: a,
    message: `Job created for ${o.name}.`
  });
}
async function ir(n, e, t) {
  var a, s, c;
  if ((a = t.jobId) != null && a.trim()) {
    const d = await n.job.findFirst({
      where: { id: t.jobId.trim(), accountId: e.accountId },
      select: {
        id: !0,
        customerId: !0,
        customerName: !0,
        description: !0,
        status: !0,
        customerAddress: !0
      }
    });
    return d ? { ok: !0, job: d } : { ok: !1, error: "No matching job found." };
  }
  const i = (s = t.customerName) == null ? void 0 : s.trim();
  if (!i)
    return { ok: !1, error: "Provide a customer name to find the job." };
  const o = await n.job.findMany({
    where: {
      accountId: e.accountId,
      customerName: { contains: i, mode: "insensitive" },
      status: { in: [...le] }
    },
    orderBy: { createdAt: "desc" },
    take: 10,
    select: {
      id: !0,
      customerId: !0,
      customerName: !0,
      description: !0,
      status: !0,
      customerAddress: !0,
      createdAt: !0,
      urgency: !0
    }
  });
  if (o.length === 0)
    return { ok: !1, error: `No active job found for ${i}.` };
  const r = (c = t.description) == null ? void 0 : c.trim().toLowerCase();
  if (r) {
    const d = o.filter((u) => {
      var l;
      return (l = u.description) == null ? void 0 : l.toLowerCase().includes(r);
    });
    if (d.length === 1)
      return { ok: !0, job: d[0] };
  }
  return o.length === 1 ? { ok: !0, job: o[0] } : {
    ok: !1,
    error: `${o[0].customerName} has more than one job in the queue — ask which one they mean (use the job description, never IDs).`,
    choices: o.map((d) => Le(d))
  };
}
const sr = 2;
async function ar(n, e) {
  const t = e.now ?? /* @__PURE__ */ new Date(), i = await n.reviewFollowupSettings.findUnique({
    where: { accountId: e.accountId },
    select: { delayDays: !0 }
  }), o = (i == null ? void 0 : i.delayDays) ?? sr, r = new Date(t.getTime() + o * 24 * 60 * 60 * 1e3);
  await n.outbox.upsert({
    where: { idempotencyKey: `review.followup:${e.jobId}` },
    create: {
      aggregateType: "job",
      aggregateId: e.jobId,
      eventType: "review.followup",
      payload: { accountId: e.accountId, jobId: e.jobId, customerId: e.customerId },
      idempotencyKey: `review.followup:${e.jobId}`,
      accountId: e.accountId,
      priority: 30,
      availableAt: r
    },
    update: {}
  });
}
const cr = "sms-tool:update-job-status", ur = ["ACTIVE", "DONE", "CANCELED"];
async function dr(n, e, t, i = {}) {
  var d, u;
  if (!ur.includes(e.status))
    return JSON.stringify({ error: "That job update is not recognized — try again." });
  const o = await ir(n, t, {
    jobId: e.jobId,
    customerName: e.customerName,
    description: e.description
  });
  if (!o.ok)
    return JSON.stringify(
      o.choices ? { success: !1, error: o.error, choices: o.choices } : { success: !1, error: o.error }
    );
  const r = o.job, a = {
    status: e.status,
    updatedAt: /* @__PURE__ */ new Date()
  };
  e.status === "DONE" && (a.completedAt = /* @__PURE__ */ new Date(), e.completionNotes && (a.completionNotes = e.completionNotes)), await n.job.update({
    where: { id: r.id },
    data: a
  }), e.status === "DONE" && t.customerId && await n.customer.updateMany({
    where: { id: t.customerId, contactStatus: "PROSPECT" },
    data: { contactStatus: "CUSTOMER" }
  }), e.status === "DONE" && r.customerId && (await n.outbox.upsert({
    where: { idempotencyKey: `job.completed:${r.id}` },
    create: {
      aggregateType: "job",
      aggregateId: r.id,
      eventType: "job.completed",
      accountId: t.accountId,
      priority: 10,
      payload: {
        accountId: t.accountId,
        customerId: r.customerId,
        customerName: r.customerName,
        ...e.completionNotes ? { notes: e.completionNotes } : {},
        entityType: "job",
        entityId: r.id
      },
      idempotencyKey: `job.completed:${r.id}`
    },
    update: {}
  }), await ar(n, {
    accountId: t.accountId,
    jobId: r.id,
    customerId: r.customerId
  }));
  const s = e.status === "DONE" ? "job.completed_internal" : "job.status_changed", c = e.status === "DONE" ? `job.completed_internal:${r.id}` : `job.status_changed:${r.id}:${e.status}`;
  return await n.outbox.upsert({
    where: { idempotencyKey: c },
    create: {
      aggregateType: "job",
      aggregateId: r.id,
      eventType: s,
      accountId: t.accountId,
      priority: 25,
      payload: {
        accountId: t.accountId,
        jobId: r.id,
        jobTitle: r.description ?? void 0,
        newStatus: e.status,
        customerId: r.customerId ?? void 0,
        customerName: r.customerName ?? void 0,
        entityType: "job",
        entityId: r.id,
        // Per-occurrence id (jobId + status, matching the key) so moving the
        // same job through two statuses notifies twice, not once.
        relayId: `${r.id}:${e.status}`
      },
      idempotencyKey: c
    },
    update: {}
  }), (u = (d = i.logger) == null ? void 0 : d.log) == null || u.call(d, cr, "job status updated", { jobId: r.id, status: e.status }), me(i, { ...r, status: e.status }), JSON.stringify({
    success: !0,
    customerName: r.customerName,
    description: r.description ?? "",
    stage: Je(e.status)
  });
}
const Pt = "sms-tool:cancel-job";
async function lr(n, e, t, i = {}) {
  var r, a, s, c;
  if (!e.jobId && !e.customerName)
    return JSON.stringify({ error: "Provide either jobId or customerName to cancel a job." });
  let o = null;
  return e.jobId ? o = await n.job.findFirst({
    where: { id: e.jobId, accountId: t.accountId },
    select: { id: !0, customerId: !0, customerName: !0, description: !0, status: !0 }
  }) : e.customerName && (o = await n.job.findFirst({
    where: {
      accountId: t.accountId,
      customerName: { contains: e.customerName, mode: "insensitive" },
      status: { in: [...le] }
    },
    orderBy: { createdAt: "desc" },
    select: { id: !0, customerId: !0, customerName: !0, description: !0, status: !0 }
  })), o ? o.status === "CANCELED" ? JSON.stringify({ error: `${o.customerName}'s job is already canceled.` }) : (await n.job.update({
    where: { id: o.id },
    data: { status: "CANCELED", updatedAt: /* @__PURE__ */ new Date() }
  }), o.customerId && await n.outbox.upsert({
    where: { idempotencyKey: `job.cancelled:${o.id}` },
    create: {
      aggregateType: "job",
      aggregateId: o.id,
      eventType: "job.cancelled",
      accountId: t.accountId,
      priority: 10,
      payload: {
        accountId: t.accountId,
        customerId: o.customerId,
        customerName: o.customerName,
        entityType: "job",
        entityId: o.id
      },
      idempotencyKey: `job.cancelled:${o.id}`
    },
    update: {}
  }), (c = (s = i.logger) == null ? void 0 : s.log) == null || c.call(s, Pt, "job canceled", { jobId: o.id }), me(i, { ...o, status: "CANCELED" }), JSON.stringify({
    success: !0,
    customerName: o.customerName,
    description: o.description ?? ""
  })) : ((a = (r = i.logger) == null ? void 0 : r.warn) == null || a.call(r, Pt, "job not found for cancellation", {
    ...e,
    accountId: t.accountId
  }), JSON.stringify({ error: "No matching active job found to cancel." }));
}
const Mt = "sms-tool:mark-invoice-paid", Ct = ["CASH", "CHECK", "VENMO", "CASH_APP"];
async function mr(n, e, t, i = {}) {
  var w, b, g, S;
  if (!Ct.includes(e.paymentType))
    return JSON.stringify({
      error: `Invalid paymentType "${e.paymentType}". Valid values: ${Ct.join(", ")}`
    });
  if (!e.invoiceId && !e.customerName)
    return JSON.stringify({
      error: "Provide either invoiceId or customerName to mark an invoice paid."
    });
  let o = null;
  const r = {
    id: !0,
    invoiceNumber: !0,
    customerName: !0,
    customerId: !0,
    total: !0,
    laborTotal: !0,
    servicesTotal: !0,
    partsTotal: !0,
    rakeAmount: !0,
    status: !0,
    payments: { select: { kind: !0, status: !0, amount: !0 } }
  };
  if (e.invoiceId)
    o = await n.invoice.findFirst({
      where: {
        id: e.invoiceId,
        accountId: t.accountId,
        status: { notIn: ["CANCELED"] }
      },
      select: r
    });
  else if (e.customerName) {
    const A = await n.invoice.findMany({
      where: {
        accountId: t.accountId,
        customerName: { contains: e.customerName, mode: "insensitive" },
        status: { in: ["SENT", "OVERDUE"] }
      },
      orderBy: { createdAt: "desc" },
      take: 2,
      select: r
    });
    if (A.length > 1)
      return JSON.stringify({
        error: `More than one open invoice matches "${e.customerName}". Specify which by invoice number (e.g. ${D(A[0].invoiceNumber)} or ${D(A[1].invoiceNumber)}).`
      });
    o = A[0] ?? null;
  }
  if (!o)
    return (b = (w = i.logger) == null ? void 0 : w.warn) == null || b.call(w, Mt, "invoice not found for manual payment", {
      ...e,
      accountId: t.accountId
    }), JSON.stringify({ error: "No matching unpaid invoice found." });
  const a = tt(o.total, o.payments);
  if (a.isFullyPaid)
    return JSON.stringify({ error: `${D(o.invoiceNumber)} is already marked as paid.` });
  const s = o, c = e.amount ?? a.balanceDue, d = s.total.toNumber().toFixed(2), u = c.toFixed(2), l = async (A) => {
    const E = await So(A, {
      invoiceId: s.id,
      accountId: t.accountId,
      kind: "PAYMENT",
      method: e.paymentType,
      amount: c,
      rakeAmount: s.rakeAmount.toNumber(),
      laborSubtotal: s.laborTotal.toNumber(),
      serviceSubtotal: s.servicesTotal.toNumber(),
      materialSubtotal: s.partsTotal.toNumber(),
      customerId: s.customerId,
      customerName: s.customerName,
      invoiceNumber: s.invoiceNumber,
      invoiceTotal: s.total.toNumber()
    });
    if (!E) return null;
    const { paymentId: k, isFullyPaid: O, isPartial: N } = E;
    if (O ? await A.invoice.updateMany({
      where: { id: s.id, status: { in: ["SENT", "OVERDUE", "PAID_PARTIAL"] } },
      data: { status: "PAID" }
    }) : N && await A.invoice.updateMany({
      where: { id: s.id, status: { in: ["SENT", "OVERDUE"] } },
      data: { status: "PAID_PARTIAL" }
    }), O)
      await A.customer.updateMany({
        where: { id: s.customerId, contactStatus: "PROSPECT" },
        data: { contactStatus: "CUSTOMER" }
      }), await A.outbox.upsert({
        where: { idempotencyKey: `payment.received_internal:${s.id}` },
        create: {
          aggregateType: "invoice",
          aggregateId: s.id,
          eventType: "payment.received_internal",
          accountId: t.accountId,
          priority: 15,
          payload: {
            accountId: t.accountId,
            customerId: s.customerId,
            customerName: s.customerName,
            invoiceNumber: s.invoiceNumber,
            total: d,
            entityType: "invoice",
            entityId: s.id
          },
          idempotencyKey: `payment.received_internal:${s.id}`
        },
        update: {}
      });
    else if (N) {
      const y = await A.invoicePayment.findMany({
        where: { invoiceId: s.id },
        select: { kind: !0, status: !0, amount: !0 }
      }), _ = tt(s.total, y).balanceDue.toFixed(2);
      await A.outbox.upsert({
        where: { idempotencyKey: `payment.partial_internal:${s.id}:${k}` },
        create: {
          aggregateType: "invoice",
          aggregateId: s.id,
          eventType: "payment.partial_internal",
          accountId: t.accountId,
          priority: 15,
          payload: {
            accountId: t.accountId,
            customerId: s.customerId,
            customerName: s.customerName,
            invoiceNumber: s.invoiceNumber,
            amount: u,
            remaining: _,
            entityType: "invoice",
            entityId: s.id
          },
          idempotencyKey: `payment.partial_internal:${s.id}:${k}`
        },
        update: {}
      });
    }
    return E;
  }, m = n, f = typeof m.$transaction == "function" ? await m.$transaction(l) : await l(n);
  if (!f)
    return JSON.stringify({
      error: `That payment looks like a duplicate of one just recorded for ${D(s.invoiceNumber)}.`
    });
  const { isFullyPaid: h, isPartial: I } = f;
  return (S = (g = i.logger) == null ? void 0 : g.log) == null || S.call(g, Mt, "manual payment recorded", {
    invoiceId: s.id,
    invoiceNumber: s.invoiceNumber,
    paymentType: e.paymentType,
    amount: u,
    isFullyPaid: h,
    isPartial: I
  }), ee(i, {
    id: s.id,
    invoiceNumber: s.invoiceNumber,
    customerName: s.customerName,
    status: h ? "PAID" : I ? "PAID_PARTIAL" : s.status
  }), JSON.stringify({
    success: !0,
    invoiceNumber: s.invoiceNumber,
    customerName: s.customerName,
    total: d,
    amount: u,
    paymentType: e.paymentType,
    isFullyPaid: h,
    isPartial: I
  });
}
const Rt = "sms-tool:edit-invoice", Ut = ["labor", "part", "service"], Ft = ["DRAFT", "IN_REVIEW", "QUOTE"];
async function fr(n, e, t, i = {}) {
  var re, j, ye, ie, Ee, se, pe, K, B, z, Ie, G;
  const o = ce(e.invoiceNumber);
  if (!e.invoiceId && o == null && !((re = e.customerName) != null && re.trim()))
    return JSON.stringify({
      error: "Tell me which invoice to edit — by invoice number or the customer name."
    });
  const r = Array.isArray(e.addItems) && e.addItems.length > 0, a = Array.isArray(e.removeItemNames) && e.removeItemNames.length > 0;
  if (!r && !a && e.discountPercent == null && e.discountAmount == null && e.memo == null)
    return JSON.stringify({
      error: "No changes given. Say what to add, remove, discount, or note on the invoice."
    });
  if (e.discountPercent != null && (e.discountPercent < 0 || e.discountPercent > 100))
    return JSON.stringify({ error: "Discount percent must be between 0 and 100." });
  const s = [];
  if (r)
    for (const T of e.addItems) {
      const M = (T.name ?? "").trim();
      if (!M) return JSON.stringify({ error: "Each new line item needs a name." });
      const v = (T.type ?? "service").trim().toLowerCase();
      if (!Ut.includes(v))
        return JSON.stringify({
          error: `"${v}" is not a valid item type. Use one of: ${Ut.join(", ")}.`
        });
      if (typeof T.unitPrice != "number" || !Number.isFinite(T.unitPrice) || T.unitPrice < 0)
        return JSON.stringify({ error: `Line item "${M}" needs a valid unit price.` });
      const $ = T.quantity ?? 1;
      if (typeof $ != "number" || !Number.isFinite($) || $ <= 0)
        return JSON.stringify({ error: `Line item "${M}" needs a positive quantity.` });
      s.push({
        type: v,
        name: M,
        description: ((j = T.description) == null ? void 0 : j.trim()) || null,
        quantity: $,
        unitPrice: T.unitPrice,
        taxable: T.taxable ?? !1
      });
    }
  const c = {
    id: !0,
    invoiceNumber: !0,
    customerName: !0,
    status: !0,
    discountPercent: !0,
    // The invoice's OWN snapshotted sales-tax rate (Zip.tax, resolved from the
    // job location at create/review). Editing REAPPLIES this stored rate to the
    // new taxable subtotal — we never call Zip.tax here (Hard Rule #9 in the API;
    // and re-looking-up on every line-item tweak would burn billed calls).
    taxRate: !0,
    account: {
      select: { rakeType: !0, rakePercent: !0, rakeFixedAmount: !0 }
    }
  };
  let d = null;
  if (e.invoiceId)
    d = await n.invoice.findFirst({
      where: { id: e.invoiceId, accountId: t.accountId },
      select: c
    });
  else if (o != null)
    d = await n.invoice.findFirst({
      where: { accountId: t.accountId, invoiceNumber: o },
      select: c
    });
  else if ((ye = e.customerName) != null && ye.trim()) {
    const T = await n.invoice.findMany({
      where: {
        accountId: t.accountId,
        customerName: { contains: e.customerName.trim(), mode: "insensitive" },
        status: { in: [...Ft] }
      },
      orderBy: { createdAt: "desc" },
      take: 2,
      select: c
    });
    if (T.length > 1)
      return JSON.stringify({
        error: `More than one open invoice matches "${e.customerName}". Tell me which by invoice number (e.g. ${D(T[0].invoiceNumber)} or ${D(T[1].invoiceNumber)}).`
      });
    d = T[0] ?? null;
  }
  if (!d)
    return (Ee = (ie = i.logger) == null ? void 0 : ie.warn) == null || Ee.call(ie, Rt, "invoice not found for edit", { ...e, accountId: t.accountId }), JSON.stringify({ error: "No matching editable invoice found." });
  if (!Ft.includes(d.status))
    return JSON.stringify({
      error: `${D(d.invoiceNumber)} is ${d.status} and can no longer be edited. Cancel and reissue it instead.`
    });
  const u = d, l = t.accountId, m = await n.invoiceLineItem.findMany({
    where: { invoiceId: u.id },
    orderBy: { sortOrder: "asc" },
    select: { type: !0, name: !0, description: !0, quantity: !0, unitPrice: !0, taxable: !0 }
  }), f = a ? e.removeItemNames.map((T) => T.trim().toLowerCase()).filter(Boolean) : [];
  let h = 0;
  const I = m.filter((T) => {
    const M = f.some((v) => T.name.toLowerCase().includes(v));
    return M && h++, !M;
  }).map((T) => ({
    type: T.type,
    name: T.name,
    description: T.description,
    quantity: typeof T.quantity == "number" ? T.quantity : Number(T.quantity),
    unitPrice: typeof T.unitPrice == "number" ? T.unitPrice : Number(T.unitPrice),
    taxable: T.taxable
  }));
  if (f.length > 0 && h === 0)
    return JSON.stringify({
      error: `Nothing on ${D(u.invoiceNumber)} matched "${e.removeItemNames.join(", ")}".`
    });
  const w = [...I], b = /* @__PURE__ */ new Set();
  let g = 0, S = 0;
  for (const T of s) {
    const M = T.name.toLowerCase(), v = [];
    if (w.forEach(($, q) => {
      !b.has($) && $.name.toLowerCase() === M && v.push(q);
    }), v.length > 0) {
      w[v[0]] = T;
      for (let $ = v.length - 1; $ >= 1; $--) w.splice(v[$], 1);
      S++;
    } else
      w.push(T), g++;
    b.add(T);
  }
  if (w.length === 0)
    return JSON.stringify({
      error: "An invoice needs at least one line item — add something before removing the rest."
    });
  const A = ((pe = (se = u.taxRate) == null ? void 0 : se.toNumber) == null ? void 0 : pe.call(se)) ?? 0, E = Xe(w, 0).subtotal, k = e.discountAmount != null && e.discountAmount > 0, O = k ? "fixed" : "percent", N = k ? 0 : e.discountPercent != null ? e.discountPercent : Number(((B = (K = u.discountPercent) == null ? void 0 : K.toNumber) == null ? void 0 : B.call(K)) ?? 0), y = k ? +Math.min(e.discountAmount, E).toFixed(2) : +(E * (N / 100)).toFixed(2), p = Xe(w, A, y), _ = p.total, P = u.account.rakePercent.toNumber(), R = u.account.rakeType === "fixed" ? u.account.rakeFixedAmount.toNumber() : +((p.laborTotal + p.servicesTotal) * (P / 100)).toFixed(2), Se = async (T) => {
    await T.invoiceLineItem.deleteMany({ where: { invoiceId: u.id } }), await T.invoiceLineItem.createMany({
      data: w.map((M, v) => ({
        invoiceId: u.id,
        accountId: l,
        type: M.type,
        name: M.name,
        description: M.description ?? null,
        quantity: M.quantity ?? 1,
        unitPrice: M.unitPrice,
        total: (M.quantity ?? 1) * M.unitPrice,
        taxable: M.taxable ?? !1,
        sortOrder: v
      }))
    }), await T.invoice.update({
      where: { id: u.id },
      data: {
        laborTotal: p.laborTotal,
        partsTotal: p.partsTotal,
        servicesTotal: p.servicesTotal,
        subtotal: p.subtotal,
        discountPercent: N,
        discountAmount: y,
        discountKind: O,
        taxableAmount: p.taxableAmount,
        taxAmount: p.taxAmount,
        total: _,
        rakePercent: P,
        rakeAmount: R,
        // Review gate: on a gated account an edit pulls a contractor-visible DRAFT
        // (or a still-held IN_REVIEW) back to IN_REVIEW so ops re-reviews the change
        // before the contractor sees it. SENDING is excluded by the claim above
        // and can never reach this mutation.
        ...t.holdForReview && (u.status === "DRAFT" || u.status === "IN_REVIEW") ? { status: "IN_REVIEW", ...t.reviewRequestText ? { reviewRequestText: t.reviewRequestText } : {} } : {},
        ...e.memo != null ? { memo: e.memo } : {},
        updatedAt: /* @__PURE__ */ new Date()
      }
    }), t.holdForReview && u.status === "DRAFT" && await cn(T, {
      invoiceId: u.id,
      accountId: l
    });
  }, fe = n;
  typeof fe.$transaction == "function" ? await fe.$transaction(Se) : await Se(n), (Ie = (z = i.logger) == null ? void 0 : z.log) == null || Ie.call(z, Rt, "invoice edited", {
    invoiceId: u.id,
    invoiceNumber: u.invoiceNumber,
    added: g,
    updated: S,
    removed: h,
    total: _
  });
  const he = t.holdForReview ? "IN_REVIEW" : u.status === "APPROVED" ? "DRAFT" : u.status;
  return ee(i, {
    id: u.id,
    invoiceNumber: u.invoiceNumber,
    customerName: u.customerName,
    status: he,
    isQuote: u.status === "QUOTE"
  }), he === "DRAFT" && ((G = i.invoiceApproval) == null || G.call(i, {
    invoiceId: u.id,
    invoiceNumber: u.invoiceNumber,
    customerName: u.customerName ?? "the customer",
    total: `$${_.toFixed(2)}`
  })), JSON.stringify({
    success: !0,
    invoiceId: u.id,
    invoiceNumber: u.invoiceNumber,
    customerName: u.customerName,
    added: g,
    updated: S,
    removed: h,
    subtotal: p.subtotal.toFixed(2),
    discountPercent: N,
    discountAmount: y.toFixed(2),
    taxAmount: p.taxAmount.toFixed(2),
    total: _.toFixed(2),
    lineItems: w.map((T) => ({
      type: T.type,
      name: T.name,
      quantity: T.quantity ?? 1,
      unitPrice: (T.unitPrice ?? 0).toFixed(2),
      total: ((T.quantity ?? 1) * (T.unitPrice ?? 0)).toFixed(2)
    }))
  });
}
async function hr(n, e) {
  const t = await n.customerSubscription.findFirst({
    where: {
      accountId: e.accountId,
      customerId: e.customerId,
      status: { in: ["active", "trialing"] }
    },
    orderBy: { createdAt: "desc" },
    select: { plan: { select: { name: !0, discountPercent: !0 } } }
  });
  if (!t) return null;
  const i = Number(t.plan.discountPercent);
  return i > 0 ? { discountName: `${t.plan.name} member`, discountPercent: i } : null;
}
const jt = "invoice.drafted_internal";
async function yr(n, e) {
  const t = `${jt}:${e.invoiceId}`;
  await n.outbox.upsert({
    where: { idempotencyKey: t },
    create: {
      aggregateType: "invoice",
      aggregateId: e.invoiceId,
      eventType: jt,
      payload: e,
      idempotencyKey: t,
      accountId: e.accountId,
      priority: 10
    },
    update: {}
  });
}
const pr = "invoice:create-for-assistant", Ir = ["labor", "part", "service"];
function Jt(n) {
  const e = String(n ?? "").trim().toLowerCase();
  return Ir.includes(e) ? e : "service";
}
async function gr(n, e, t, i = {}) {
  var z, Ie, G, T, M;
  if (!Array.isArray(e.items) || e.items.length === 0)
    return JSON.stringify({ error: "An invoice needs at least one line item." });
  try {
    to(e.items, {
      discountPercent: e.discountPercent,
      discountAmount: e.discountAmount
    });
  } catch (v) {
    if (v instanceof be) return JSON.stringify({ error: v.message });
    throw v;
  }
  const o = {
    id: !0,
    name: !0,
    phone: !0,
    street: !0,
    city: !0,
    state: !0,
    zip: !0
  };
  let r = null;
  if (e.customerId)
    r = await n.customer.findFirst({
      where: { id: e.customerId, accountId: t.accountId },
      select: o
    });
  else if ((z = e.customerName) != null && z.trim()) {
    const v = await n.customer.findMany({
      where: { accountId: t.accountId, name: { contains: e.customerName.trim(), mode: "insensitive" } },
      take: 2,
      select: o
    });
    if (v.length > 1)
      return JSON.stringify({
        error: `More than one customer matches "${e.customerName}". Say which one (full name), or create the customer first.`
      });
    r = v[0] ?? null;
  }
  if (!r)
    return JSON.stringify({
      error: "No matching customer. Create the customer first, then create the invoice."
    });
  const a = e.status === "QUOTE" ? "QUOTE" : "DRAFT", s = t.holdForReview === !0 && a !== "QUOTE", c = s ? "IN_REVIEW" : a, d = s;
  if (c !== "QUOTE") {
    const v = await n.invoice.findFirst({
      where: { accountId: t.accountId, customerId: r.id, status: { notIn: ["CANCELED", "QUOTE"] } },
      orderBy: { createdAt: "desc" },
      select: { invoiceNumber: !0, total: !0 }
    });
    if (v) {
      const $ = typeof ((Ie = v.total) == null ? void 0 : Ie.toNumber) == "function" ? v.total.toNumber().toFixed(2) : String(v.total);
      return JSON.stringify({
        success: !1,
        error: `An open invoice (${D(v.invoiceNumber)} for $${$}) already exists for ${r.name}. Edit that one, or void it first.`,
        invoiceNumber: v.invoiceNumber
      });
    }
  }
  const u = e.jobId ? await n.job.findFirst({
    where: { id: e.jobId, accountId: t.accountId },
    select: { id: !0, serviceStreet: !0, serviceCity: !0, serviceState: !0, serviceZip: !0 }
  }) : null, l = (u == null ? void 0 : u.id) ?? null;
  if (l) {
    const v = await n.invoice.findFirst({
      where: { jobId: l, status: { not: "CANCELED" } },
      select: { invoiceNumber: !0 }
    });
    if (v)
      return JSON.stringify({
        error: `That job already has ${D(v.invoiceNumber)}. A job can only have one invoice — edit that one instead.`
      });
  }
  const m = await n.account.update({
    where: { id: t.accountId },
    data: { nextInvoiceNumber: { increment: 1 } },
    select: {
      collectsSalesTax: !0,
      nextInvoiceNumber: !0,
      businessName: !0,
      timezone: !0,
      rakeType: !0,
      rakePercent: !0,
      rakeFixedAmount: !0
    }
  }), f = m.nextInvoiceNumber - 1, h = e.items.map((v) => ({ ...v, type: Jt(v.type) })), I = await No(n, {
    accountId: t.accountId,
    customerId: r.id,
    customerName: r.name ?? r.phone,
    customerPhone: r.phone,
    memo: e.memo,
    footerOverride: e.footerOverride,
    timeZone: m.timezone || "UTC",
    lineItems: h
  }), w = I.items.map((v) => ({ ...v, type: Jt(v.type) })), { laborTotal: b, partsTotal: g, servicesTotal: S, subtotal: A } = Xe(w, 0), E = m.collectsSalesTax, k = E ? w.filter((v) => !!v.taxable).reduce((v, $) => v + ($.quantity ?? 1) * $.unitPrice, 0) : 0;
  let O = 0, N = 0, y = null, p = null, _;
  if (i.computeSalesTax && E && k > 0) {
    const v = u ?? await n.job.findFirst({
      where: { accountId: t.accountId, customerId: r.id, status: "ACTIVE" },
      orderBy: { createdAt: "desc" },
      select: { serviceStreet: !0, serviceCity: !0, serviceState: !0, serviceZip: !0 }
    }), $ = v != null && v.serviceZip ? { street: v.serviceStreet, city: v.serviceCity, state: v.serviceState, zip: v.serviceZip } : { street: r.street, city: r.city, state: r.state, zip: r.zip }, q = await i.computeSalesTax(n, { accountId: t.accountId, taxableAmount: k, address: $ });
    O = q.taxRate, N = q.taxAmount, y = q.taxState, p = q.taxWarning, _ = xe({ showSalesTax: E, taxableAmount: k, taxRate: O, taxState: y, zip: $.zip ?? null });
  } else E && k > 0 ? (p = "Sales tax will be applied at review — recorded $0 on create.", _ = "Sales tax on — recorded $0 on create; the rate is applied at ops review (Zip.tax runs worker-side).") : _ = xe({ showSalesTax: E, taxableAmount: k, taxRate: 0, taxState: null, zip: null });
  const P = await hr(n, { accountId: t.accountId, customerId: r.id }), R = e.discountAmount != null && e.discountAmount > 0, Se = R ? "fixed" : "percent", fe = R ? 0 : e.discountPercent != null ? e.discountPercent : (P == null ? void 0 : P.discountPercent) ?? 0, he = R || e.discountPercent != null ? null : (P == null ? void 0 : P.discountName) ?? null, re = R ? +Math.min(e.discountAmount, A).toFixed(2) : +(A * (fe / 100)).toFixed(2);
  N = +(un(k, A, re) * O).toFixed(2);
  const j = +(A - re + N).toFixed(2), ye = m.rakePercent.toNumber(), ie = m.rakeType === "fixed" ? m.rakeFixedAmount.toNumber() : +((b + S) * (ye / 100)).toFixed(2), Ee = {
    accountId: t.accountId,
    customerId: r.id,
    // Tie the invoice to a job when a VALID one is given (the driveway flow:
    // customer + job + quote). jobIdToTie is null when none was given or the id
    // didn't resolve, so it can never trip the FK. createInvoiceFromTemplate does
    // not persist it, so set it on the invoice row itself.
    ...l ? { jobId: l } : {},
    templateId: I.templateId,
    invoiceNumber: f,
    customerName: r.name ?? r.phone,
    customerPhone: r.phone,
    memo: I.memo,
    footerOverride: I.footerOverride,
    invoiceDate: I.invoiceDate,
    dueDate: I.dueDate,
    dueTimezone: I.dueTimezone,
    overdueAt: I.overdueAt,
    laborTotal: b,
    partsTotal: g,
    servicesTotal: S,
    subtotal: A,
    discountPercent: fe,
    discountAmount: re,
    discountKind: Se,
    ...he ? { discountName: he } : {},
    taxRate: O,
    taxableAmount: k,
    taxAmount: N,
    taxState: y,
    taxWarning: p,
    taxBasis: _,
    total: j,
    rakePercent: ye,
    rakeAmount: ie,
    status: c,
    // Snapshot the triggering request beside the invoice for the ops reviewer.
    ...s && t.reviewRequestText ? { reviewRequestText: t.reviewRequestText } : {}
  }, se = (v) => w.map(($, q) => {
    const mt = $.quantity ?? 1;
    return {
      invoiceId: v,
      accountId: t.accountId,
      type: $.type,
      name: $.name,
      description: $.description ?? null,
      quantity: mt,
      unitPrice: $.unitPrice,
      total: mt * $.unitPrice,
      taxable: $.taxable ?? !1,
      sortOrder: q
    };
  }), pe = n, K = async (v) => {
    const $ = await v.invoice.create({ data: Ee, select: { id: !0 } });
    return await v.invoiceLineItem.createMany({ data: se($.id) }), c === "DRAFT" && await yr(v, {
      accountId: t.accountId,
      invoiceId: $.id,
      invoiceNumber: f,
      customerName: r.name ?? r.phone ?? void 0,
      total: j.toFixed(2),
      ...i.ownerDraftAlertHandled ? { suppressSms: !0 } : {}
    }), s && await cn(v, {
      invoiceId: $.id,
      accountId: t.accountId
    }), $.id;
  }, B = typeof pe.$transaction == "function" ? await pe.$transaction(K) : await K(n);
  return await In(n, {
    accountId: t.accountId,
    type: "INVOICE_BUILT",
    text: `${D(f)} · $${j.toFixed(2)}`,
    customerName: r.name ?? null,
    refType: "invoice",
    refId: B
  }), d && await xn(n, {
    kind: "admin.invoice.pending_review",
    title: "Invoice needs review",
    body: `${m.businessName} • ${D(f)} • $${j.toFixed(2)}`,
    deepLink: "tenfour://admin/tower",
    entityId: B,
    aggregateType: "invoice"
  }), (T = (G = i.logger) == null ? void 0 : G.log) == null || T.call(G, pr, c === "QUOTE" ? "quote created" : "invoice queued for review", {
    invoiceId: B,
    invoiceNumber: f,
    total: j,
    status: c
  }), ee(i, {
    id: B,
    invoiceNumber: f,
    customerName: r.name ?? r.phone,
    status: c,
    isQuote: c === "QUOTE"
  }), c === "DRAFT" && ((M = i.invoiceApproval) == null || M.call(i, {
    invoiceId: B,
    invoiceNumber: f,
    customerName: r.name ?? r.phone,
    total: `$${j.toFixed(2)}`
  })), JSON.stringify({
    success: !0,
    invoiceId: B,
    invoiceNumber: f,
    customerName: r.name ?? r.phone,
    total: j.toFixed(2),
    status: c,
    isQuote: c === "QUOTE",
    awaitingApproval: c === "DRAFT",
    // Held for Ten Four review — the contractor gets an "in review" ack (no view
    // link yet), not the normal approve-ready alert. Released to DRAFT by ops.
    heldForReview: c === "IN_REVIEW",
    // Spoken-friendly line the voice model relays on a held create (SMS uses its
    // own deterministic in-review ack and ignores this). Only present when held.
    ...c === "IN_REVIEW" ? { message: `${D(f)} for $${j.toFixed(2)} is with Ten Four for review — you'll get a text to approve it shortly. Tell the caller it's being reviewed and don't imply it was sent.` } : {},
    lineItems: w.map((v) => {
      const $ = v.quantity ?? 1;
      return {
        type: v.type,
        name: v.name,
        quantity: $,
        unitPrice: v.unitPrice.toFixed(2),
        total: ($ * v.unitPrice).toFixed(2)
      };
    })
  });
}
async function wr(n, e, t, i = {}) {
  var s;
  const o = ce(e.invoiceNumber);
  if ((e.action ?? (e.invoiceId || o != null ? "edit" : "create")) === "edit")
    return fr(
      n,
      {
        invoiceId: e.invoiceId,
        invoiceNumber: o ?? void 0,
        customerName: e.customerName,
        addItems: e.lineItems,
        removeItemNames: e.removeItemNames,
        discountPercent: e.discountPercent,
        discountAmount: e.discountAmount,
        memo: e.memo
      },
      t,
      i
    );
  const a = [];
  return !e.customerId && !((s = e.customerName) != null && s.trim()) && a.push("customer"), (!Array.isArray(e.lineItems) || e.lineItems.length === 0) && a.push("lineItems"), a.length > 0 ? JSON.stringify({
    success: !1,
    error: `Nothing was created — still need: ${a.join(", ")}.`,
    needs: a,
    message: "Ask the account for exactly what is missing (who to bill and/or the amount or line items), then call write_invoice again. Do not invent it."
  }) : gr(
    n,
    {
      customerId: e.customerId,
      customerName: e.customerName,
      jobId: e.jobId ?? null,
      status: e.status,
      memo: e.memo,
      discountPercent: e.discountPercent,
      discountAmount: e.discountAmount,
      items: e.lineItems ?? []
    },
    t,
    i
  );
}
const Lt = "sms-tool:approve-invoice";
async function vr(n, e, t, i = {}) {
  var d, u, l, m, f;
  const o = {
    id: !0,
    invoiceNumber: !0,
    customerName: !0,
    status: !0,
    total: !0,
    customerId: !0,
    customerPhone: !0
  };
  let r = null;
  if (e.invoiceId ? r = await n.invoice.findFirst({ where: { id: e.invoiceId, accountId: t.accountId }, select: o }) : ce(e.invoiceNumber) != null ? r = await n.invoice.findFirst({
    where: { invoiceNumber: ce(e.invoiceNumber), accountId: t.accountId },
    select: o
  }) : e.customerName && (r = await n.invoice.findFirst({
    where: {
      accountId: t.accountId,
      status: "DRAFT",
      customerName: { contains: e.customerName.trim(), mode: "insensitive" }
    },
    orderBy: { createdAt: "desc" },
    select: o
  })), !r)
    return JSON.stringify({ error: "Could not find that invoice to approve — give the invoice number or the customer name." });
  if (r.status !== "DRAFT")
    return JSON.stringify({
      error: `${D(r.invoiceNumber)} is ${r.status.toLowerCase()}, not a draft awaiting approval.`
    });
  const a = typeof ((d = r.total) == null ? void 0 : d.toNumber) == "function" ? r.total.toNumber() : Number(r.total);
  if (!(a > 0))
    return JSON.stringify({
      error: `${D(r.invoiceNumber)} has a $0 total — add a line item before sending.`
    });
  if (!t.confirmInline && t.confirmationMode === "portal")
    return ee(i, r), i.invoiceApproval ? (i.invoiceApproval({
      invoiceId: r.id,
      invoiceNumber: r.invoiceNumber,
      customerName: r.customerName ?? "the customer",
      total: `$${a.toFixed(2)}`
    }), (l = (u = i.logger) == null ? void 0 : u.log) == null || l.call(u, Lt, "invoice approval staged for portal confirmation", {
      accountId: t.accountId,
      invoiceId: r.id
    }), JSON.stringify({
      status: "awaiting_portal_confirmation",
      invoice: D(r.invoiceNumber),
      instruction: "NOT sent yet. The approval card is ready below — tell the account holder to review it there; sending happens only when they approve it. Never claim it was sent."
    })) : JSON.stringify({
      status: "needs_portal_approval",
      invoice: D(r.invoiceNumber),
      instruction: "NOT sent. Sending needs the account holder’s own approval — tell them to open the invoice (card below) and approve it from the Invoices page. Never claim it was sent."
    });
  const s = globalThis.crypto.randomUUID();
  return (await n.invoice.updateMany({
    where: { id: r.id, status: "DRAFT" },
    data: {
      status: "SENDING",
      deliveryAttemptId: s,
      sentAt: null,
      approvedAt: /* @__PURE__ */ new Date(),
      reviewFlaggedAt: null,
      reviewRejectionReason: null
    }
  })).count !== 1 ? JSON.stringify({
    error: `${D(r.invoiceNumber)} changed while it was being approved — refresh and try again.`
  }) : (await n.outbox.create({
    data: {
      aggregateType: "invoice",
      aggregateId: r.id,
      eventType: "invoice.created",
      payload: {
        invoiceId: r.id,
        accountId: t.accountId,
        customerId: r.customerId,
        customerPhone: r.customerPhone,
        invoiceNumber: r.invoiceNumber,
        total: a,
        deliveryAttemptId: s,
        stripePaymentLinkUrl: null,
        pdfUrl: null,
        // SMS approve (no confirmInline): the reply above is a text, so skip the
        // send handler's owner "sent" text to avoid a duplicate. Voice keeps it.
        ...t.confirmInline ? {} : { suppressOwnerSentNotify: !0 }
      },
      idempotencyKey: `invoice.created:${r.id}:${s}`,
      accountId: t.accountId,
      priority: 20
    }
  }), await n.outbox.create({
    data: {
      aggregateType: "invoice",
      aggregateId: r.id,
      eventType: "invoice.delivery_watchdog",
      payload: { accountId: t.accountId, invoiceId: r.id, deliveryAttemptId: s, check: 0 },
      idempotencyKey: `invoice.delivery_watchdog:${r.id}:${s}:0`,
      accountId: t.accountId,
      priority: 30,
      availableAt: new Date(Date.now() + 120 * 1e3)
    }
  }), (f = (m = i.logger) == null ? void 0 : m.log) == null || f.call(m, Lt, "invoice delivery started", {
    accountId: t.accountId,
    invoiceId: r.id,
    deliveryAttemptId: s
  }), ee(i, {
    id: r.id,
    invoiceNumber: r.invoiceNumber,
    customerName: r.customerName,
    status: "SENDING"
  }), JSON.stringify({
    success: !0,
    invoiceId: r.id,
    invoiceNumber: r.invoiceNumber,
    deliveryAttemptId: s,
    message: `Ten Four — ${D(r.invoiceNumber)} is on its way to your customer.`
  }));
}
const br = "sms-tool:cancel-invoice", Nr = /* @__PURE__ */ new Set(["PAID", "CANCELED"]);
async function Tr(n, e, t, i = {}) {
  var c, d;
  const o = { id: !0, invoiceNumber: !0, customerName: !0, status: !0, deliveryAttemptId: !0 };
  let r = null;
  if (e.invoiceId ? r = await n.invoice.findFirst({ where: { id: e.invoiceId, accountId: t.accountId }, select: o }) : ce(e.invoiceNumber) != null ? r = await n.invoice.findFirst({
    where: { invoiceNumber: ce(e.invoiceNumber), accountId: t.accountId },
    select: o
  }) : e.customerName && (r = await n.invoice.findFirst({
    where: {
      accountId: t.accountId,
      status: { notIn: ["CANCELED", "PAID"] },
      customerName: { contains: e.customerName.trim(), mode: "insensitive" }
    },
    orderBy: { createdAt: "desc" },
    select: o
  })), !r)
    return JSON.stringify({ error: "Could not find that invoice to cancel — give the invoice number or the customer name." });
  if (Nr.has(r.status)) {
    const u = r.status === "PAID" ? `${D(r.invoiceNumber)} is already paid — a refund is handled separately, it can't be cancelled.` : `${D(r.invoiceNumber)} is already cancelled.`;
    return JSON.stringify({ error: u });
  }
  return !(r.status === "DRAFT" || r.status === "QUOTE") && t.canApproveInvoices === !1 ? JSON.stringify({
    error: `${D(r.invoiceNumber)} has already been sent, so canceling it needs the "Approve & send invoices" permission. The account owner can grant it in team settings.`
  }) : await n.invoicePayment.count({ where: { invoiceId: r.id } }) > 0 ? JSON.stringify({
    error: `${D(r.invoiceNumber)} has a payment on it — refund the payment first, then it can be cancelled.`
  }) : (await n.invoice.update({
    where: { id: r.id },
    data: { status: "CANCELED", jobId: null }
  }), r.status === "SENDING" && r.deliveryAttemptId && await ko(
    n,
    r.id,
    r.deliveryAttemptId,
    "Canceled by owner before invoice delivery completed"
  ), await n.outbox.upsert({
    where: { idempotencyKey: `invoice.voided:${r.id}` },
    update: {},
    create: {
      aggregateType: "invoice",
      aggregateId: r.id,
      eventType: "invoice.voided",
      accountId: t.accountId,
      priority: 15,
      payload: {
        invoiceId: r.id,
        accountId: t.accountId,
        // SMS suppresses the handler's cancel text (the reply above is a text);
        // voice keeps it (the spoken reply is ephemeral).
        ...t.confirmInline ? {} : { suppressNotify: !0 }
      },
      idempotencyKey: `invoice.voided:${r.id}`
    }
  }), (d = (c = i.logger) == null ? void 0 : c.log) == null || d.call(c, br, "invoice cancelled", { accountId: t.accountId, invoiceId: r.id }), ee(i, {
    id: r.id,
    invoiceNumber: r.invoiceNumber,
    customerName: r.customerName,
    status: "CANCELED"
  }), JSON.stringify({
    success: !0,
    invoiceId: r.id,
    invoiceNumber: r.invoiceNumber,
    message: `Ten Four — ${D(r.invoiceNumber)} cancelled. You can restore it to a draft anytime.`
  }));
}
const Bt = "sms-tool:send-booking-link";
async function qt(n, e, t, i) {
  var o;
  await n.outbox.upsert({
    where: { idempotencyKey: `booking.link_sent:${t}` },
    create: {
      aggregateType: "booking_token",
      aggregateId: t,
      eventType: "booking.link_sent",
      payload: {
        accountId: e.accountId,
        conversationId: e.conversationId,
        customerId: e.customerId,
        customerName: ((o = e.customer) == null ? void 0 : o.name) ?? void 0,
        url: i,
        // Per-occurrence id: two booking links in one conversation would
        // otherwise collapse onto conversationId downstream.
        relayId: t
      },
      idempotencyKey: `booking.link_sent:${t}`,
      accountId: e.accountId,
      priority: 25
    },
    update: {}
  });
}
async function Ar(n, e, t, i = {}) {
  var m, f, h, I, w, b, g, S, A, E, k;
  const o = ((m = e.description) == null ? void 0 : m.trim()) ?? "", a = {
    phone: ((f = t.customer) == null ? void 0 : f.phone) || t.toPhone || "",
    firstName: e.firstName,
    lastName: e.lastName,
    email: e.email,
    street: e.street ?? ((h = t.customer) == null ? void 0 : h.street) ?? void 0,
    city: e.city ?? ((I = t.customer) == null ? void 0 : I.city) ?? void 0,
    state: e.state ?? ((w = t.customer) == null ? void 0 : w.state) ?? void 0,
    zip: e.zip ?? ((b = t.customer) == null ? void 0 : b.zip) ?? void 0
  };
  let s;
  if (e.customAnswers && Object.keys(e.customAnswers).length > 0) {
    const O = await n.account.findUnique({
      where: { id: t.accountId },
      select: {
        formTemplate: {
          select: {
            // Exclude FILE_UPLOAD (not model-fillable) so this resolve list stays in
            // the same order as the tool-schema query in sms-context.ts — the slugs
            // (customAnswerSlug) must line up across both.
            questions: {
              where: { key: null, type: { not: "FILE_UPLOAD" } },
              orderBy: { order: "asc" },
              select: { id: !0, label: !0, type: !0, options: !0, required: !0 }
            }
          }
        }
      }
    }), N = (((g = O == null ? void 0 : O.formTemplate) == null ? void 0 : g.questions) ?? []).map((y) => ({
      id: y.id,
      label: y.label,
      type: y.type,
      options: y.options,
      required: y.required
    }));
    s = sn(N, e.customAnswers) ?? void 0;
  }
  const c = await n.bookingToken.findFirst({
    where: {
      accountId: t.accountId,
      customerId: t.customerId,
      formTemplateId: null,
      status: "ACTIVE",
      expiresAt: { gt: /* @__PURE__ */ new Date() }
    },
    orderBy: { createdAt: "desc" },
    select: { token: !0, context: !0 }
  });
  if (c) {
    await gn(n, c.token, {
      context: c.context,
      prefill: a,
      customPrefill: s
    });
    const O = `${t.frontendUrl}/book/${c.token}`;
    return await qt(n, t, c.token, O), (A = (S = i.logger) == null ? void 0 : S.log) == null || A.call(S, Bt, "reusing existing ACTIVE booking token", {
      customerId: t.customerId
    }), JSON.stringify({ success: !0, bookingUrl: O, reused: !0 });
  }
  let d = null;
  if (e.jobId) {
    const O = await n.job.findFirst({
      where: { id: e.jobId, accountId: t.accountId },
      select: { id: !0 }
    });
    O && (d = O.id);
  }
  const u = await at(n, {
    accountId: t.accountId,
    customerId: t.customerId,
    jobId: d,
    description: o,
    prefill: a,
    customPrefill: s
  }), l = `${t.frontendUrl}/book/${u.token}`;
  return await qt(n, t, u.token, l), (k = (E = i.logger) == null ? void 0 : E.log) == null || k.call(E, Bt, "booking link created", { customerId: t.customerId, bookingUrl: l }), JSON.stringify({ success: !0, bookingUrl: l });
}
const we = "sms-tool:send-form";
async function Ia(n, e, t, i = {}) {
  var f, h, I, w, b, g, S, A, E, k, O;
  const o = await n.customer.findFirst({
    where: { id: t.customerId, accountId: t.accountId },
    select: { doNotText: !0, consentStatus: !0 }
  });
  if (!o)
    return JSON.stringify({ error: "No customer associated with this conversation — cannot send form link" });
  if (o.doNotText || o.consentStatus === "opted_out")
    return (h = (f = i.logger) == null ? void 0 : f.warn) == null || h.call(f, we, "refusing form link — customer opted out", { accountId: t.accountId }), JSON.stringify({
      error: "This customer has opted out of text messages, so a form link cannot be texted to them.",
      reason: "opted_out"
    });
  if ((t.initiatedBy ?? "customer") === "contractor" && o.consentStatus !== "opted_in")
    return (w = (I = i.logger) == null ? void 0 : I.warn) == null || w.call(I, we, "refusing contractor-initiated form link — customer has not opted in", {
      accountId: t.accountId
    }), JSON.stringify({
      error: "This customer hasn't opted in to text messages, so a form link can't be texted to them unless they ask for it in their own text thread. You can send them the booking link instead — it carries the text opt-in — or share the form URL another way.",
      reason: "consent_required",
      alternative: "send_booking_link"
    });
  const r = await n.account.findUnique({
    where: { id: t.accountId },
    select: {
      // The default IS send_booking_link's form and is excluded below — exactly as
      // sms-context excludes it when building the tools.
      defaultFormTemplateId: !0,
      formTemplates: {
        orderBy: [{ assignedAt: "asc" }, { formTemplateId: "asc" }],
        select: {
          formTemplate: {
            select: {
              id: !0,
              name: !0,
              enabled: !0,
              kind: !0,
              // FILE_UPLOAD questions are KEPT (they get no schema property but do
              // consume a slug index) so the q-slugs line up with the tool schema.
              questions: {
                where: { key: null },
                orderBy: { order: "asc" },
                select: { id: !0, label: !0, type: !0, options: !0, required: !0 }
              }
            }
          }
        }
      }
    }
  }), s = an(
    ((r == null ? void 0 : r.formTemplates) ?? []).map((N) => N.formTemplate).filter((N) => N.enabled && N.kind === "OTHER" && N.id !== (r == null ? void 0 : r.defaultFormTemplateId)).map((N) => ({
      id: N.id,
      name: N.name,
      questions: N.questions.map((y) => ({
        id: y.id,
        label: y.label,
        type: y.type,
        options: y.options,
        required: y.required
      }))
    }))
  ).find((N) => N.slug === e.slug);
  if (!s)
    return (g = (b = i.logger) == null ? void 0 : b.warn) == null || g.call(b, we, "no assigned form for slug", { accountId: t.accountId, slug: e.slug }), JSON.stringify({ error: `No form "${e.slug}" is available for this account` });
  const c = { phone: ((S = t.customer) == null ? void 0 : S.phone) || t.toPhone || "" }, d = sn(s.questions, e.answers) ?? void 0, u = await n.bookingToken.findFirst({
    where: {
      accountId: t.accountId,
      customerId: t.customerId,
      formTemplateId: s.id,
      status: "ACTIVE",
      expiresAt: { gt: /* @__PURE__ */ new Date() }
    },
    orderBy: { createdAt: "desc" },
    select: { token: !0, context: !0 }
  });
  if (u)
    return await gn(n, u.token, {
      context: u.context,
      prefill: c,
      customPrefill: d
    }), (E = (A = i.logger) == null ? void 0 : A.log) == null || E.call(A, we, "reusing existing ACTIVE form link", {
      customerId: t.customerId,
      formId: s.id
    }), JSON.stringify({
      success: !0,
      formName: s.name,
      formUrl: `${t.frontendUrl}/book/${u.token}`,
      reused: !0
    });
  const l = await at(n, {
    accountId: t.accountId,
    customerId: t.customerId,
    formTemplateId: s.id,
    prefill: c,
    customPrefill: d
  }), m = `${t.frontendUrl}/book/${l.token}`;
  return (O = (k = i.logger) == null ? void 0 : k.log) == null || O.call(k, we, "form link created", { customerId: t.customerId, formId: s.id, formUrl: m }), JSON.stringify({ success: !0, formName: s.name, formUrl: m });
}
const Sr = 25, Er = 50;
async function kr(n, e, t, i = {}) {
  var s, c;
  const o = Math.max(1, Math.min(Math.floor(e.limit ?? Sr), Er)), [r, a] = await Promise.all([
    n.customer.count({ where: { accountId: t.accountId } }),
    n.customer.findMany({
      where: { accountId: t.accountId },
      // Postgres DESC sorts NULLs first, so never-seen customers used to lead
      // the "most recently seen" list in arbitrary order. Nulls go last, tied
      // by newest record.
      orderBy: [{ lastSeenAt: { sort: "desc", nulls: "last" } }, { createdAt: "desc" }],
      take: o,
      select: { id: !0, name: !0, phone: !0, address: !0, totalJobs: !0 }
    })
  ]);
  if ((c = (s = i.logger) == null ? void 0 : s.log) == null || c.call(s, "assistant-tools:list-customers", "list_customers", {
    returned: a.length,
    total: r
  }), r === 0)
    return JSON.stringify({ customers: [], totalCustomers: 0, message: "No customers on file yet." });
  for (const d of a) ae(i, d);
  return JSON.stringify({
    customers: a.map((d) => ({
      name: d.name,
      phone: d.phone,
      address: d.address,
      totalJobs: d.totalJobs
    })),
    totalCustomers: r,
    ...r > a.length ? { note: `Showing the ${a.length} most recently active of ${r} customers.` } : {}
  });
}
const Or = "assistant-tool:summarize-today";
async function _r(n, e, t, i = {}) {
  var m, f;
  const o = /* @__PURE__ */ new Date(), r = new Date(o.getFullYear(), o.getMonth(), o.getDate()), a = new Date(r);
  a.setDate(a.getDate() + 1);
  const [
    s,
    c,
    d,
    u,
    l
  ] = await Promise.all([
    n.job.findMany({
      where: {
        accountId: t.accountId,
        status: { in: [...le] }
      },
      orderBy: { createdAt: "asc" },
      take: 25,
      select: {
        id: !0,
        customerName: !0,
        description: !0,
        status: !0,
        createdAt: !0
      }
    }),
    n.invoice.count({
      where: { accountId: t.accountId, status: "DRAFT" }
    }),
    n.invoice.count({
      where: { accountId: t.accountId, status: "SENDING" }
    }),
    n.job.count({
      where: {
        accountId: t.accountId,
        status: "DONE",
        completedAt: { gte: r, lt: a }
      }
    }),
    n.message.count({
      where: {
        accountId: t.accountId,
        direction: "INBOUND",
        createdAt: { gte: new Date(o.getTime() - 1440 * 60 * 1e3) }
      }
    })
  ]);
  (f = (m = i.logger) == null ? void 0 : m.log) == null || f.call(m, Or, "summary built", {
    activeQueue: s.length,
    pendingReview: c,
    pendingConfirmation: d,
    completedToday: u,
    inboundLast24h: l
  });
  for (const h of s) me(i, h);
  return JSON.stringify({
    today: r.toISOString().slice(0, 10),
    activeQueueJobs: s.map((h) => Le(h)),
    pendingReviewInvoices: c,
    pendingConfirmationInvoices: d,
    jobsCompletedToday: u,
    inboundMessagesLast24h: l
  });
}
const $r = "assistant-tool:list-recent-conversations";
async function Dr(n, e, t, i = {}) {
  var s, c;
  const o = typeof e.limit == "number" && e.limit > 0 ? Math.min(e.limit, 50) : 10, r = await n.conversation.findMany({
    where: { accountId: t.accountId },
    orderBy: { lastMessageAt: "desc" },
    take: o,
    select: {
      id: !0,
      participantPhone: !0,
      lastMessageAt: !0,
      customer: { select: { name: !0 } },
      messages: {
        orderBy: { createdAt: "desc" },
        take: 1,
        select: { body: !0, direction: !0, createdAt: !0 }
      }
    }
  });
  (c = (s = i.logger) == null ? void 0 : s.log) == null || c.call(s, $r, "listed", { count: r.length });
  const a = r.map((d) => {
    var l, m, f;
    const u = d.messages[0];
    return {
      conversationId: d.id,
      customer: ((l = d.customer) == null ? void 0 : l.name) ?? d.participantPhone,
      lastMessageAt: ((f = (m = d.lastMessageAt) == null ? void 0 : m.toISOString) == null ? void 0 : f.call(m)) ?? null,
      lastMessagePreview: u ? {
        direction: u.direction,
        preview: typeof u.body == "string" ? u.body.slice(0, 120) : ""
      } : null
    };
  });
  return JSON.stringify({ conversations: a });
}
const Pr = "assistant-tool:list-pending-invoices";
async function Mr(n, e, t, i = {}) {
  var a, s;
  const o = await n.invoice.findMany({
    where: {
      accountId: t.accountId,
      status: { in: ["DRAFT", "SENDING"] }
    },
    orderBy: { createdAt: "desc" },
    take: 50,
    select: {
      id: !0,
      invoiceNumber: !0,
      customerName: !0,
      total: !0,
      status: !0,
      createdAt: !0
    }
  });
  (s = (a = i.logger) == null ? void 0 : a.log) == null || s.call(a, Pr, "listed", { count: o.length });
  const r = o.map((c) => Yo(c));
  for (const c of o) ee(i, c);
  return JSON.stringify({ invoices: r });
}
const Cr = "assistant-tool:send-booking-link-to-customer";
async function An(n, e, t, i = {}) {
  var s, c;
  if (!e.customerId && !e.customerName)
    return JSON.stringify({
      error: "Provide either customerId or customerName to generate a booking link."
    });
  let o = null;
  if (e.customerId ? o = await n.customer.findFirst({
    where: { id: e.customerId, accountId: t.accountId },
    select: { id: !0, name: !0, phone: !0, address: !0, street: !0, city: !0, state: !0, zip: !0 }
  }) : e.customerName && (o = await n.customer.findFirst({
    where: {
      accountId: t.accountId,
      name: { contains: e.customerName, mode: "insensitive" }
    },
    orderBy: { lastSeenAt: "desc" },
    select: { id: !0, name: !0, phone: !0, address: !0, street: !0, city: !0, state: !0, zip: !0 }
  })), !o)
    return (c = (s = i.logger) == null ? void 0 : s.warn) == null || c.call(s, Cr, "customer not found", { ...e, accountId: t.accountId }), JSON.stringify({
      error: `No customer found matching ${e.customerId ? `id ${e.customerId}` : `name "${e.customerName}"`}.`
    });
  const r = await Ar(
    n,
    {
      description: e.description,
      jobId: void 0,
      firstName: e.firstName,
      lastName: e.lastName,
      email: e.email,
      street: e.street,
      city: e.city,
      state: e.state,
      zip: e.zip
    },
    {
      accountId: t.accountId,
      conversationId: "",
      customerId: o.id,
      toPhone: o.phone,
      fromPhone: o.phone,
      customer: {
        id: o.id,
        name: o.name ?? "",
        phone: o.phone,
        address: o.address,
        totalJobs: 0,
        street: o.street,
        city: o.city,
        state: o.state,
        zip: o.zip,
        intakeComplete: !1
      },
      frontendUrl: t.frontendUrl
    },
    i
  );
  let a = !1;
  try {
    a = !JSON.parse(r).error;
  } catch {
    a = !1;
  }
  return a && ae(i, o), r;
}
async function ne(n, e, t) {
  const i = await n.account.findUnique({
    where: { id: e },
    select: { phone: !0, ownerPhone: !0 }
  });
  if (!(i != null && i.phone))
    return { error: "No Ten Four number is configured to send from." };
  let o = i.ownerPhone;
  if (t) {
    const r = await n.user.findFirst({
      where: { id: t, accountId: e },
      select: { mobilePhone: !0, role: !0, consentStatus: !0 }
    });
    if (r && r.role === "MEMBER" && r.consentStatus !== "opted_in")
      return {
        error: "That teammate hasn't opted in to text messages yet, so I can't text them. They can opt in when they set up their account (or by replying START)."
      };
    r != null && r.mobilePhone && (o = r.mobilePhone);
  }
  return o ? { phones: { phone: i.phone, toPhone: o } } : { error: "No personal phone on file to text." };
}
async function oe(n, e, t, i, o) {
  const r = `sms.reply:${o}:${e}:${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
  await zo(n, {
    accountId: e,
    fromPhone: t.phone,
    toPhone: t.toPhone,
    body: i,
    idempotencyKey: r,
    priority: 10
  });
}
const Rr = "assistant-tool:text-me-customer-info";
async function Ur(n, e, t, i = {}) {
  var s, c;
  if (!e.customerId && !e.customerName)
    return JSON.stringify({
      error: "Provide a customer id or name to text yourself their contact info."
    });
  const o = await ne(n, t.accountId, t.userId);
  if ("error" in o) return JSON.stringify(o);
  const r = e.customerId ? await n.customer.findFirst({
    where: { id: e.customerId, accountId: t.accountId },
    select: { name: !0, phone: !0, address: !0 }
  }) : await n.customer.findFirst({
    where: {
      accountId: t.accountId,
      name: { contains: e.customerName, mode: "insensitive" }
    },
    orderBy: { lastSeenAt: "desc" },
    select: { name: !0, phone: !0, address: !0 }
  });
  if (!r)
    return JSON.stringify({
      error: `No customer found matching ${e.customerId ? `id ${e.customerId}` : `"${e.customerName}"`}.`
    });
  const a = [r.name, r.phone, r.address].map((d) => d ? String(d).trim() : "").filter(Boolean).join(" · ");
  return await oe(n, t.accountId, o.phones, a, "customer-info"), (c = (s = i.logger) == null ? void 0 : s.log) == null || c.call(s, Rr, "queued account contact-info text", {
    accountId: t.accountId
  }), JSON.stringify({ success: !0, sentTo: "your phone", summary: a });
}
const Fr = "assistant-tool:text-me-my-queue";
async function jr(n, e, t, i = {}) {
  var c, d;
  const o = await ne(n, t.accountId, t.userId);
  if ("error" in o) return JSON.stringify(o);
  const r = await n.job.findMany({
    where: {
      accountId: t.accountId,
      status: { in: ["ACTIVE"] },
      // "My queue" (multi-user): a recognized teammate sees their assigned +
      // unassigned jobs; owner/legacy (no userId) sees the whole account.
      ...t.userId ? { OR: [{ assignedUserId: t.userId }, { assignedUserId: null }] } : {}
    },
    orderBy: { createdAt: "asc" },
    take: 25,
    select: { customerName: !0, description: !0, customerAddress: !0 }
  });
  if (r.length === 0)
    return JSON.stringify({ success: !1, message: "Your queue is empty." });
  const a = r.map((u, l) => {
    const m = [u.customerName, u.description, u.customerAddress].map((f) => f ? String(f).trim() : "").filter(Boolean);
    return `${l + 1}. ${m.join(" — ")}`;
  }), s = `Your queue (${r.length}):
${a.join(`
`)}`;
  return await oe(n, t.accountId, o.phones, s, "my-queue"), (d = (c = i.logger) == null ? void 0 : c.log) == null || d.call(c, Fr, "queued queue text", {
    accountId: t.accountId,
    count: r.length
  }), JSON.stringify({ success: !0, sentTo: "your phone", count: r.length });
}
const Jr = "assistant-tool:text-me-my-next-job";
async function Lr(n, e, t, i = {}) {
  var s, c;
  const o = await ne(n, t.accountId, t.userId);
  if ("error" in o) return JSON.stringify(o);
  const r = await n.job.findFirst({
    where: {
      accountId: t.accountId,
      status: { in: ["ACTIVE"] },
      // "My next job" (multi-user): a recognized teammate's next is their
      // assigned + unassigned oldest; owner/legacy (no userId) sees the whole
      // account. Mirrors text_me_my_queue / get_queue.
      ...t.userId ? { OR: [{ assignedUserId: t.userId }, { assignedUserId: null }] } : {}
    },
    orderBy: { createdAt: "asc" },
    select: { customerName: !0, customerAddress: !0, description: !0, urgency: !0 }
  });
  if (!r)
    return JSON.stringify({ success: !1, message: "No active jobs in your queue." });
  const a = `Next job: ${[
    r.customerName,
    r.customerAddress,
    r.description,
    r.urgency ? `urgency ${r.urgency}` : ""
  ].map((d) => d ? String(d).trim() : "").filter(Boolean).join(" · ")}`;
  return await oe(n, t.accountId, o.phones, a, "next-job"), (c = (s = i.logger) == null ? void 0 : s.log) == null || c.call(s, Jr, "queued next-job text", { accountId: t.accountId }), JSON.stringify({ success: !0, sentTo: "your phone" });
}
const Br = "assistant-tool:text-me-job-address";
async function qr(n, e, t, i = {}) {
  var s, c;
  if (!e.jobId && !e.customerName)
    return JSON.stringify({
      error: "Provide a job id or customer name to text yourself the address."
    });
  const o = await ne(n, t.accountId, t.userId);
  if ("error" in o) return JSON.stringify(o);
  const r = e.jobId ? await n.job.findFirst({
    where: { id: e.jobId, accountId: t.accountId },
    select: { customerName: !0, customerAddress: !0 }
  }) : await n.job.findFirst({
    where: {
      accountId: t.accountId,
      customerName: { contains: e.customerName, mode: "insensitive" },
      status: { in: ["ACTIVE"] }
    },
    orderBy: { createdAt: "desc" },
    select: { customerName: !0, customerAddress: !0 }
  });
  if (!r)
    return JSON.stringify({
      error: `No matching job found for ${e.jobId ? `id ${e.jobId}` : `"${e.customerName}"`}.`
    });
  if (!r.customerAddress)
    return JSON.stringify({ error: `No address on file for ${r.customerName}'s job.` });
  const a = `${r.customerName}: ${r.customerAddress}`;
  return await oe(n, t.accountId, o.phones, a, "job-address"), (c = (s = i.logger) == null ? void 0 : s.log) == null || c.call(s, Br, "queued job-address text", { accountId: t.accountId }), JSON.stringify({ success: !0, sentTo: "your phone" });
}
const Yr = "assistant-tool:text-me-payment-link", Hr = ["CANCELED", "QUOTE", "DRAFT", "SENDING", "PAID"];
async function Vr(n, e, t, i = {}) {
  var d, u;
  if (!e.invoiceId && !e.customerId && !e.customerName)
    return JSON.stringify({
      error: "Provide an invoice id, customer id, or customer name to text yourself a payment link."
    });
  const o = await ne(n, t.accountId, t.userId);
  if ("error" in o) return JSON.stringify(o);
  const r = {
    accountId: t.accountId,
    status: { notIn: Hr }
  };
  e.invoiceId ? r.id = e.invoiceId : e.customerId ? r.customerId = e.customerId : e.customerName && (r.customerName = { contains: e.customerName, mode: "insensitive" });
  const a = await n.invoice.findFirst({
    where: r,
    orderBy: { createdAt: "desc" },
    select: {
      invoiceNumber: !0,
      customerName: !0,
      total: !0,
      stripePaymentLinkUrl: !0,
      pdfUrl: !0
    }
  });
  if (!a)
    return JSON.stringify({
      error: `No unpaid invoice found for ${e.invoiceId ? `invoice ${e.invoiceId}` : e.customerId ? "that customer" : `"${e.customerName}"`}.`
    });
  const s = a.stripePaymentLinkUrl ?? a.pdfUrl;
  if (!s)
    return JSON.stringify({
      error: `${D(a.invoiceNumber)} has no payment link yet.`
    });
  const c = `Payment link for ${a.customerName} (${D(a.invoiceNumber)}, $${String(
    a.total
  )}): ${s}`;
  return await oe(n, t.accountId, o.phones, c, "payment-link"), (u = (d = i.logger) == null ? void 0 : d.log) == null || u.call(d, Yr, "queued payment-link text", { accountId: t.accountId }), JSON.stringify({ success: !0, sentTo: "your phone" });
}
const Wr = "assistant-tool:text-me-booking-link";
async function Kr(n, e, t, i = {}) {
  var d, u;
  if (!e.customerId && !e.customerName)
    return JSON.stringify({
      error: "Provide a customer id or name to text yourself a booking link."
    });
  const o = await ne(n, t.accountId, t.userId);
  if ("error" in o) return JSON.stringify(o);
  const r = await An(
    n,
    { customerId: e.customerId, customerName: e.customerName, description: e.description },
    { accountId: t.accountId, frontendUrl: t.frontendUrl },
    i
  ), a = JSON.parse(r);
  if (!a.bookingUrl)
    return r;
  const c = `Booking link for ${e.customerName ?? "your customer"}: ${a.bookingUrl}`;
  return await oe(n, t.accountId, o.phones, c, "booking-link"), (u = (d = i.logger) == null ? void 0 : d.log) == null || u.call(d, Wr, "queued booking-link text", { accountId: t.accountId }), JSON.stringify({ success: !0, sentTo: "your phone", bookingUrl: a.bookingUrl });
}
const zr = "assistant-tool:text-me-unread-messages";
async function Gr(n, e, t, i = {}) {
  var c, d, u, l;
  const o = await ne(n, t.accountId, t.userId);
  if ("error" in o) return JSON.stringify(o);
  const r = await n.conversation.findMany({
    where: {
      accountId: t.accountId,
      participantType: "CUSTOMER",
      messages: { some: { direction: "INBOUND" } }
    },
    orderBy: { lastMessageAt: "desc" },
    take: 50,
    select: {
      id: !0,
      participantPhone: !0,
      customer: { select: { name: !0 } },
      messages: {
        orderBy: { createdAt: "desc" },
        take: 1,
        select: { direction: !0, body: !0 }
      }
    }
  }), a = [];
  for (const m of r) {
    const f = (c = m.messages) == null ? void 0 : c[0];
    if (!f || f.direction !== "INBOUND") continue;
    const h = ((d = m.customer) == null ? void 0 : d.name) ?? m.participantPhone ?? "Unknown", I = typeof f.body == "string" ? f.body.slice(0, 80).trim() : "";
    a.push(I ? `${h}: ${I}` : h);
  }
  if (a.length === 0)
    return JSON.stringify({ success: !1, message: "No unread customer messages." });
  const s = `Waiting on a reply (${a.length}):
${a.join(`
`)}`;
  return await oe(n, t.accountId, o.phones, s, "unread-messages"), (l = (u = i.logger) == null ? void 0 : u.log) == null || l.call(u, zr, "queued unread-messages text", {
    accountId: t.accountId,
    count: a.length
  }), JSON.stringify({ success: !0, sentTo: "your phone", count: a.length });
}
const Qr = "assistant-tool:create-reminder";
async function Zr(n, e, t, i = {}) {
  var d, u, l;
  const o = (d = e.text) == null ? void 0 : d.trim();
  if (!o)
    return JSON.stringify({ error: "What should I remind you about? Provide the reminder text." });
  let r = e.customerId ?? null;
  if (r) {
    if (!await n.customer.findFirst({
      where: { id: r, accountId: t.accountId },
      select: { id: !0 }
    }))
      return JSON.stringify({ error: "That customer is not on this account account." });
  } else if (e.customerName) {
    const m = await n.customer.findFirst({
      where: {
        accountId: t.accountId,
        name: { contains: e.customerName, mode: "insensitive" }
      },
      orderBy: { lastSeenAt: "desc" },
      select: { id: !0 }
    });
    r = (m == null ? void 0 : m.id) ?? null;
  }
  let a = e.jobId ?? null;
  if (a) {
    const m = await n.job.findFirst({
      where: { id: a, accountId: t.accountId },
      select: { id: !0, customerId: !0 }
    });
    if (!m)
      return JSON.stringify({ error: "That job is not on this account account." });
    if (r && m.customerId !== r)
      return JSON.stringify({ error: "That job belongs to a different customer." });
    r = r ?? m.customerId;
  }
  const s = Xr(e.dueAt), c = await n.reminder.create({
    data: {
      accountId: t.accountId,
      // Per-user reminders: attach to the recognized teammate who asked Aria.
      userId: t.userId ?? null,
      text: o,
      dueAt: s,
      customerId: r,
      jobId: a
    },
    select: { id: !0 }
  });
  return (l = (u = i.logger) == null ? void 0 : u.log) == null || l.call(u, Qr, "reminder created", {
    accountId: t.accountId,
    reminderId: c.id,
    linkedCustomer: !!r
  }), JSON.stringify({ success: !0, reminderId: c.id });
}
function Xr(n) {
  if (!n) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(n))
    return /* @__PURE__ */ new Date(`${n}T12:00:00.000Z`);
  const e = new Date(n);
  return Number.isNaN(e.getTime()) ? null : e;
}
const xr = "assistant-tool:add-job-note";
async function ei(n, e, t, i = {}) {
  var d, u, l;
  const o = (d = e.note) == null ? void 0 : d.trim();
  if (!o)
    return JSON.stringify({ error: "What note should I add? Provide the note text." });
  if (!e.jobId && !e.customerName)
    return JSON.stringify({ error: "Which customer's job should I add that note to?" });
  const r = e.jobId ? await n.job.findFirst({
    where: { id: e.jobId, accountId: t.accountId },
    select: { id: !0, customerName: !0, notes: !0 }
  }) : await n.job.findFirst({
    where: {
      accountId: t.accountId,
      customerName: { contains: e.customerName, mode: "insensitive" },
      status: { in: ["ACTIVE"] }
    },
    orderBy: { createdAt: "desc" },
    select: { id: !0, customerName: !0, notes: !0 }
  });
  if (!r)
    return JSON.stringify({
      error: e.customerName ? `No active job found for ${e.customerName}.` : "No matching job found."
    });
  const s = `[${(/* @__PURE__ */ new Date()).toISOString().slice(0, 10)}] ${o}`, c = r.notes ? `${r.notes}
${s}` : s;
  return await n.job.update({ where: { id: r.id }, data: { notes: c } }), (l = (u = i.logger) == null ? void 0 : u.log) == null || l.call(u, xr, "job note appended", { accountId: t.accountId, jobId: r.id }), me(i, r), JSON.stringify({ success: !0, customerName: r.customerName });
}
const ti = "assistant-tool:message-customer", ni = 3600 * 1e3;
async function oi(n, e, t, i = {}) {
  var w, b;
  const o = (e.customerName ?? "").trim(), r = (e.messageText ?? "").trim(), a = t.confirmationMode ?? "reply";
  if (!o)
    return JSON.stringify({ error: "Which customer? Provide the customer name to text." });
  if (!r)
    return JSON.stringify({ error: "Nothing to send — provide the message text to relay." });
  if (r.length > 1500)
    return JSON.stringify({ error: "That message is too long. Keep it to 1,500 characters or fewer." });
  if (!t.confirmInline && a === "reply" && !t.conversationId)
    return JSON.stringify({ error: "Can't set up the confirmation here — ask the account holder to text the customer directly." });
  const s = await n.account.findUnique({
    where: { id: t.accountId },
    select: { name: !0, businessName: !0, phone: !0, allowAgentTextCustomers: !0 }
  });
  if (!s || s.allowAgentTextCustomers !== !0)
    return JSON.stringify({
      error: "Texting customers on your behalf is turned off in your Ten Four settings, so I can't send that. You can turn it on under Preferences."
    });
  const c = ((s == null ? void 0 : s.name) ?? "").trim().split(/\s+/)[0], d = ((s == null ? void 0 : s.businessName) ?? "").trim(), u = (g) => g.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), l = d ? r.replace(new RegExp(`\\bthis is ${u(d)}\\b`, "ig"), "") : r, m = !!c && new RegExp(`\\bthis is ${u(c)}\\b`, "i").test(l) || !!(s != null && s.name) && new RegExp(`\\bthis is ${u(s.name)}\\b`, "i").test(l), f = /\bi['']?(?:ll|m)\b|\bi (?:will|am)\b/i.test(r);
  if (m || f)
    return JSON.stringify({
      error: `That draft is written as ${c || "the account holder"} in the first person — the customer must not think they are texting them. Rewrite it as ${(s == null ? void 0 : s.businessName) ?? "the business"} in the THIRD person: open with "Hi <customer>, this is ${(s == null ? void 0 : s.businessName) ?? "the business"}", refer to ${c || "the account holder"} as "he/she/they" (e.g. "${c || "they"} will give you a call…"), and use NO first-person "I". Then call message_customer again.`
    });
  const h = await n.customer.findFirst({
    where: {
      accountId: t.accountId,
      name: { contains: o, mode: "insensitive" }
    },
    orderBy: { lastSeenAt: "desc" },
    select: { id: !0, name: !0, phone: !0, doNotText: !0, consentStatus: !0 }
  });
  if (!h)
    return (b = (w = i.logger) == null ? void 0 : w.warn) == null || b.call(w, ti, "customer not found", { accountId: t.accountId }), JSON.stringify({ error: `No customer found named "${o}".` });
  if (h.doNotText || h.consentStatus === "opted_out")
    return JSON.stringify({
      error: `${h.name ?? "That customer"} has opted out of texts, so I can't message them. You'd need to reach them another way.`
    });
  const I = await n.conversation.findFirst({
    where: { accountId: t.accountId, customerId: h.id, type: "SMS" },
    orderBy: { lastMessageAt: "desc" },
    select: { id: !0 }
  });
  if (!I)
    return JSON.stringify({
      error: `I don't have an active text thread with ${h.name ?? o} to send to. They'd need to text in first, or you can reach them directly.`
    });
  if (!t.confirmInline && a === "portal") {
    if (!i.customerMessageDraft)
      return JSON.stringify({
        error: "Can't open the message preview here — ask the account holder to use the Messages page."
      });
    const g = t.assistantConversationId ? await n.assistantHandoffRequest.findFirst({
      where: {
        accountId: t.accountId,
        assistantConversationId: t.assistantConversationId,
        status: { in: ["OPEN", "ANSWERED", "READY_TO_CONFIRM"] }
      },
      select: { id: !0 }
    }) : null;
    return i.customerMessageDraft({
      conversationId: I.id,
      customerName: h.name ?? o,
      body: r,
      ...g ? { handoffRequestId: g.id } : {}
    }), g && await n.assistantHandoffRequest.update({
      where: { id: g.id },
      data: {
        status: "AWAITING_CUSTOMER_SEND",
        customerReplyConversationId: I.id,
        resolutionSummary: `Prepared a reply for ${h.name ?? o}; waiting for the owner to send it.`
      }
    }), JSON.stringify({
      status: "awaiting_portal_confirmation",
      customer: h.name ?? o,
      draft: r,
      instruction: `Draft ready — NOT sent yet. Tell the account holder the editable preview for ${h.name ?? o} is ready below, where they can review, edit, and send it.`
    });
  }
  if (t.confirmInline) {
    if (!(s != null && s.phone))
      return JSON.stringify({ error: "No Ten Four number is configured to send from." });
    const g = await n.message.create({
      data: {
        conversationId: I.id,
        accountId: t.accountId,
        direction: "OUTBOUND",
        senderType: "SYSTEM",
        fromNumber: s.phone,
        toNumber: h.phone,
        body: r,
        status: "processing",
        toolCall: { name: "message_customer", arguments: { customerName: h.name ?? o, channel: "voice" } }
      },
      select: { id: !0 }
    });
    return await n.outbox.upsert({
      where: { idempotencyKey: `sms.reply:${g.id}` },
      create: {
        aggregateType: "message",
        aggregateId: g.id,
        eventType: "sms.reply",
        payload: {
          messageId: g.id,
          to: h.phone,
          from: s.phone,
          body: r,
          accountId: t.accountId,
          recipientType: "customer"
        },
        idempotencyKey: `sms.reply:${g.id}`,
        accountId: t.accountId,
        priority: 10
      },
      update: {}
    }), Ho(i, {
      id: I.id,
      customerName: h.name ?? o
    }), JSON.stringify({
      status: "sent",
      customer: h.name ?? o,
      sent: r,
      instruction: `Sent. Briefly tell the caller you've texted ${h.name ?? o} that message. Do NOT read it back again.`
    });
  }
  return await n.pendingAction.updateMany({
    where: { conversationId: t.conversationId, type: "SEND_CUSTOMER_MESSAGE", resolved: !1 },
    data: { resolved: !0, resolvedWith: "SUPERSEDED", resolvedAt: /* @__PURE__ */ new Date() }
  }), await n.pendingAction.create({
    data: {
      accountId: t.accountId,
      conversationId: t.conversationId,
      type: "SEND_CUSTOMER_MESSAGE",
      payload: {
        customerId: h.id,
        customerPhone: h.phone,
        customerName: h.name ?? o,
        customerConversationId: I.id,
        messageText: r
      },
      validResponses: ["YES", "NO"],
      actor: "CONTRACTOR",
      expiresAt: new Date(Date.now() + ni)
    }
  }), JSON.stringify({
    status: "awaiting_confirmation",
    customer: h.name ?? o,
    draft: r,
    instruction: `Draft ready — NOT sent yet. Tell the account holder you'll text ${h.name ?? o} this exact message: "${r}", and that it sends as soon as they reply YES (NO to cancel, or tell you what to change).`
  });
}
async function ri(n, e, t) {
  const i = (e.resolutionSummary ?? "").trim();
  if (!t.assistantConversationId)
    return JSON.stringify({ error: "No correlated handoff is active in this thread." });
  if (!i)
    return JSON.stringify({ error: "resolutionSummary is required before completing a handoff." });
  const o = await n.assistantHandoffRequest.findFirst({
    where: {
      accountId: t.accountId,
      assistantConversationId: t.assistantConversationId
    },
    select: { id: !0, status: !0 }
  });
  return o ? o.status === "AWAITING_CUSTOMER_SEND" ? JSON.stringify({
    error: "The customer reply is only drafted. Keep this handoff open until the owner presses Send."
  }) : o.status === "RESOLVED" || o.status === "DISMISSED" ? JSON.stringify({ ok: !0, status: o.status, duplicate: !0 }) : (await n.assistantHandoffRequest.update({
    where: { id: o.id },
    data: { status: "READY_TO_CONFIRM", resolutionSummary: i }
  }), JSON.stringify({
    ok: !0,
    status: "READY_TO_CONFIRM",
    instruction: "Now tell the owner what you completed. The request resolves only after that confirmation is saved."
  })) : JSON.stringify({ error: "No correlated handoff is active in this thread." });
}
const X = "---";
function ii(n) {
  const e = n.trim();
  if (e === "true") return !0;
  if (e === "false") return !1;
  if (/^-?\d+(\.\d+)?$/.test(e)) return Number(e);
  if (e.startsWith('"') && e.endsWith('"') && e.length >= 2 || e.startsWith("'") && e.endsWith("'") && e.length >= 2) {
    if (e.startsWith('"'))
      try {
        return JSON.parse(e);
      } catch {
        return e.slice(1, -1);
      }
    return e.slice(1, -1);
  }
  return e;
}
function H(n) {
  const e = n.replace(/^﻿/, "").replace(/\r\n?/g, `
`), t = {};
  if (!e.startsWith(`${X}
`))
    return { frontmatter: Ye(t), body: e, hadFrontmatter: !1 };
  const i = e.indexOf(`
${X}`, X.length);
  if (i === -1)
    return { frontmatter: Ye(t), body: e, hadFrontmatter: !1 };
  const o = e.slice(X.length + 1, i), r = e.slice(i + X.length + 1).replace(/^\n+/, "");
  for (const a of o.split(`
`)) {
    const s = a.trim();
    if (!s || s.startsWith("#")) continue;
    const c = s.indexOf(":");
    if (c <= 0) continue;
    const d = s.slice(0, c).trim();
    /^[A-Za-z_][A-Za-z0-9_]*$/.test(d) && (t[d] = ii(s.slice(c + 1)));
  }
  return { frontmatter: Ye(t), body: r, hadFrontmatter: !0 };
}
function Ye(n) {
  const e = { ...n, sensitive: n.sensitive === !0 };
  return typeof n.title == "number" && (e.title = String(n.title)), n.enabled !== void 0 && (e.enabled = n.enabled !== !1), e;
}
function si(n) {
  return typeof n == "boolean" || typeof n == "number" ? String(n) : n === "" || /^[\s"'#:>|\-?&*!%@`[\]{},]/.test(n) || /[\n:#]/.test(n) || n !== n.trim() || /^(true|false|null|~|-?\d+(\.\d+)?)$/i.test(n) ? JSON.stringify(n) : n;
}
const ai = ["title", "sensitive", "enabled", "updated_by", "updated_at", "source"];
function Yt(n, e) {
  const t = {};
  for (const r of ai) {
    const a = n[r];
    a !== void 0 && (t[r] = a);
  }
  for (const [r, a] of Object.entries(n))
    a === void 0 || r in t || (t[r] = a);
  t.sensitive === void 0 && (t.sensitive = !1);
  const i = Object.entries(t).map(([r, a]) => `${r}: ${si(a)}`), o = e.replace(/\r\n?/g, `
`).replace(/^\n+/, "");
  return `${X}
${i.join(`
`)}
${X}

${o.endsWith(`
`) || o === "" ? o : `${o}
`}`;
}
class C extends Error {
  constructor(e) {
    super(e), this.name = "MemoryPathError";
  }
}
const ci = /^[A-Za-z0-9][A-Za-z0-9._-]*$/, Ht = 240, Vt = 8;
function U(n, e = {}) {
  if (typeof n != "string") {
    if (e.allowRoot && (n == null || n === "")) return "";
    throw new C("A path is required.");
  }
  let t = n.trim().replace(/\\/g, "/");
  for (; t.startsWith("./"); ) t = t.slice(2);
  if (t = t.replace(/\/+/g, "/"), t.startsWith("/") && (t = t.slice(1)), t.endsWith("/") && (t = t.slice(0, -1)), t === "" || t === ".") {
    if (e.allowRoot) return "";
    throw new C("A file path is required (the root is a directory).");
  }
  if (t.length > Ht)
    throw new C(`Path is too long (max ${Ht} characters).`);
  const i = t.split("/");
  if (i.length > Vt)
    throw new C(`Path is nested too deep (max ${Vt} levels).`);
  for (const o of i) {
    if (o === ".." || o === ".")
      throw new C('Relative segments ("." / "..") are not allowed.');
    if (!ci.test(o))
      throw new C(
        `"${o}" is not a valid name — use letters, digits, ".", "_" or "-" and start with a letter or digit.`
      );
  }
  return i.join("/");
}
function ga(n) {
  const e = n.lastIndexOf("/");
  return e === -1 ? "" : n.slice(0, e);
}
function De(n) {
  const e = n.lastIndexOf("/");
  return e === -1 ? n : n.slice(e + 1);
}
function J(n) {
  return /\.(md|markdown)$/i.test(n);
}
function Wt(n) {
  return /\.(md|markdown|txt|csv|json|yaml|yml)$/i.test(n);
}
function Te(n) {
  return n.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 80);
}
const L = "system", Sn = [
  {
    path: "README.md",
    frontmatter: { title: "Memory — root guide", sensitive: !1, updated_by: L },
    body: "# Memory\n\nThis tree is the business's shared long-term memory. Aria (the owner's assistant), Lyra (the customer-facing receptionist), Scribe, and the owner all read and write it. Live records — jobs, invoices, customers' contact details, the queue — are NOT here; they live in the system and are reached through the job/invoice/customer tools. Memory holds what those records cannot: how the business works, what it sells, how the owner wants things done, and what has been learned about people over time.\n\n## Layout\n\n| Directory | What lives there |\n|---|---|\n| `business_knowledge/` | Facts about the business: services and pricing (`services.md`), preferences (`preferences.md`), the playbook (`playbook.md`), and any reference documents the owner uploads. |\n| `forms/` | One document per form the business sends: its fields, which are required, and when to send it. |\n| `customers/` | One document per customer relationship — preferences, access notes, open threads. |\n| `team/` | Who is on the team and what each person handles. |\n| `meetings/` | Dated meeting notes. |\n| `notes/` | Dated notes Aria and Scribe write that fit nowhere else. |\n\n## How to find things\n\n- Start with `memory_tree` for the shape, then `memory_ls` on a directory.\n- Every directory has a `README.md` that says what belongs there and how it is organized — read it before writing into that directory.\n- `memory_grep` searches document text across the tree (or under one directory). Read the matching file with `memory_cat` before relying on it.\n- Prefer updating an existing document over creating a near-duplicate. Use `memory_append` for dated additions and `memory_write` to replace.\n\n## Conventions\n\n- Markdown only for documents you write. Filenames are kebab-case; dated files are `YYYY-MM-DD--slug.md`.\n- Every document may carry frontmatter: `title`, `sensitive` (true/false), `updated_by`, `updated_at`.\n- Mark a document `sensitive: true` when it holds anything a customer must never hear: access codes, pricing floors, internal notes about people, disputes.\n\n## Sensitivity\n\nReads always return the document's `sensitive` flag. A sensitive document may inform an answer but its contents are never repeated to a customer. When unsure, treat a document as sensitive.\n"
  },
  {
    path: "business_knowledge/README.md",
    frontmatter: { title: "Business knowledge — guide", sensitive: !1, updated_by: L },
    body: `# Business knowledge

Durable facts about the business itself. This is the first place to look for "what do we charge", "do we do X", "how does the owner want this handled".

## Files

- \`owner-introduction.md\` — the owner’s setup conversation: what they do, where they work, and how they prefer to work. Created when setup is completed. Read this before asking the owner for those details again.
- \`services.md\` — the service catalog: what the business sells, with pricing rules in a table and any prose that explains them (minimums, per-unit rates, what is quoted on site). This is the source of truth for services.
- \`preferences.md\` — how the owner wants things done: scheduling windows, tone, what to confirm before acting, suppliers they prefer.
- \`playbook.md\` — recurring procedures and know-how: how a typical job runs, what to ask a new caller, seasonal rules.
- Any other \`<name>.md\` here is a reference document (policies, FAQs, warranties, pricing sheets). Its filename stem is also its prompt tag: a persona prompt that contains \`{name}\` receives the document's text at that position.

## How to find things

Use \`memory_grep\` here first — most business questions are answered by a line in one of these files. Read the whole file with \`memory_cat\` before quoting a price or a policy.

## Writing here

When the owner tells you something durably true about the business, record it in the right file (append a short dated line, or edit the section it belongs to). Do not put per-customer or per-job details here — those go to \`customers/\` or the job itself.

## Sensitivity

Most of this directory is safe to share with customers (prices, hours, policies). Anything internal — cost basis, margins, supplier terms, negotiating floors — goes in a file marked \`sensitive: true\`.
`
  },
  {
    path: "business_knowledge/services.md",
    frontmatter: { title: "Services", sensitive: !1, updated_by: L },
    body: `# Services

The service catalog. The table is the read model the app shows and the personas quote from; the prose below it explains how pricing works when a single number is not enough.

| Service | Price | Taxable | Description |
|---|---|---|---|

## Pricing notes

_None yet. Add rules here in plain language, e.g. "Carpet install is $4.50 per sq yd with a $300 minimum" or "Emergency calls after 6pm add $75"._
`
  },
  {
    path: "business_knowledge/preferences.md",
    frontmatter: { title: "Preferences", sensitive: !1, updated_by: L },
    body: `# Preferences

How the owner wants things done. One line per preference; date the line when it changes.

_Nothing recorded yet._
`
  },
  {
    path: "business_knowledge/playbook.md",
    frontmatter: { title: "Playbook", sensitive: !1, updated_by: L },
    body: `# Playbook

Recurring procedures and know-how: how a typical job runs, what to ask a new caller, what to check before quoting.

_Nothing recorded yet._
`
  },
  {
    path: "forms/README.md",
    frontmatter: { title: "Forms — guide", sensitive: !1, updated_by: L },
    body: `# Forms

One document per form the business can send a customer. Each file lists the form's fields, which are required, and when to send it. These files are mirrored from the Forms settings — edit the form there, not here.

## How to find things

\`memory_ls forms\` lists every form. The booking form is the one a new customer fills in to request work; other forms (surveys, intake sheets) are sent by name when the conversation calls for them.

## Sensitivity

Form definitions are not sensitive. Submitted answers are never stored here.
`
  },
  {
    path: "customers/README.md",
    frontmatter: { title: "Customers — guide", sensitive: !1, updated_by: L },
    body: `# Customers

One document per customer relationship, named \`<customer-slug>--<customer-id>.md\`. The stable ID suffix keeps two customers with the same name from ever sharing a file. It holds what the business has learned about working with that person: preferences, access notes (gate codes, where the key is, the dog), relationship history, open threads, and hard rules ("never auto-book").

Contact details, jobs, and invoices are NOT here — use the customer and job tools for those.

## How to find things

\`memory_grep\` a name or a detail across this directory, then \`memory_cat\` the file. If no file exists yet, the customer tools still have the record; create the file only when there is something durable to remember.

## Writing here

Record facts the customer stated, dated, in the matching section. Never record dollar amounts, dates, or job status — those live in the system.

## Sensitivity

Every customer document is \`sensitive: true\` by default: it is about a specific person. Its contents are for the business and for that customer only — never repeat one customer's notes to another caller.
`
  },
  {
    path: "team/README.md",
    frontmatter: { title: "Team — guide", sensitive: !1, updated_by: L },
    body: `# Team

Who is on the team and what each person handles. \`members.md\` lists members and roles; add a \`<name>.md\` for anyone with notes worth keeping (coverage, specialties, how they like to be reached internally).

## Sensitivity

Names and roles are fine to share ("Mike handles scheduling"). Personal phone numbers, pay, and performance notes are sensitive — keep them in a file marked \`sensitive: true\`.
`
  },
  {
    path: "team/members.md",
    frontmatter: { title: "Team members", sensitive: !1, updated_by: L },
    body: `# Team members

| Name | Role | Handles |
|---|---|---|
`
  },
  {
    path: "meetings/README.md",
    frontmatter: { title: "Meetings — guide", sensitive: !1, updated_by: L },
    body: `# Meetings

Dated meeting notes, one file per meeting: \`YYYY-MM-DD--slug.md\`. Lead with who attended and the decisions made; keep the detail below.

## How to find things

Newest first by filename. \`memory_grep\` a topic or a name to find the meeting that discussed it.

## Sensitivity

Meeting notes are internal. Mark a file \`sensitive: true\` when it discusses a customer dispute, pricing strategy, or a team member.
`
  },
  {
    path: "notes/README.md",
    frontmatter: { title: "Notes — guide", sensitive: !1, updated_by: L },
    body: "# Notes\n\nDated notes that fit nowhere else — things Aria or Scribe captured that are worth keeping but are not (yet) a business fact, a customer fact, or a procedure. Files are `YYYY-MM-DD--slug.md`.\n\nWhen a note turns out to be durable, move its substance into `business_knowledge/`, `customers/`, or `team/` and leave a one-line pointer here.\n\n## Sensitivity\n\nDefault not sensitive; mark a note `sensitive: true` when it is about a specific person or money.\n"
  }
], wa = new Set(Sn.map((n) => n.path));
class En extends Error {
  constructor(e, t, i) {
    super(e), this.usedBytes = t, this.limitBytes = i, this.name = "MemoryQuotaError";
  }
}
class Pe extends Error {
  constructor(e) {
    super(`No file at ${e}`), this.name = "MemoryNotFoundError";
  }
}
const Kt = 6, ui = 200, zt = 240, He = 4e4;
class va {
  constructor(e) {
    Q(this, "accountId");
    Q(this, "storage");
    Q(this, "prisma");
    Q(this, "now");
    Q(this, "logger");
    Q(this, "seeded", !1);
    if (!e.accountId) throw new Error("MemoryFs requires an accountId");
    this.accountId = e.accountId, this.storage = e.storage, this.prisma = e.prisma, this.now = e.now ?? (() => /* @__PURE__ */ new Date()), this.logger = e.logger;
  }
  // ── keys ──────────────────────────────────────────────────────────────────
  key(e) {
    return e === "" ? this.accountId : `${this.accountId}/${e}`;
  }
  rel(e) {
    const t = `${this.accountId}/`;
    return e.startsWith(t) ? e.slice(t.length) : e;
  }
  async listAll(e) {
    const t = e === "" ? `${this.accountId}/` : `${this.accountId}/${e}/`;
    return (await this.storage.list(t)).filter((o) => o.key.startsWith(`${this.accountId}/`));
  }
  // ── seeding ───────────────────────────────────────────────────────────────
  /**
   * Write every seed document that is missing. Idempotent and cheap after the
   * first call per instance (one HEAD-equivalent download of the root README).
   */
  async ensureSeeded() {
    var o, r;
    if (this.seeded) return { seeded: !1, written: [] };
    if (await this.storage.download(this.key("README.md")))
      return this.seeded = !0, { seeded: !1, written: [] };
    const t = new Set((await this.listAll("")).map((a) => this.rel(a.key))), i = [];
    for (const a of Sn)
      t.has(a.path) || (await this.write(a.path, a.body, {
        updatedBy: a.frontmatter.updated_by ?? "system",
        title: a.frontmatter.title,
        sensitive: a.frontmatter.sensitive
      }), i.push(a.path));
    return this.seeded = !0, (r = (o = this.logger) == null ? void 0 : o.log) == null || r.call(o, "memory-fs", "seeded memory tree", { accountId: this.accountId, files: i.length }), { seeded: i.length > 0, written: i };
  }
  // ── reads ─────────────────────────────────────────────────────────────────
  async exists(e) {
    const t = U(e);
    return await this.storage.download(this.key(t)) != null;
  }
  /** Direct children of `dir` (files + subdirectories), dirs first. */
  async ls(e = "", t = {}) {
    const i = U(e, { allowRoot: !0 });
    await this.ensureSeeded();
    const o = await this.listAll(i), r = /* @__PURE__ */ new Map(), a = i === "" ? "" : `${i}/`;
    for (const c of o) {
      const d = this.rel(c.key);
      if (t.allowPath && !t.allowPath(d)) continue;
      const u = d.slice(a.length), l = u.indexOf("/");
      if (l === -1)
        r.set(u, {
          path: `${a}${u}`,
          name: u,
          kind: "file",
          size: c.size,
          updatedAt: c.updatedAt
        });
      else {
        const m = u.slice(0, l);
        r.has(m) || r.set(m, { path: `${a}${m}`, name: m, kind: "dir" });
      }
    }
    const s = [...r.values()].sort(
      (c, d) => c.kind === d.kind ? c.name.localeCompare(d.name) : c.kind === "dir" ? -1 : 1
    );
    return await this.decorateSensitive(s), s;
  }
  /** Nested listing from `dir` to `depth` levels. */
  async tree(e = "", t = Kt, i = {}) {
    const o = U(e, { allowRoot: !0 });
    await this.ensureSeeded();
    const r = await this.listAll(o), a = [], s = Math.max(1, Math.min(t, Kt)), c = o === "" ? "" : `${o}/`;
    for (const m of r) {
      const f = this.rel(m.key);
      if (i.allowPath && !i.allowPath(f)) continue;
      const I = f.slice(c.length).split("/");
      let w = a, b = c.slice(0, -1);
      for (let g = 0; g < I.length; g += 1) {
        const S = I[g];
        b = b ? `${b}/${S}` : S;
        const A = g === I.length - 1;
        if (g >= s) break;
        let E = w.find((k) => k.name === S);
        E || (E = A ? { path: b, name: S, kind: "file", size: m.size, updatedAt: m.updatedAt } : { path: b, name: S, kind: "dir", children: [] }, w.push(E)), A || (w = E.children ?? (E.children = []));
      }
    }
    const d = (m) => {
      m.sort((f, h) => f.kind === h.kind ? f.name.localeCompare(h.name) : f.kind === "dir" ? -1 : 1);
      for (const f of m) f.children && d(f.children);
    };
    d(a);
    const u = [], l = (m) => {
      for (const f of m)
        f.kind === "file" && u.push(f), f.children && l(f.children);
    };
    return l(a), await this.decorateSensitive(u), a;
  }
  /**
   * Stamp `sensitive` on markdown file nodes by reading their frontmatter.
   * Bounded: only the first 60 markdown files of a listing are inspected so a
   * huge directory cannot turn a listing into hundreds of downloads.
   */
  async decorateSensitive(e) {
    const t = e.filter((i) => i.kind === "file" && J(i.path)).slice(0, 60);
    await Promise.all(
      t.map(async (i) => {
        const o = await this.storage.download(this.key(i.path));
        o && (i.sensitive = H(o.bytes.toString("utf8")).frontmatter.sensitive);
      })
    );
  }
  async stat(e) {
    const t = U(e, { allowRoot: !0 });
    if (await this.ensureSeeded(), t === "") return { path: "", kind: "dir", size: 0, updatedAt: null, sensitive: !1 };
    const i = await this.storage.download(this.key(t));
    if (i) {
      const a = J(t) ? H(i.bytes.toString("utf8")).frontmatter : void 0;
      return {
        path: t,
        kind: "file",
        size: i.bytes.length,
        updatedAt: a != null && a.updated_at ? String(a.updated_at) : null,
        contentType: i.contentType,
        frontmatter: a,
        sensitive: (a == null ? void 0 : a.sensitive) === !0
      };
    }
    const o = await this.listAll(t);
    return o.length === 0 ? null : {
      path: t,
      kind: "dir",
      size: o.reduce((r, a) => r + a.size, 0),
      updatedAt: null,
      sensitive: !1
    };
  }
  async cat(e, t = {}) {
    const i = U(e);
    await this.ensureSeeded();
    const o = await this.storage.download(this.key(i));
    if (!o) throw new Pe(i);
    const r = Math.max(200, Math.min(t.maxChars ?? He, He));
    if (!Wt(i)) {
      const d = `${i}.md`, u = await this.storage.download(this.key(d)), l = u ? H(u.bytes.toString("utf8")).frontmatter : { sensitive: !1 };
      return {
        path: i,
        kind: "binary",
        title: typeof l.title == "string" ? l.title : De(i),
        sensitive: l.sensitive === !0,
        frontmatter: l,
        updatedBy: typeof l.updated_by == "string" ? l.updated_by : void 0,
        updatedAt: l.updated_at ? String(l.updated_at) : null,
        size: o.bytes.length,
        content: "",
        truncated: !1,
        contentType: o.contentType,
        sidecar: u ? d : void 0
      };
    }
    const a = o.bytes.toString("utf8"), s = J(i) ? H(a) : { frontmatter: { sensitive: !1 }, body: a }, c = s.body.length > r;
    return {
      path: i,
      kind: J(i) ? "markdown" : "text",
      title: typeof s.frontmatter.title == "string" ? s.frontmatter.title : De(i),
      sensitive: s.frontmatter.sensitive === !0,
      frontmatter: s.frontmatter,
      updatedBy: typeof s.frontmatter.updated_by == "string" ? s.frontmatter.updated_by : void 0,
      updatedAt: s.frontmatter.updated_at ? String(s.frontmatter.updated_at) : null,
      size: o.bytes.length,
      content: c ? `${s.body.slice(0, r)}

[Truncated — use memory_head with an offset or read a narrower file]` : s.body,
      truncated: c,
      contentType: o.contentType
    };
  }
  async head(e, t = 20, i = 0) {
    const o = await this.cat(e, { maxChars: He }), r = Math.max(1, Math.min(t, 400)), a = Math.max(0, i), s = o.content.split(`
`), c = s.slice(a, a + r);
    return {
      ...o,
      content: c.join(`
`),
      truncated: a + r < s.length || o.truncated,
      totalLines: s.length
    };
  }
  async grep(e, t = {}) {
    const i = e.trim();
    if (!i) throw new C("A search pattern is required.");
    const o = U(t.dir ?? "", { allowRoot: !0 });
    await this.ensureSeeded();
    const r = t.ignoreCase !== !1, a = Math.max(1, Math.min(t.maxResults ?? 30, 100)), s = (await this.listAll(o)).filter((l) => {
      const m = this.rel(l.key);
      return Wt(m) && l.size <= Be && (!t.allowPath || t.allowPath(m));
    }), c = s.slice(0, ui), d = [], u = r ? i.toLowerCase() : i;
    for (const l of c) {
      if (d.length >= a) break;
      const m = await this.storage.download(l.key);
      if (!m) continue;
      const f = this.rel(l.key), h = m.bytes.toString("utf8"), I = J(f) ? H(h) : { frontmatter: { sensitive: !1 }, body: h }, w = I.body.split(`
`);
      for (let b = 0; b < w.length && d.length < a; b += 1) {
        const g = w[b];
        (r ? g.toLowerCase() : g).includes(u) && d.push({
          path: f,
          line: b + 1,
          text: g.length > zt ? `${g.slice(0, zt)}…` : g,
          sensitive: I.frontmatter.sensitive === !0
        });
      }
    }
    return {
      matches: d,
      filesSearched: c.length,
      truncated: d.length >= a || s.length > c.length
    };
  }
  // ── writes ────────────────────────────────────────────────────────────────
  /** Create or overwrite a markdown document (frontmatter is (re)stamped). */
  async write(e, t, i) {
    return await this.writeDocument(e, t, i, !1);
  }
  /** Atomic first import. Null means another document won; its bytes are never replaced. */
  async writeIfAbsent(e, t, i) {
    return this.writeDocument(e, t, i, !0);
  }
  async writeDocument(e, t, i, o) {
    const r = U(e);
    if (!J(r))
      throw new C("Documents must be markdown files (end the path with .md).");
    const a = await this.storage.download(this.key(r));
    if (o && a) return null;
    const s = a ? H(a.bytes.toString("utf8")).frontmatter : void 0, c = H(t), d = {
      ...s ?? {},
      ...c.hadFrontmatter ? c.frontmatter : {},
      ...i.extra ?? {},
      title: i.title ?? (c.hadFrontmatter && typeof c.frontmatter.title == "string" ? c.frontmatter.title : s == null ? void 0 : s.title) ?? di(c.body, r),
      sensitive: i.sensitive ?? (c.hadFrontmatter ? c.frontmatter.sensitive : void 0) ?? (s == null ? void 0 : s.sensitive) ?? !1,
      updated_by: i.updatedBy,
      updated_at: this.now().toISOString()
    };
    i.enabled !== void 0 && (d.enabled = i.enabled);
    const u = Yt(d, c.body), l = Buffer.from(u, "utf8");
    if (l.length > Be)
      throw new C(
        `That document is too large (${l.length} bytes; max ${Be}). Split it into smaller files.`
      );
    return await this.putObject(r, l, "text/markdown; charset=utf-8", (a == null ? void 0 : a.bytes.length) ?? 0, o) ? { path: r, created: !a, bytes: l.length, sensitive: d.sensitive } : null;
  }
  /** Append text to a markdown document (created if missing), keeping its frontmatter. */
  async append(e, t, i) {
    const o = U(e);
    if (!J(o))
      throw new C("Documents must be markdown files (end the path with .md).");
    const r = await this.storage.download(this.key(o)), a = r ? H(r.bytes.toString("utf8")) : { frontmatter: { sensitive: !1 }, body: "" }, s = t.replace(/\r\n?/g, `
`).trim(), c = a.body.trimEnd() ? `${a.body.trimEnd()}

${s}
` : `${s}
`;
    return this.write(o, Yt(a.frontmatter, c), {
      ...i,
      title: i.title ?? (typeof a.frontmatter.title == "string" ? a.frontmatter.title : void 0),
      sensitive: i.sensitive ?? a.frontmatter.sensitive
    });
  }
  /** Create a directory by writing its README.md guide (object storage has no empty dirs). */
  async mkdir(e, t) {
    var s;
    const i = U(e);
    if (J(i)) throw new C("A directory name cannot end with .md.");
    const o = `${i}/README.md`;
    if (await this.storage.download(this.key(o)))
      return { path: o, created: !1, bytes: 0, sensitive: !1 };
    const r = De(i), a = ((s = t.guide) == null ? void 0 : s.trim()) || `# ${nt(r)}

What lives here: _describe the kind of document this directory holds_.

How to find things: files are named by subject (kebab-case); dated files are \`YYYY-MM-DD--slug.md\`.

Sensitivity: _say whether documents here may be shared with customers_.
`;
    return this.write(o, a, { ...t, title: t.title ?? `${nt(r)} — guide`, sensitive: t.sensitive ?? !1 });
  }
  /** Store a binary (pdf/image/docx/video) at `path`. Quota-checked. */
  async putBinary(e, t, i) {
    const o = U(e);
    if (J(o)) throw new C("Use write() for markdown documents.");
    if (t.length > yt)
      throw new C(`That file is too large (max ${yt} bytes).`);
    const r = await this.storage.download(this.key(o));
    return await this.putObject(o, t, i, (r == null ? void 0 : r.bytes.length) ?? 0), { path: o, bytes: t.length, created: !r };
  }
  async mv(e, t) {
    const i = U(e), o = U(t);
    if (i === o) return { moved: [] };
    if (o.startsWith(`${i}/`)) throw new C("Cannot move a directory into itself.");
    if (await this.ensureSeeded(), await this.storage.download(this.key(i))) {
      if (J(i) !== J(o))
        throw new C("Keep the .md extension when moving a markdown document.");
      if (await this.storage.download(this.key(o)))
        throw new C(`${o} already exists — remove it first or pick another name.`);
      return await this.storage.move(this.key(i), this.key(o)), { moved: [o] };
    }
    const a = await this.listAll(i);
    if (a.length === 0) throw new Pe(i);
    const s = [];
    for (const c of a) {
      const d = this.rel(c.key).slice(i.length + 1), u = `${o}/${d}`;
      await this.storage.move(c.key, this.key(u)), s.push(u);
    }
    return { moved: s };
  }
  async rm(e, t = {}) {
    const i = U(e);
    if (i === "README.md") throw new C("The root guide cannot be removed.");
    await this.ensureSeeded();
    const o = await this.storage.download(this.key(i));
    if (o)
      return await this.storage.remove([this.key(i)]), await this.adjustUsage(-o.bytes.length), { removed: [i] };
    const r = await this.listAll(i);
    if (r.length === 0) throw new Pe(i);
    if (!t.recursive)
      throw new C(`${i} is a directory with ${r.length} file(s) — pass recursive to remove it.`);
    return await this.storage.remove(r.map((a) => a.key)), await this.adjustUsage(-r.reduce((a, s) => a + s.size, 0)), { removed: r.map((a) => this.rel(a.key)) };
  }
  async signedUrl(e, t = 900) {
    const i = U(e);
    return this.storage.signedUrl(this.key(i), t);
  }
  // ── quota ─────────────────────────────────────────────────────────────────
  async usage(e = {}) {
    const t = await this.prisma.account.findUnique({
      where: { id: this.accountId },
      select: { storageUsedBytes: !0, storageLimitBytes: !0 }
    });
    if (!t) throw new Error(`Account ${this.accountId} not found`);
    const i = t.storageLimitBytes == null ? qn : Number(t.storageLimitBytes);
    let o = Number(t.storageUsedBytes ?? 0);
    if (e.recompute || o === 0) {
      const a = (await this.listAll("")).reduce((s, c) => s + c.size, 0);
      a !== o && (o = a, await this.prisma.account.update({
        where: { id: this.accountId },
        data: { storageUsedBytes: BigInt(a) }
      }));
    }
    return { usedBytes: o, limitBytes: i };
  }
  async putObject(e, t, i, o, r = !1) {
    const a = t.length - o;
    if (a > 0) {
      const { usedBytes: s, limitBytes: c } = await this.usage();
      if (s + a > c)
        throw new En(
          `Storage limit reached (${Gt(s)} of ${Gt(c)} used). Remove files or increase the account's storage limit.`,
          s,
          c
        );
    }
    if (r) {
      if (!await this.storage.createIfAbsent(this.key(e), t, i)) return !1;
    } else
      await this.storage.upload(this.key(e), t, i);
    return await this.adjustUsage(a), !0;
  }
  async adjustUsage(e) {
    var t, i;
    if (e !== 0)
      try {
        await this.prisma.account.update({
          where: { id: this.accountId },
          data: { storageUsedBytes: { increment: BigInt(e) } }
        });
      } catch (o) {
        (i = (t = this.logger) == null ? void 0 : t.warn) == null || i.call(t, "memory-fs", "usage counter update failed", {
          accountId: this.accountId,
          err: o.message
        });
      }
  }
}
function di(n, e) {
  const t = n.split(`
`).find((i) => i.startsWith("# "));
  return t ? t.slice(2).trim().slice(0, 160) : nt(De(e).replace(/\.md$/i, ""));
}
function nt(n) {
  return n.replace(/[-_]+/g, " ").replace(/\s+/g, " ").trim().replace(/^\w/, (e) => e.toUpperCase());
}
function Gt(n) {
  return n >= 1024 ** 3 ? `${(n / 1024 ** 3).toFixed(2)} GB` : n >= 1024 ** 2 ? `${(n / 1024 ** 2).toFixed(1)} MB` : n >= 1024 ? `${(n / 1024).toFixed(0)} KB` : `${n} B`;
}
const V = "memory-tool", li = new Set(Yn), Ue = "customers", kn = "customers/README.md", Qt = "applied_voice_operations";
function On(n) {
  return li.has(n);
}
function Z(n) {
  return typeof n == "string" && n.trim() ? n : void 0;
}
function _e(n) {
  return typeof n == "number" && Number.isFinite(n) ? n : void 0;
}
function $e(n) {
  return typeof n == "boolean" ? n : void 0;
}
function Zt(n) {
  return {
    path: n.path,
    title: n.title,
    sensitive: n.sensitive,
    updatedBy: n.updatedBy ?? null,
    updatedAt: n.updatedAt,
    kind: n.kind,
    size: n.size,
    content: n.content,
    truncated: n.truncated,
    ...n.sidecar ? { sidecar: n.sidecar } : {},
    ...n.contentType && n.kind === "binary" ? { contentType: n.contentType } : {},
    // Portal citation chip (assistant-stream attaches it on a successful read).
    citation: {
      id: `memory:${n.path}`,
      kind: "business",
      title: n.title.slice(0, 160),
      subtitle: `Memory · ${n.path}`.slice(0, 160)
    }
  };
}
function W(n) {
  return n === Ue || n.startsWith(`${Ue}/`);
}
async function Ve(n, e, t) {
  var a;
  if (!t) return { alreadyApplied: !1 };
  const i = await n.stat(e), o = (i == null ? void 0 : i.kind) === "file" ? (a = i.frontmatter) == null ? void 0 : a[Qt] : void 0, r = typeof o == "string" ? o.split(",").map((s) => s.trim()).filter(Boolean) : [];
  return r.includes(t) ? { alreadyApplied: !0 } : {
    alreadyApplied: !1,
    extra: {
      [Qt]: [...r, t].slice(-32).join(",")
    }
  };
}
function We(n, e, t) {
  return e.actor !== "lyra" || !W(n) ? !0 : n === kn || n === t;
}
async function mi(n, e) {
  var i;
  if (e.actor !== "lyra" || !e.customerScope) return;
  const t = await n.stat(e.customerScope.path);
  return t ? t.kind === "file" && ((i = t.frontmatter) == null ? void 0 : i.customer_id) === e.customerScope.id ? e.customerScope.path : void 0 : e.customerScope.path;
}
async function Me(n, e, t) {
  var o;
  if (t.actor !== "lyra" || !W(e) || e === kn) return null;
  if (!t.customerScope || e !== t.customerScope.path)
    return "Lyra can only access the customer memory for the person in this conversation.";
  const i = await n.stat(e);
  return (i == null ? void 0 : i.kind) === "file" && ((o = i.frontmatter) == null ? void 0 : o.customer_id) !== t.customerScope.id ? "This customer memory file is not bound to the person in this conversation." : null;
}
async function ve(n, e, t) {
  var i;
  return t.actor !== "lyra" || !W(e) ? null : e !== ((i = t.customerScope) == null ? void 0 : i.path) ? "Lyra can only change the customer memory for the person in this conversation." : Me(n, e, t);
}
async function _n(n, e, t, i) {
  var a, s, c, d, u, l, m, f, h, I, w, b, g, S, A, E, k, O;
  const o = i.memoryFs;
  if (!o)
    return JSON.stringify({ error: "Memory is not available right now. Answer from what you know and say the memory tree could not be reached." });
  if (o.accountId !== t.accountId)
    return JSON.stringify({ error: "Memory is not available for this account." });
  const r = Z(e.path);
  try {
    const N = await mi(o, t);
    switch (n) {
      case "memory_ls": {
        const y = r ?? "";
        if (t.actor === "lyra" && W(y) && y !== Ue)
          return JSON.stringify({ error: "Lyra can only list the current customer record, not other customer paths." });
        const p = await o.ls(y, {
          allowPath: (_) => We(_, t, N)
        });
        return JSON.stringify({
          path: r ?? "",
          entries: p.map((_) => ({
            name: _.name,
            path: _.path,
            kind: _.kind,
            ..._.size != null ? { size: _.size } : {},
            ..._.sensitive != null ? { sensitive: _.sensitive } : {}
          }))
        });
      }
      case "memory_tree": {
        const y = _e(e.depth), p = r ?? "";
        if (t.actor === "lyra" && W(p) && p !== Ue)
          return JSON.stringify({ error: "Lyra can only traverse the current customer record, not other customer paths." });
        const _ = await o.tree(p, y ?? 4, {
          allowPath: (P) => We(P, t, N)
        });
        return JSON.stringify({ path: r ?? "", tree: $n(_) });
      }
      case "memory_cat": {
        if (!r) return JSON.stringify({ error: "Provide the path of the file to read (see memory_ls)." });
        const y = await Me(o, r, t);
        if (y) return JSON.stringify({ error: y });
        const p = await o.cat(r);
        return (s = (a = i.logger) == null ? void 0 : a.log) == null || s.call(a, V, "memory read", { accountId: t.accountId, actor: t.actor, path: p.path, sensitive: p.sensitive }), JSON.stringify(Zt(p));
      }
      case "memory_head": {
        if (!r) return JSON.stringify({ error: "Provide the path of the file to read (see memory_ls)." });
        const y = await Me(o, r, t);
        if (y) return JSON.stringify({ error: y });
        const p = await o.head(r, _e(e.lines) ?? 20, _e(e.offset) ?? 0);
        return (d = (c = i.logger) == null ? void 0 : c.log) == null || d.call(c, V, "memory head", { accountId: t.accountId, actor: t.actor, path: p.path, sensitive: p.sensitive }), JSON.stringify({ ...Zt(p), totalLines: p.totalLines });
      }
      case "memory_grep": {
        const y = Z(e.pattern) ?? Z(e.query);
        if (!y) return JSON.stringify({ error: "Provide the text to search for." });
        const p = await o.grep(y, {
          dir: r,
          ignoreCase: $e(e.ignoreCase) ?? !0,
          maxResults: _e(e.maxResults),
          allowPath: (_) => We(_, t, N)
        });
        return (l = (u = i.logger) == null ? void 0 : u.log) == null || l.call(u, V, "memory grep", {
          accountId: t.accountId,
          actor: t.actor,
          matches: p.matches.length,
          filesSearched: p.filesSearched
        }), JSON.stringify({
          pattern: y,
          path: r ?? "",
          matches: p.matches,
          filesSearched: p.filesSearched,
          truncated: p.truncated,
          note: "Matches are discovery only — memory_cat the file before relying on it."
        });
      }
      case "memory_stat": {
        if (r) {
          const p = await Me(o, r, t);
          if (p) return JSON.stringify({ error: p });
        }
        const y = await o.stat(r ?? "");
        return JSON.stringify(y ? {
          path: y.path,
          kind: y.kind,
          size: y.size,
          updatedAt: y.updatedAt,
          sensitive: y.sensitive,
          ...y.frontmatter ? {
            title: y.frontmatter.title ?? null,
            updatedBy: y.frontmatter.updated_by ?? null,
            ...y.frontmatter.enabled !== void 0 ? { enabled: y.frontmatter.enabled } : {}
          } : {}
        } : { error: `Nothing at ${r ?? "/"}.` });
      }
      case "memory_write": {
        const y = typeof e.content == "string" ? e.content : void 0;
        if (!r) return JSON.stringify({ error: "Provide the path to write (a .md file under an existing directory)." });
        if (y == null || !y.trim()) return JSON.stringify({ error: "Provide the markdown content to write." });
        const p = await ve(o, r, t);
        if (p) return JSON.stringify({ error: p });
        const _ = await Ve(o, r, t.operationId);
        if (_.alreadyApplied)
          return JSON.stringify({ success: !0, path: r, idempotentReplay: !0 });
        const P = { ..._.extra ?? {} };
        t.actor === "lyra" && r === ((m = t.customerScope) == null ? void 0 : m.path) && (P.customer_id = t.customerScope.id);
        const R = await o.write(r, y, {
          updatedBy: t.actor,
          title: Z(e.title),
          sensitive: $e(e.sensitive),
          ...Object.keys(P).length ? { extra: P } : {}
        });
        return (h = (f = i.logger) == null ? void 0 : f.log) == null || h.call(f, V, R.created ? "memory file created" : "memory file replaced", {
          accountId: t.accountId,
          actor: t.actor,
          path: R.path,
          bytes: R.bytes
        }), JSON.stringify({ success: !0, ...R });
      }
      case "memory_append": {
        const y = typeof e.content == "string" ? e.content : void 0;
        if (!r) return JSON.stringify({ error: "Provide the path of the .md file to append to." });
        if (y == null || !y.trim()) return JSON.stringify({ error: "Provide the text to append." });
        const p = await ve(o, r, t);
        if (p) return JSON.stringify({ error: p });
        const _ = await Ve(o, r, t.operationId);
        if (_.alreadyApplied)
          return JSON.stringify({ success: !0, path: r, idempotentReplay: !0 });
        const P = { ..._.extra ?? {} };
        t.actor === "lyra" && r === ((I = t.customerScope) == null ? void 0 : I.path) && (P.customer_id = t.customerScope.id);
        const R = await o.append(r, y, {
          updatedBy: t.actor,
          sensitive: $e(e.sensitive),
          ...Object.keys(P).length ? { extra: P } : {}
        });
        return (b = (w = i.logger) == null ? void 0 : w.log) == null || b.call(w, V, "memory file appended", {
          accountId: t.accountId,
          actor: t.actor,
          path: R.path,
          bytes: R.bytes
        }), JSON.stringify({ success: !0, ...R });
      }
      case "memory_mkdir": {
        if (!r) return JSON.stringify({ error: "Provide the directory path to create." });
        if (t.actor === "lyra" && W(r))
          return JSON.stringify({ error: "Lyra cannot create customer directories from a customer conversation." });
        const y = await Ve(o, `${r}/README.md`, t.operationId);
        if (y.alreadyApplied)
          return JSON.stringify({ success: !0, directory: r.replace(/\/+$/, ""), readme: `${r}/README.md`, created: !1, idempotentReplay: !0 });
        const p = await o.mkdir(r, {
          updatedBy: t.actor,
          guide: Z(e.guide),
          ...y.extra ? { extra: y.extra } : {}
        });
        return JSON.stringify({ success: !0, directory: r.replace(/\/+$/, ""), readme: p.path, created: p.created });
      }
      case "memory_mv": {
        const y = Z(e.from) ?? r, p = Z(e.to);
        if (!y || !p) return JSON.stringify({ error: "Provide both `from` and `to` paths." });
        const _ = await ve(o, y, t), P = await ve(o, p, t);
        if (_ || P) return JSON.stringify({ error: _ ?? P });
        if (t.actor === "lyra" && W(y) !== W(p))
          return JSON.stringify({ error: "Lyra cannot move customer memory into or out of the customer directory." });
        const R = await o.mv(y, p);
        return (S = (g = i.logger) == null ? void 0 : g.log) == null || S.call(g, V, "memory moved", { accountId: t.accountId, actor: t.actor, from: y, to: p, count: R.moved.length }), JSON.stringify({ success: !0, from: y, to: p, moved: R.moved });
      }
      case "memory_rm": {
        if (!r) return JSON.stringify({ error: "Provide the path to remove." });
        const y = await ve(o, r, t);
        if (y) return JSON.stringify({ error: y });
        const p = await o.rm(r, { recursive: $e(e.recursive) ?? !1 });
        return (E = (A = i.logger) == null ? void 0 : A.log) == null || E.call(A, V, "memory removed", { accountId: t.accountId, actor: t.actor, path: r, count: p.removed.length }), JSON.stringify({ success: !0, removed: p.removed });
      }
      default:
        return JSON.stringify({ error: `Unknown memory tool: ${n}` });
    }
  } catch (N) {
    return N instanceof C || N instanceof En ? JSON.stringify({ error: N.message }) : N instanceof Pe ? JSON.stringify({ error: `${N.message}. Use memory_ls or memory_grep to find the right path.` }) : ((O = (k = i.logger) == null ? void 0 : k.error) == null || O.call(k, V, "memory tool failed", {
      accountId: t.accountId,
      tool: n,
      err: N.message
    }), JSON.stringify({ error: "Memory could not be reached right now. Say so plainly rather than guessing." }));
  }
}
function $n(n, e = "") {
  var i;
  const t = [];
  for (const o of n)
    o.kind === "dir" ? (t.push(`${e}${o.name}/`), (i = o.children) != null && i.length && t.push($n(o.children, `${e}  `))) : t.push(`${e}${o.name}${o.sensitive ? "  [sensitive]" : ""}`);
  return t.join(`
`);
}
function Xt(n, e) {
  if (n.accountRole === "OWNER") return !0;
  switch (e) {
    // Managing an existing invoice — editing it, or the cancel family (cancel /
    // uncancel / reissue) — requires the invoice permission (a member without it
    // can't mutate a money doc). Creating a fresh draft stays open.
    case "generate_invoices":
      return n.canGenerateInvoices === !0;
    // Approving-and-sending is the money-out gate. It reuses the same per-user
    // "generate invoices" flag rather than adding a redundant column.
    case "approve_invoices":
      return n.canGenerateInvoices === !0;
    case "mark_invoice_paid":
      return n.canMarkInvoicePaid === !0;
    case "cancel_jobs":
      return n.canCancelJobs === !0;
    case "adjust_settings":
      return n.canAdjustSettings === !0;
    // Reading the answers customers submitted to this account's forms. Its own
    // permission rather than a slice of adjust_settings (#517): form responses
    // carry personal customer details, so an owner must be able to grant them
    // without granting the rest of Settings — and withhold them from a member
    // who legitimately needs Settings. Independent of adjust_settings in BOTH
    // directions; nothing here consults canAdjustSettings.
    case "view_form_responses":
      return n.canViewFormResponses === !0;
    // Seeing the money that already came in — revenue (#572): /reports
    // and its CSV (the report-summary aggregate), the revenue aggregates behind
    // the money figures, and the payments-received ledger. Its own permission
    // (Settings → Team, the #517 shape) rather than a slice of the invoice
    // permission: a field tech may approve/send and collect without being shown
    // the business's earnings. **This fixes the edges: this and nothing else.**
    // The ordinary invoice list (PAID rows included), GET /invoices/:id,
    // `lookup_customer`'s open-invoice count and invoice hits in global search
    // are operational reads and stay open to every member.
    case "view_reports":
      return n.canViewReports === !0;
    default:
      return e;
  }
}
const fi = {
  mark_invoice_paid: "mark_invoice_paid",
  cancel_job: "cancel_jobs",
  // Approving-and-sending (DRAFT→SENT) is the money-out gate.
  approve_invoice: "approve_invoices"
  // cancel_invoice is NOT here — it's STATUS-AWARE (draft-open / sent-gated),
  // enforced inside cancelInvoice from the `canApproveInvoices` flag threaded
  // below. A static all-or-nothing gate can't express "anyone tosses an unsent
  // draft, but voiding a SENT invoice needs approve_invoices".
};
async function ba(n, e, t, i) {
  var l;
  const { prisma: o, logger: r } = i, a = { accountId: t.accountId, userId: t.userId }, s = {
    logger: r,
    computeSalesTax: i.computeSalesTax,
    ownerDraftAlertHandled: i.ownerDraftAlertHandled,
    recordReference: i.recordReference,
    customerMessageDraft: i.customerMessageDraft,
    invoiceApproval: i.invoiceApproval
  };
  if (t.manualMode && Mo.includes(n))
    return JSON.stringify({
      error: `That's not available right now — this account has used its plan's included AI usage for the month. The ${n.replace(/_/g, " ")} feature is paused until the plan is upgraded. You can handle this yourself in the Ten Four web app (Messages, Invoices, and the Job Queue all work normally), or upgrade the plan for more usage.`
    });
  const c = {
    accountRole: t.accountRole ?? "OWNER",
    canGenerateInvoices: t.canGenerateInvoices ?? !0,
    canMarkInvoicePaid: t.canMarkInvoicePaid ?? !0,
    canCancelJobs: t.canCancelJobs ?? !0,
    canAdjustSettings: t.canAdjustSettings ?? !0,
    // No assistant tool reads form responses today, so this only ever matters
    // if one is added — it defaults like the others (absent → owner/legacy).
    canViewFormResponses: t.canViewFormResponses ?? !0,
    // No assistant tool reads revenue aggregates today (#572); same default.
    canViewReports: t.canViewReports ?? !0
  }, d = n === "update_job_status" && String(e.status ?? "").toUpperCase() === "CANCELED" ? "cancel_jobs" : fi[n];
  if (d && !Xt(c, d))
    return JSON.stringify({
      error: `You don't have permission to do that on this account (${n.replace(/_/g, " ")}). The account owner can grant it in team settings.`
    });
  const u = Xt(c, "approve_invoices");
  if (On(n))
    return _n(n, e, { accountId: t.accountId, actor: "aria" }, { memoryFs: i.memoryFs, logger: r });
  switch (n) {
    case "get_queue":
      return xo(
        o,
        {
          status: e.status,
          limit: typeof e.limit == "number" ? e.limit : void 0
        },
        // "My queue": when a teammate is recognized, scope to their + unassigned
        // jobs. Owner/legacy (no userId) sees the whole account, as before.
        { accountId: t.accountId, userId: t.userId },
        s
      );
    case "lookup_customer":
      return er(o, { name: String(e.name ?? "") }, a, s);
    case "list_customers":
      return kr(
        o,
        { limit: typeof e.limit == "number" ? e.limit : void 0 },
        a,
        s
      );
    case "create_customer":
      return nr(
        o,
        {
          name: e.name,
          phone: e.phone,
          email: e.email,
          street: e.street,
          city: e.city,
          state: e.state,
          zip: e.zip
        },
        a,
        s
      );
    case "create_job":
      return rr(
        o,
        {
          customerId: e.customerId,
          customerName: e.customerName,
          description: e.description,
          type: e.type,
          urgency: e.urgency
        },
        a,
        s
      );
    case "update_job_status":
      return dr(
        o,
        {
          jobId: e.jobId,
          customerName: e.customerName,
          description: e.description,
          status: String(e.status ?? ""),
          completionNotes: e.completionNotes
        },
        { accountId: t.accountId },
        s
      );
    case "cancel_job":
      return lr(
        o,
        {
          jobId: e.jobId,
          customerName: e.customerName
        },
        a,
        s
      );
    case "mark_invoice_paid":
      return mr(
        o,
        {
          invoiceId: e.invoiceId,
          customerName: e.customerName,
          paymentType: String(e.paymentType ?? "")
        },
        a,
        s
      );
    case "write_invoice":
      return wr(
        o,
        {
          action: e.action,
          invoiceId: e.invoiceId,
          // The tool schema takes the id as PRINTED ("INV-0002"), and models still
          // send a plain number — pass either straight through; the resolver
          // normalizes both via resolveInvoiceNumberArg. Narrowing to `number`
          // here silently dropped every typed identifier before it was read.
          invoiceNumber: typeof e.invoiceNumber == "number" || typeof e.invoiceNumber == "string" ? e.invoiceNumber : void 0,
          customerId: e.customerId,
          customerName: e.customerName,
          jobId: e.jobId ?? null,
          status: e.status,
          lineItems: Array.isArray(e.lineItems) ? e.lineItems : void 0,
          removeItemNames: Array.isArray(e.removeItemNames) ? e.removeItemNames : void 0,
          discountPercent: typeof e.discountPercent == "number" ? e.discountPercent : void 0,
          discountAmount: typeof e.discountAmount == "number" ? e.discountAmount : void 0,
          memo: e.memo
        },
        // Thread the review gate — the SMS + phone-voice callers set it when the
        // account is gated; the in-portal mic / web Aria leave it unset.
        { ...a, holdForReview: t.holdForReview, reviewRequestText: t.reviewRequestText },
        s
      );
    case "approve_invoice":
      return vr(
        o,
        {
          invoiceId: e.invoiceId,
          // The tool schema takes the id as PRINTED ("INV-0002"), and models still
          // send a plain number — pass either straight through; the resolver
          // normalizes both via resolveInvoiceNumberArg. Narrowing to `number`
          // here silently dropped every typed identifier before it was read.
          invoiceNumber: typeof e.invoiceNumber == "number" || typeof e.invoiceNumber == "string" ? e.invoiceNumber : void 0,
          customerName: e.customerName
        },
        // confirmInline distinguishes voice (spoken reply) from SMS (texted
        // reply) so the send handler can skip the duplicate owner text on SMS.
        // confirmationMode 'portal' (web) stages the approval card instead of
        // sending — the account holder's tap performs the real approve.
        { ...a, confirmInline: t.confirmInline, confirmationMode: t.confirmationMode },
        s
      );
    case "cancel_invoice":
      return Tr(
        o,
        {
          invoiceId: e.invoiceId,
          // The tool schema takes the id as PRINTED ("INV-0002"), and models still
          // send a plain number — pass either straight through; the resolver
          // normalizes both via resolveInvoiceNumberArg. Narrowing to `number`
          // here silently dropped every typed identifier before it was read.
          invoiceNumber: typeof e.invoiceNumber == "number" || typeof e.invoiceNumber == "string" ? e.invoiceNumber : void 0,
          customerName: e.customerName
        },
        // confirmInline (voice) → the cancel reply is spoken/ephemeral, so keep
        // the void handler's cancel text; SMS suppresses it (the reply is a text).
        { ...a, confirmInline: t.confirmInline, canApproveInvoices: u },
        s
      );
    case "send_booking_link_to_customer":
      return An(
        o,
        {
          customerId: e.customerId,
          customerName: e.customerName,
          description: e.description,
          firstName: e.firstName,
          lastName: e.lastName,
          email: e.email,
          street: e.street,
          city: e.city,
          state: e.state,
          zip: e.zip
        },
        { accountId: t.accountId, frontendUrl: t.frontendUrl },
        s
      );
    case "summarize_today":
      return _r(o, {}, a, s);
    case "list_recent_conversations":
      return Dr(
        o,
        { limit: typeof e.limit == "number" ? e.limit : void 0 },
        a,
        s
      );
    case "list_pending_invoices":
      return Mr(o, {}, a, s);
    case "text_me_customer_info":
      return Ur(
        o,
        {
          customerId: e.customerId,
          customerName: e.customerName
        },
        a,
        s
      );
    case "text_me_my_queue":
      return jr(o, {}, a, s);
    case "text_me_my_next_job":
      return Lr(o, {}, a, s);
    case "text_me_job_address":
      return qr(
        o,
        {
          jobId: e.jobId,
          customerName: e.customerName
        },
        a,
        s
      );
    case "text_me_payment_link":
      return Vr(
        o,
        {
          invoiceId: e.invoiceId,
          customerId: e.customerId,
          customerName: e.customerName
        },
        a,
        s
      );
    case "text_me_booking_link":
      return Kr(
        o,
        {
          customerId: e.customerId,
          customerName: e.customerName,
          description: e.description
        },
        { accountId: t.accountId, frontendUrl: t.frontendUrl, userId: t.userId },
        s
      );
    case "text_me_unread_messages":
      return Gr(o, {}, a, s);
    case "create_reminder":
      return Zr(
        o,
        {
          text: e.text,
          dueAt: e.dueAt,
          customerId: e.customerId,
          customerName: e.customerName,
          jobId: e.jobId
        },
        // Attach the reminder to the recognized teammate (per-user reminders).
        { accountId: t.accountId, userId: t.userId },
        s
      );
    case "add_job_note":
      return ei(
        o,
        {
          jobId: e.jobId,
          customerName: e.customerName,
          note: e.note
        },
        a,
        s
      );
    case "message_customer":
      return oi(
        o,
        {
          customerName: e.customerName,
          messageText: e.messageText
        },
        {
          accountId: t.accountId,
          conversationId: t.conversationId,
          confirmInline: t.confirmInline,
          confirmationMode: t.confirmationMode,
          assistantConversationId: t.assistantConversationId
        },
        s
      );
    case "complete_handoff":
      return ri(
        o,
        { resolutionSummary: e.resolutionSummary },
        {
          accountId: t.accountId,
          assistantConversationId: t.assistantConversationId
        }
      );
    default:
      return (l = r == null ? void 0 : r.warn) == null || l.call(r, "assistant-tools:execute", "unknown tool call", { tool: n }), JSON.stringify({ error: `Unknown tool: ${n}` });
  }
}
const hi = "customer-tool:lookup-me";
async function yi(n, e, t = {}) {
  var r, a;
  if (!e.customerId)
    return JSON.stringify({ error: "No customer is associated with this caller." });
  const i = await n.customer.findUnique({
    where: { id: e.customerId },
    select: {
      id: !0,
      name: !0,
      phone: !0,
      address: !0,
      street: !0,
      city: !0,
      state: !0,
      zip: !0,
      intakeComplete: !0,
      totalJobs: !0
    }
  });
  if (!i)
    return JSON.stringify({ error: "Customer record not found." });
  const o = await n.job.findMany({
    where: { customerId: e.customerId },
    orderBy: { createdAt: "desc" },
    take: 10,
    select: { id: !0, description: !0, status: !0, urgency: !0, createdAt: !0 }
  });
  return (a = (r = t.logger) == null ? void 0 : r.log) == null || a.call(r, hi, "lookup_me", { customerId: e.customerId, jobs: o.length }), JSON.stringify({ customer: i, jobs: o });
}
const xt = "customer-tool:cancel-my-job";
async function pi(n, e, t, i = {}) {
  var r, a, s, c;
  if (!t.customerId)
    return JSON.stringify({ error: "No customer is associated with this caller." });
  const o = e.jobId ? await n.job.findFirst({
    where: { id: e.jobId, customerId: t.customerId, accountId: t.accountId },
    select: { id: !0, customerName: !0, description: !0, status: !0 }
  }) : await n.job.findFirst({
    where: {
      customerId: t.customerId,
      accountId: t.accountId,
      status: { in: [...le] }
    },
    orderBy: { createdAt: "desc" },
    select: { id: !0, customerName: !0, description: !0, status: !0 }
  });
  return o ? o.status === "CANCELED" ? JSON.stringify({ error: "That job is already canceled." }) : (await n.job.update({ where: { id: o.id }, data: { status: "CANCELED", updatedAt: /* @__PURE__ */ new Date() } }), await n.outbox.upsert({
    where: { idempotencyKey: `job.cancelled_internal:${o.id}` },
    create: {
      aggregateType: "job",
      aggregateId: o.id,
      eventType: "job.cancelled_internal",
      accountId: t.accountId,
      priority: 10,
      payload: {
        accountId: t.accountId,
        customerId: t.customerId,
        customerName: o.customerName,
        reason: "Customer canceled the job.",
        entityType: "job",
        entityId: o.id
      },
      idempotencyKey: `job.cancelled_internal:${o.id}`
    },
    update: {}
  }), (c = (s = i.logger) == null ? void 0 : s.log) == null || c.call(s, xt, "job canceled by customer", { jobId: o.id, customerId: t.customerId }), JSON.stringify({ success: !0, jobId: o.id, description: o.description })) : ((a = (r = i.logger) == null ? void 0 : r.warn) == null || a.call(r, xt, "no matching job for self-cancel", {
    customerId: t.customerId,
    jobId: e.jobId
  }), JSON.stringify({ error: "No active job found on your account to cancel." }));
}
const Ii = "customer-tool:relay-to-account";
async function gi(n, e, t, i = {}) {
  var c, d, u;
  const o = (e.summary ?? "").trim();
  if (!o)
    return JSON.stringify({ error: "summary is required to relay to the account" });
  const r = ((c = t.customerName) == null ? void 0 : c.trim()) || "A customer", a = t.callId ? `voice:${t.callId}` : `conv:${t.conversationId ?? `${t.accountId}:latest`}`, s = `customer.relay:${a}`;
  return await n.outbox.upsert({
    where: { idempotencyKey: s },
    create: {
      aggregateType: t.conversationId ? "conversation" : "call",
      aggregateId: t.conversationId ?? t.callId ?? t.accountId,
      eventType: "customer.relay",
      accountId: t.accountId,
      priority: 15,
      payload: {
        accountId: t.accountId,
        customerId: t.customerId ?? void 0,
        customerName: r,
        summary: o,
        source: "voice",
        callId: t.callId,
        conversationId: t.conversationId,
        relayId: t.callId ?? t.conversationId,
        title: `Message from ${r}`
      },
      idempotencyKey: s
    },
    update: {}
  }), (u = (d = i.logger) == null ? void 0 : d.log) == null || u.call(d, Ii, "relayed to account", { accountId: t.accountId, anchor: a }), JSON.stringify({ ok: !0, relayed: !0 });
}
const en = "customer-tool:send-booking-link-to-caller";
async function wi(n, e, t, i = {}) {
  var g, S, A, E, k, O, N;
  if (!t.customerPhone)
    return JSON.stringify({ error: "No phone number on file to text the booking link to." });
  if (!t.accountPhone)
    return JSON.stringify({ error: "No Ten Four number is configured to send from." });
  const o = `sms.reply:voice-booking:${t.callId ?? t.customerId ?? t.accountId}`;
  if (await n.outbox.findUnique({
    where: { idempotencyKey: o },
    select: { id: !0 }
  }))
    return (S = (g = i.logger) == null ? void 0 : g.log) == null || S.call(g, en, "booking link already sent on this call — skipping", {
      accountId: t.accountId
    }), JSON.stringify({ success: !0, sentTo: "the caller", reused: !0 });
  let a = t.customerId;
  a || (a = (await n.customer.upsert({
    where: { accountId_phone: { accountId: t.accountId, phone: t.customerPhone } },
    create: {
      accountId: t.accountId,
      name: t.customerPhone,
      phone: t.customerPhone,
      identityId: t.customerPhone,
      contactStatus: "PROSPECT",
      consentSource: "voice",
      lastSeenAt: /* @__PURE__ */ new Date()
    },
    update: { lastSeenAt: /* @__PURE__ */ new Date() },
    select: { id: !0 }
  })).id);
  const s = ((A = e.callerName) == null ? void 0 : A.trim()) ?? "", [c, ...d] = s ? s.split(/\s+/) : [], u = d.join(" "), l = ((E = e.address) == null ? void 0 : E.trim()) || void 0, { token: m } = await at(n, {
    accountId: t.accountId,
    customerId: a,
    description: ((k = e.problem) == null ? void 0 : k.trim()) || e.description,
    prefill: {
      phone: t.customerPhone,
      ...c ? { firstName: c } : {},
      ...u ? { lastName: u } : {},
      ...l ? { street: l } : {}
    }
  }), f = `${t.frontendUrl}/book/${m}`, h = `Here's your booking link to pick a time: ${f}`, I = `sms:${t.customerPhone}`, w = await n.conversation.upsert({
    where: { accountId_threadKey: { accountId: t.accountId, threadKey: I } },
    create: {
      accountId: t.accountId,
      customerId: a,
      participantPhone: t.customerPhone,
      participantType: "CUSTOMER",
      type: "SMS",
      threadKey: I,
      state: "ACTIVE",
      lastMessageAt: /* @__PURE__ */ new Date(),
      stateChangedAt: /* @__PURE__ */ new Date()
    },
    update: { lastMessageAt: /* @__PURE__ */ new Date(), customerId: a },
    select: { id: !0 }
  }), b = await n.message.create({
    data: {
      conversationId: w.id,
      accountId: t.accountId,
      direction: "OUTBOUND",
      senderType: "SYSTEM",
      fromNumber: t.accountPhone,
      toNumber: t.customerPhone,
      body: h,
      status: "processing",
      approvedBy: "system",
      approvedAt: /* @__PURE__ */ new Date()
    },
    select: { id: !0 }
  });
  return await n.outbox.upsert({
    where: { idempotencyKey: o },
    create: {
      aggregateType: "message",
      aggregateId: b.id,
      eventType: "sms.reply",
      accountId: t.accountId,
      priority: 10,
      payload: {
        messageId: b.id,
        to: t.customerPhone,
        from: t.accountPhone,
        body: h,
        accountId: t.accountId
      },
      idempotencyKey: o
    },
    update: {}
  }), (N = (O = i.logger) == null ? void 0 : O.log) == null || N.call(O, en, "texted booking link to caller", { accountId: t.accountId }), JSON.stringify({ success: !0, bookingUrl: f, sentTo: "the caller" });
}
const vi = "customer-tool:request-owner-input", tn = 40;
function bi(n) {
  if (!Array.isArray(n)) return;
  const e = n.filter((t) => typeof t == "string").map((t) => t.trim()).filter(Boolean).slice(0, 6);
  return e.length > 0 ? e : void 0;
}
function Ni(n) {
  var i;
  const e = n.activity.length > 0 ? n.activity.map((o) => {
    const r = o.isTrigger ? " — triggered this request" : "";
    return `- ${o.occurredAt} — **${o.actor}:** ${o.text}${r}`;
  }).join(`
`) : "- No transcript activity was available; use the linked source record for context.", t = (i = n.suggestions) != null && i.length ? `

Possible answers:
${n.suggestions.map((o) => `- ${o}`).join(`
`)}` : "";
  return [
    `I need your input about ${n.who}.`,
    "",
    n.contextSummary,
    "",
    "Relevant activity, oldest first:",
    e,
    "",
    `**What should I do?** ${n.question}${t}`,
    "",
    "Reply here. I’ll use your answer to handle the next step and confirm what happened."
  ].join(`
`);
}
async function Ti(n, e, t, i = {}) {
  var S, A, E, k, O;
  const o = (e.question ?? "").trim(), r = (e.contextSummary ?? "").trim();
  if (!o) return JSON.stringify({ error: "question is required for an owner handoff" });
  if (!r)
    return JSON.stringify({ error: "contextSummary is required for an owner handoff" });
  if (o.length > 2e3 || r.length > 4e3)
    return JSON.stringify({ error: "Keep the handoff question and context concise." });
  if (t.source === "voice" && !t.callId)
    return JSON.stringify({ error: "A trusted call id is required for a voice handoff." });
  if (t.source === "sms" && (!t.conversationId || !t.triggerMessageId))
    return JSON.stringify({ error: "A trusted conversation and trigger message are required for an SMS handoff." });
  const s = `assistant.handoff:${t.source === "voice" ? `voice:${t.callId}:${((S = t.voiceTurns) == null ? void 0 : S.length) ?? 0}` : `sms:${t.conversationId}:${t.triggerMessageId}`}`, c = await n.assistantHandoffRequest.findUnique({
    where: { idempotencyKey: s },
    select: { id: !0, assistantConversationId: !0, status: !0 }
  });
  if (c)
    return JSON.stringify({
      ok: !0,
      handoffRequestId: c.id,
      ariaThreadId: c.assistantConversationId,
      status: c.status,
      duplicate: !0,
      instruction: "The owner has already been notified. Continue helping the customer smoothly."
    });
  const d = t.customerId ? await n.customer.findFirst({
    where: { id: t.customerId, accountId: t.accountId },
    select: { id: !0, name: !0, phone: !0 }
  }) : null, u = t.conversationId ? await n.conversation.findFirst({
    where: { id: t.conversationId, accountId: t.accountId },
    select: { id: !0 }
  }) : null, l = ((A = d == null ? void 0 : d.name) == null ? void 0 : A.trim()) || ((E = t.customerName) == null ? void 0 : E.trim()) || t.customerPhone || "this caller", m = d ? { id: d.id, name: d.name } : void 0, f = /* @__PURE__ */ new Date();
  let h = [];
  if (t.source === "sms" && u) {
    if (h = (await n.message.findMany({
      where: { accountId: t.accountId, conversationId: u.id },
      orderBy: [{ createdAt: "desc" }, { id: "desc" }],
      take: tn,
      select: {
        id: !0,
        createdAt: !0,
        direction: !0,
        senderType: !0,
        body: !0,
        fromNumber: !0
      }
    })).reverse().map((y) => ({
      id: y.id,
      occurredAt: y.createdAt.toISOString(),
      channel: "sms",
      direction: y.direction === "INBOUND" ? "inbound" : "outbound",
      actor: y.direction === "INBOUND" ? l : y.senderType === "CONTRACTOR" ? "Account owner" : "Lyra",
      text: y.body,
      ...y.fromNumber ? { phone: y.fromNumber } : {},
      ...m ? { customer: m } : {},
      conversationId: u.id,
      messageId: y.id,
      isTrigger: y.id === t.triggerMessageId
    })), !h.some((y) => y.isTrigger === !0)) {
      const y = [...h].reverse().find((p) => p.direction === "inbound");
      y && (y.isTrigger = !0);
    }
  } else if (t.source === "voice") {
    const N = (t.voiceTurns ?? []).slice(-tn), y = N.map((p) => p.role).lastIndexOf("user");
    h = N.map((p, _) => ({
      id: `${t.callId ?? "call"}:${_}`,
      occurredAt: p.occurredAt ?? f.toISOString(),
      channel: "voice",
      direction: p.role === "user" ? "inbound" : "outbound",
      actor: p.role === "user" ? l : "Lyra",
      text: p.text.trim(),
      ...p.role === "user" && t.customerPhone ? { phone: t.customerPhone } : {},
      ...m ? { customer: m } : {},
      ...u ? { conversationId: u.id } : {},
      ...t.callId ? { callId: t.callId } : {},
      isTrigger: _ === y
    })).filter((p) => p.text);
  }
  const I = bi(e.suggestedAnswers), w = globalThis.crypto.randomUUID(), b = globalThis.crypto.randomUUID(), g = globalThis.crypto.randomUUID();
  return await n.assistantConversation.create({
    data: {
      id: b,
      accountId: t.accountId,
      title: `${l} needs your input`.slice(0, 160),
      lastMessageAt: f,
      messages: {
        create: {
          id: g,
          accountId: t.accountId,
          role: "ASSISTANT",
          content: Ni({
            who: l,
            contextSummary: r,
            question: o,
            suggestions: I,
            activity: h
          })
        }
      }
    }
  }), await n.assistantHandoffRequest.create({
    data: {
      id: w,
      accountId: t.accountId,
      originAgent: "lyra",
      sourceChannel: t.source,
      status: "OPEN",
      question: o,
      contextSummary: r,
      ...I ? { suggestedAnswers: I } : {},
      activity: h,
      customerId: d == null ? void 0 : d.id,
      sourceConversationId: u == null ? void 0 : u.id,
      callId: t.callId,
      triggerMessageId: t.triggerMessageId,
      assistantConversationId: b,
      idempotencyKey: s,
      requestedAt: f
    }
  }), await n.outbox.upsert({
    where: { idempotencyKey: `assistant.handoff_requested:${w}` },
    create: {
      aggregateType: "assistant_handoff",
      aggregateId: w,
      eventType: "assistant.handoff_requested",
      accountId: t.accountId,
      priority: 20,
      payload: {
        accountId: t.accountId,
        handoffRequestId: w,
        originAgent: "lyra",
        question: o,
        contextSummary: r,
        ...d != null && d.id ? { customerId: d.id } : {},
        ...(d == null ? void 0 : d.name) ?? t.customerName ? { customerName: (d == null ? void 0 : d.name) ?? t.customerName } : {},
        source: t.source,
        ...u != null && u.id ? { conversationId: u.id } : {},
        ...t.callId ? { callId: t.callId } : {},
        ariaThreadId: b,
        title: "Aria needs your input",
        entityType: "assistant_handoff",
        entityId: w
      },
      idempotencyKey: `assistant.handoff_requested:${w}`
    },
    update: {}
  }), (O = (k = i.logger) == null ? void 0 : k.log) == null || O.call(k, vi, "owner input requested", {
    accountId: t.accountId,
    source: t.source,
    handoffRequestId: w
  }), JSON.stringify({
    ok: !0,
    handoffRequestId: w,
    ariaThreadId: b,
    status: "OPEN",
    instruction: "The owner has been notified. Continue the interaction smoothly; if the customer persists, say the owner will get back to them as soon as possible with the answer or updated information."
  });
}
const nn = `| Service | Price | Taxable | Description |
|---|---|---|---|`;
function Ne(n) {
  return n.trim().replace(/^\|/, "").replace(/\|$/, "").split("|").map((t) => t.trim());
}
function Dn(n) {
  return n.length > 0 && n.every((e) => /^:?-{2,}:?$/.test(e) || e === "");
}
function Ai(n) {
  return /^(yes|y|true|taxable|✓|x)$/i.test(n.trim());
}
function Si(n) {
  const e = n.replace(/\r\n?/g, `
`).split(`
`);
  for (let i = 0; i < e.length - 1; i += 1) {
    const o = e[i];
    if (!o.trim().startsWith("|")) continue;
    const r = Ne(o).map((m) => m.toLowerCase()), a = r.findIndex((m) => m === "service" || m === "name" || m === "services");
    if (a === -1) continue;
    const s = Ne(e[i + 1] ?? "");
    if (!Dn(s)) continue;
    const c = r.findIndex((m) => m === "price" || m === "pricing" || m === "rate"), d = r.findIndex((m) => m === "taxable" || m === "tax"), u = r.findIndex((m) => m === "description" || m === "notes" || m === "details"), l = [];
    for (let m = i + 2; m < e.length; m += 1) {
      const f = e[m];
      if (!f.trim().startsWith("|")) break;
      const h = Ne(f), I = (h[a] ?? "").replace(/\*\*/g, "").trim();
      I && l.push({
        name: I,
        priceText: c === -1 ? "" : (h[c] ?? "").trim(),
        taxable: d === -1 ? !1 : Ai(h[d] ?? ""),
        description: u === -1 ? "" : (h[u] ?? "").trim()
      });
    }
    return l;
  }
  const t = [];
  for (const i of e) {
    const o = /^\s*[-*]\s+(.+)$/.exec(i);
    if (!o) continue;
    const r = o[1].replace(/\*\*/g, "").trim(), a = r.search(/\s[—–-]\s|:\s/);
    if (a === -1) continue;
    const s = r.slice(0, a).trim();
    let c = r.slice(a).replace(/^(\s[—–-]\s|:\s)/, "").trim();
    const d = /\(taxable\)/i.test(c);
    c = c.replace(/\((non-?taxable|taxable)\)/i, "").trim();
    const u = c.search(/\s[—–]\s|:\s/), l = u === -1 ? c : c.slice(0, u).trim(), m = u === -1 ? "" : c.slice(u).replace(/^(\s[—–]\s|:\s)/, "").trim();
    s && t.push({ name: s, priceText: l, taxable: d, description: m });
  }
  return t;
}
function Ke(n) {
  return n.replace(/\|/g, "\\|").replace(/\r?\n/g, " ").trim();
}
function ot(n) {
  const e = n.map((t) => `| ${Ke(t.name)} | ${Ke(t.priceText)} | ${t.taxable ? "yes" : "no"} | ${Ke(t.description)} |`).join(`
`);
  return e ? `${nn}
${e}` : nn;
}
function Ei(n) {
  const e = on(n.price);
  switch ((n.priceType ?? "fixed").toLowerCase()) {
    case "hourly":
      return `${e}/hr`;
    case "range":
      return n.priceMax != null ? `${e}–${on(n.priceMax)}` : `from ${e}`;
    case "quote_required":
      return "quote required";
    default:
      return e;
  }
}
function on(n) {
  const e = typeof n == "number" ? n : Number(String(n));
  return Number.isFinite(e) ? `$${e.toFixed(2).replace(/\.00$/, "")}` : String(n);
}
function ki(n, e) {
  const t = n.replace(/\r\n?/g, `
`).split(`
`);
  for (let o = 0; o < t.length - 1; o += 1) {
    if (!t[o].trim().startsWith("|") || !Ne(t[o]).map((s) => s.toLowerCase()).some((s) => s === "service" || s === "name" || s === "services") || !Dn(Ne(t[o + 1] ?? ""))) continue;
    let a = o + 2;
    for (; a < t.length && t[a].trim().startsWith("|"); ) a += 1;
    return [...t.slice(0, o), ot(e), ...t.slice(a)].join(`
`);
  }
  const i = n.trimEnd();
  return `${i ? `${i}

` : `# Services

`}${ot(e)}
`;
}
const Pn = "business_knowledge", x = `${Pn}/services.md`;
async function Na(n) {
  const e = await n.ls(Pn), t = {};
  for (const i of e) {
    if (i.kind !== "file" || !/\.md$/i.test(i.name) || i.name === "README.md") continue;
    const o = i.name.replace(/\.md$/i, "");
    if (!st(o)) continue;
    const r = await n.cat(i.path);
    t[o] = r.frontmatter.enabled === !1 ? "" : r.content;
  }
  return t;
}
async function Ta(n) {
  const e = await n.cat(x);
  return Si(e.content).map((t) => ({
    name: t.name,
    // The prompt renders `$${price}`; strip one leading "$" so a plain dollar
    // figure prints once and free-text rules ("4.50 per sq yd, $300 minimum")
    // read naturally after the prefix.
    price: t.priceText.replace(/^\$/, ""),
    taxable: t.taxable,
    description: t.description
  }));
}
const te = "migration", rt = "system", Oi = /* @__PURE__ */ new Set([te, rt]);
async function de(n, e) {
  var o;
  const t = await n.stat(e);
  if (!t || t.kind !== "file") return !0;
  const i = (o = t.frontmatter) == null ? void 0 : o.updated_by;
  return typeof i == "string" ? Oi.has(i) : !1;
}
function it(n) {
  return n.toISOString().slice(0, 10);
}
async function _i(n, e, t = "admin") {
  var o;
  if (!st(e.name)) throw new Error(`Invalid knowledge doc name: ${e.name}`);
  const i = `business_knowledge/${e.name}.md`;
  return await n.write(i, e.content, {
    updatedBy: t,
    title: ((o = e.fileName) == null ? void 0 : o.trim()) || e.name.replace(/[_-]+/g, " "),
    enabled: e.enabled,
    extra: { tag: e.name }
  }), i;
}
async function Aa(n, e) {
  if (!st(e)) return;
  const t = `business_knowledge/${e}.md`;
  await n.exists(t) && await n.rm(t);
}
function $i(n) {
  return n.filter((e) => e.active).map((e) => ({
    name: e.name,
    description: e.description ?? "",
    priceText: Ei({
      priceType: e.priceType,
      price: typeof e.price == "object" ? e.price.toString() : e.price,
      priceMax: e.priceMax == null ? null : typeof e.priceMax == "object" ? e.priceMax.toString() : e.priceMax
    }),
    taxable: e.taxable
  }));
}
async function Di(n, e, t) {
  if (!t.force && !await de(e, x)) return !1;
  const i = await n.accountService.findMany({
    where: { accountId: e.accountId },
    orderBy: [{ sortOrder: "asc" }, { name: "asc" }]
  }), o = $i(i), r = await e.exists(x) ? await e.cat(x) : null, a = r ? ki(r.content, o) : `# Services

${ot(o)}

## Pricing notes

_Add pricing rules here in plain language._
`;
  return await e.write(x, a, { updatedBy: t.by ?? (t.force ? "owner" : te), title: "Services" }), !0;
}
const ze = {
  order: !0,
  label: !0,
  type: !0,
  required: !0,
  options: !0,
  key: !0,
  placeholder: !0
};
function Pi(n) {
  var i;
  const e = n.questions.map(
    (o) => `| ${o.label.replace(/\|/g, "\\|")} | ${o.type.toLowerCase().replace(/_/g, " ")} | ${o.required ? "yes" : "no"} | ${o.options.length ? o.options.join(", ").replace(/\|/g, "\\|") : o.key ? `core: ${o.key}` : ""} |`
  ).join(`
`), t = n.isBookingDefault ? "This is the booking form. Send it with `send_booking_link` when a customer wants to request work and has not booked yet, or when their details need to be captured properly." : n.toolSlug ? `Send it by name with the \`send_form__${n.toolSlug}\` tool when the conversation calls for it (the tool description says when). It records a response only — it does not book a job.` : "Not currently sendable from chat (it is not assigned to this account or is disabled).";
  return `# ${n.name}

${(i = n.description) != null && i.trim() ? `${n.description.trim()}

` : ""}- Kind: ${n.kind === "BOOKING" ? "booking form" : "form (records a response)"}
- Enabled: ${n.enabled ? "yes" : "no"}

## Fields

| Field | Type | Required | Options / core key |
|---|---|---|---|
${e}

## When to send it

${t}
`;
}
async function Mi(n, e) {
  var m;
  const t = await n.account.findUnique({
    where: { id: e.accountId },
    select: {
      defaultFormTemplateId: !0,
      formTemplates: {
        orderBy: [{ assignedAt: "asc" }, { formTemplateId: "asc" }],
        select: {
          formTemplate: {
            select: {
              id: !0,
              name: !0,
              description: !0,
              kind: !0,
              enabled: !0,
              questions: { orderBy: { order: "asc" }, select: ze }
            }
          }
        }
      }
    }
  });
  if (!t) return [];
  const i = await n.formTemplate.findMany({
    where: { accountId: e.accountId },
    orderBy: { createdAt: "asc" },
    select: {
      id: !0,
      name: !0,
      description: !0,
      kind: !0,
      enabled: !0,
      questions: { orderBy: { order: "asc" }, select: ze }
    }
  }), o = t.defaultFormTemplateId ? await n.formTemplate.findUnique({
    where: { id: t.defaultFormTemplateId },
    select: {
      id: !0,
      name: !0,
      description: !0,
      kind: !0,
      enabled: !0,
      questions: { orderBy: { order: "asc" }, select: ze }
    }
  }) : null, r = t.formTemplates.map((f) => f.formTemplate), a = an(
    r.filter((f) => f.enabled && f.kind === "OTHER" && f.id !== t.defaultFormTemplateId)
  ), s = new Map(a.map((f) => [f.id, f.slug])), c = /* @__PURE__ */ new Map();
  for (const f of [...o ? [o] : [], ...r, ...i]) c.set(f.id, f);
  const d = [], u = /* @__PURE__ */ new Set();
  for (const f of c.values()) {
    let h = Te(f.name) || "form";
    for (let w = 2; u.has(h); w += 1) h = `${Te(f.name) || "form"}-${w}`;
    u.add(h);
    const I = `forms/${h}.md`;
    await e.write(
      I,
      Pi({
        ...f,
        isBookingDefault: f.id === t.defaultFormTemplateId,
        toolSlug: s.get(f.id) ?? null
      }),
      { updatedBy: rt, title: f.name, extra: { form_id: f.id } }
    ), d.push(I);
  }
  const l = await e.ls("forms");
  for (const f of l) {
    if (f.kind !== "file" || f.name === "README.md" || d.includes(f.path)) continue;
    const h = await e.stat(f.path);
    ((m = h == null ? void 0 : h.frontmatter) == null ? void 0 : m.updated_by) === rt && h.frontmatter.form_id && await e.rm(f.path);
  }
  return d;
}
function Ci(n) {
  const e = Hn(n.memoryCard);
  if (!e) return null;
  const i = Vn(e).map((r) => `## ${r.label}

${r.items.map((a) => `- ${a}`).join(`
`)}`);
  e.notes.trim() && i.push(`## Notes

${e.notes.trim()}`);
  const o = n.memoryCardUpdatedAt ? `
_As of ${it(n.memoryCardUpdatedAt)}. Background memory — verify money, dates, and status with the customer/job tools._
` : "";
  return `# ${n.name}
${o}
${i.join(`

`)}
`;
}
function Ae(n) {
  const e = Te(n.name) || n.id.slice(0, 8), t = n.id.toLowerCase().replace(/[^a-z0-9_-]+/g, "-").replace(/^-+|-+$/g, "");
  return `customers/${e}--${t}.md`;
}
function Ri(n) {
  return `customers/${Te(n.name) || n.id.slice(0, 8)}.md`;
}
async function Ui(n, e, t, i) {
  var c;
  const o = Ri(e), r = Ae(e), a = await n.stat(o);
  if (!a || a.kind !== "file") return;
  const s = typeof ((c = a.frontmatter) == null ? void 0 : c.customer_id) == "string" ? a.frontmatter.customer_id : null;
  if (s && s !== e.id) {
    t.some((d) => d.id === s) || i.skipped.push(`${o} (customer_id does not match any same-name customer)`);
    return;
  }
  if (!s && t.length !== 1) {
    i.skipped.push(`${o} (ambiguous same-name customer path)`);
    return;
  }
  if (await n.stat(r)) {
    i.skipped.push(`${o} (canonical customer path already exists)`);
    return;
  }
  await n.mv(o, r), i.written.push(r);
}
async function Fi(n, e, t = {}) {
  const i = Ci(e);
  if (!i) return null;
  const o = Ae(e);
  return !t.force && !await de(n, o) ? null : (await n.write(o, i, {
    updatedBy: te,
    title: e.name,
    sensitive: !0,
    extra: { customer_id: e.id }
  }), o);
}
async function ji(n, e, t = {}) {
  const i = "team/members.md";
  if (!t.force && !await de(e, i)) return !1;
  const r = (await n.user.findMany({
    where: { accountId: e.accountId, status: "ACTIVE" },
    orderBy: [{ role: "asc" }, { name: "asc" }],
    select: { name: !0, role: !0, canGenerateInvoices: !0, canMarkInvoicePaid: !0, canCancelJobs: !0, canAdjustSettings: !0 }
  })).map((a) => {
    const s = [];
    return a.role === "OWNER" ? s.push("everything (owner)") : (a.canGenerateInvoices && s.push("invoices"), a.canMarkInvoicePaid && s.push("payments"), a.canCancelJobs && s.push("job cancellations"), a.canAdjustSettings && s.push("settings")), `| ${a.name.replace(/\|/g, "\\|")} | ${a.role === "OWNER" ? "Owner" : "Member"} | ${s.join(", ") || "field work"} |`;
  });
  return await e.write(i, `# Team members

| Name | Role | Handles |
|---|---|---|
${r.join(`
`)}
`, {
    updatedBy: te,
    title: "Team members"
  }), !0;
}
async function Ji(n, e, t) {
  const i = await n.infoDoc.findMany({
    where: { accountId: e.accountId, archived: !1 },
    orderBy: { updatedAt: "asc" },
    select: {
      id: !0,
      title: !0,
      slug: !0,
      content: !0,
      updatedBy: !0,
      updatedAt: !0,
      createdAt: !0,
      area: { select: { slug: !0, name: !0 } }
    }
  });
  if (i.length === 0) return;
  const o = await n.customer.findMany({
    where: { accountId: e.accountId },
    select: { id: !0, name: !0 }
  }), r = /* @__PURE__ */ new Map();
  for (const s of o) {
    const c = s.name.trim().toLowerCase();
    r.set(c, [...r.get(c) ?? [], s]);
  }
  const a = {};
  for (const s of i) {
    const c = s.slug || Te(s.title) || s.id.slice(0, 8), d = s.area.slug, u = `_Migrated from memory area "${s.area.name}" (last updated ${it(s.updatedAt)}${s.updatedBy ? ` by ${s.updatedBy}` : ""})._`;
    if (d === "preferences" || d === "playbook") {
      const f = `business_knowledge/${d}.md`;
      (a[f] ?? (a[f] = [])).push(`## ${s.title}

${s.content.trim()}

${u}`);
      continue;
    }
    let l, m = !1;
    if (d === "business")
      l = `business_knowledge/${c}.md`;
    else if (d === "people") {
      const f = r.get(s.title.trim().toLowerCase()) ?? [];
      if (f.length > 1) {
        t.skipped.push(`people/${c} (ambiguous same-name customer)`);
        continue;
      }
      l = f[0] ? Ae(f[0]) : `team/${c}.md`, m = !0;
    } else
      l = `notes/${it(s.createdAt)}--${c}.md`;
    if (!await de(e, l)) {
      t.skipped.push(l);
      continue;
    }
    await e.write(l, `# ${s.title}

${s.content.trim()}

${u}
`, {
      updatedBy: te,
      title: s.title,
      sensitive: m,
      extra: { info_doc_id: s.id, area: d }
    }), t.written.push(l);
  }
  for (const [s, c] of Object.entries(a)) {
    if (!await de(e, s)) {
      t.skipped.push(s);
      continue;
    }
    const d = s.endsWith("preferences.md") ? `# Preferences

How the owner wants things done.
` : `# Playbook

Recurring procedures and know-how.
`;
    await e.write(s, `${d}
${c.join(`

`)}
`, { updatedBy: te }), t.written.push(s);
  }
}
async function Sa(n, e) {
  const t = { accountId: e.accountId, seeded: [], written: [], skipped: [] }, i = await e.ensureSeeded();
  t.seeded = i.written;
  const o = await n.customer.findMany({
    where: { accountId: e.accountId },
    select: { id: !0, name: !0, memoryCard: !0, memoryCardUpdatedAt: !0 }
  }), r = /* @__PURE__ */ new Map();
  for (const s of o) {
    const c = s.name.trim().toLowerCase();
    r.set(c, [...r.get(c) ?? [], s]);
  }
  for (const s of o)
    await Ui(
      e,
      s,
      r.get(s.name.trim().toLowerCase()) ?? [s],
      t
    );
  await Ji(n, e, t);
  const a = await n.accountKnowledgeDoc.findMany({
    where: { accountId: e.accountId },
    select: { name: !0, content: !0, enabled: !0, fileName: !0, updatedBy: !0 }
  });
  for (const s of a) {
    const c = `business_knowledge/${s.name}.md`;
    if (!await de(e, c)) {
      t.skipped.push(c);
      continue;
    }
    t.written.push(await _i(e, s, te));
  }
  await Di(n, e, { force: !1 }) ? t.written.push(x) : t.skipped.push(x), t.written.push(...await Mi(n, e));
  for (const s of o) {
    if (s.memoryCard == null) continue;
    const c = await Fi(e, s);
    c ? t.written.push(c) : t.skipped.push(Ae(s));
  }
  return await ji(n, e) ? t.written.push("team/members.md") : t.skipped.push("team/members.md"), await e.usage({ recompute: !0 }), t.written = [...new Set(t.written)], t.skipped = [...new Set(t.skipped)], t;
}
async function Ea(n, e, t, i) {
  var s;
  const { prisma: o, logger: r } = i, a = { logger: r };
  if (On(n)) {
    const c = t.customerId && t.customerName ? {
      id: t.customerId,
      path: Ae({ id: t.customerId, name: t.customerName })
    } : void 0;
    return _n(
      n,
      e,
      {
        accountId: t.accountId,
        actor: "lyra",
        customerScope: c,
        operationId: t.memoryOperationId
      },
      { memoryFs: i.memoryFs, logger: r }
    );
  }
  switch (n) {
    case "lookup_me":
      return yi(o, { customerId: t.customerId }, a);
    case "cancel_my_job":
      return pi(
        o,
        { jobId: e.jobId },
        { customerId: t.customerId, accountId: t.accountId },
        a
      );
    case "relay_to_account":
      return gi(
        o,
        { summary: e.summary },
        {
          accountId: t.accountId,
          customerId: t.customerId,
          customerName: t.customerName,
          callId: t.callId
        },
        a
      );
    case "request_owner_input":
      return Ti(
        o,
        {
          question: e.question,
          contextSummary: e.contextSummary,
          suggestedAnswers: e.suggestedAnswers
        },
        {
          accountId: t.accountId,
          source: t.source ?? (t.callId ? "voice" : "sms"),
          customerId: t.customerId,
          customerName: t.customerName,
          customerPhone: t.customerPhone,
          conversationId: t.conversationId,
          triggerMessageId: t.triggerMessageId,
          callId: t.callId,
          voiceTurns: t.voiceTurns
        },
        a
      );
    case "send_booking_link":
      return wi(
        o,
        {
          description: e.description,
          problem: e.problem,
          callerName: e.caller_name ?? e.callerName,
          address: e.address
        },
        {
          accountId: t.accountId,
          customerId: t.customerId,
          customerPhone: t.customerPhone,
          accountPhone: t.accountPhone,
          frontendUrl: t.frontendUrl,
          callId: t.callId
        },
        a
      );
    default:
      return (s = r == null ? void 0 : r.warn) == null || s.call(r, "customer-tools:execute", "unknown tool call", { tool: n }), JSON.stringify({ error: `Unknown tool: ${n}` });
  }
}
async function Mn(n, e, t) {
  await n.$executeRaw`
    SELECT pg_advisory_xact_lock(
      hashtextextended(${`${e}:${t}`}, 0)
    )
  `;
}
const Li = "outreach-tool:record-prospect-info", Bi = Wn.filter(
  (n) => n !== "password"
);
async function qi(n, e, t, i = {}) {
  var h, I, w, b;
  const o = pt(e.fields);
  if (!o.success)
    return JSON.stringify({ error: o.error });
  const r = o.values;
  if (Object.keys(r).length === 0)
    return JSON.stringify({ error: "Pass at least one field to record." });
  const a = await n.outreachSession.findUnique({
    where: { id: t.sessionId },
    select: { accountId: !0, prospectPhone: !0 }
  });
  if (!a || a.accountId !== t.accountId)
    return JSON.stringify({ error: "No active signup session for this prospect." });
  await Mn(n, a.accountId, a.prospectPhone);
  const s = await n.outreachSession.findUnique({
    where: { id: t.sessionId },
    select: {
      id: !0,
      accountId: !0,
      status: !0,
      prospectPhone: !0,
      collected: !0,
      account: { select: { outreachTemplate: { select: { formFields: !0 } } } }
    }
  });
  if (!s || s.accountId !== t.accountId || s.prospectPhone !== a.prospectPhone)
    return JSON.stringify({ error: "No active signup session for this prospect." });
  if (s.status === "SIGNED_UP") {
    const g = (h = t.frontendUrl) != null && h.trim() ? `${t.frontendUrl.trim()}/home (Settings)` : "their Ten Four dashboard (sign in, then Settings)";
    return JSON.stringify({
      error: `This prospect already signed up — their signup record is locked and this change was NOT saved. Tell them plainly you can't change their signup from this thread; they can update their business name, trade, service area and the rest at ${g}. Never say 'got it' as if it were saved.`
    });
  }
  const c = Kn((I = s.account.outreachTemplate) == null ? void 0 : I.formFields), d = /* @__PURE__ */ new Set([...c.map((g) => g.key), ...Bi]), u = {}, l = [];
  for (const [g, S] of Object.entries(r)) {
    const A = S.trim();
    if (A) {
      if (!d.has(g)) {
        l.push(g);
        continue;
      }
      u[g] = A;
    }
  }
  if (Object.keys(u).length === 0)
    return JSON.stringify({
      error: "None of those field keys exist on this signup.",
      rejected: l,
      allowedKeys: [...d]
    });
  const m = {};
  for (const [g, S] of Object.entries(
    s.collected ?? {}
  ))
    d.has(g) && typeof S == "string" && S.trim() && (m[g] = S);
  const f = pt({ ...m, ...u });
  return f.success ? (await n.outreachSession.update({
    where: { id: s.id },
    data: {
      collected: f.values,
      // Two-way contact + progress → the session is engaged (never demote a
      // later state like FORM_SENT).
      ...s.status === "REQUESTED" || s.status === "CALLING" ? { status: "ENGAGED" } : {}
    }
  }), (b = (w = i.logger) == null ? void 0 : w.log) == null || b.call(w, Li, "recorded prospect fields", {
    sessionId: s.id,
    keys: Object.keys(u)
  }), JSON.stringify({
    success: !0,
    saved: Object.keys(u),
    ...l.length > 0 ? { rejected: l } : {}
  })) : JSON.stringify({ error: f.error });
}
const Yi = "Msg & data rates may apply. Reply STOP to opt out, START to opt in, HELP for help.";
async function Hi(n, e, t) {
  return await n.$executeRaw`
    SELECT pg_advisory_xact_lock(
      hashtextextended(${`sms-first-contact:${e}`}, 0)
    )
  `, await n.message.findFirst({
    where: { conversationId: e, direction: "OUTBOUND" },
    select: { id: !0 }
  }) ? { body: t, firstContact: !1 } : { body: `${t}

${Yi}`, firstContact: !0 };
}
const Ge = "The signup link was texted to this phone by this tool just now. Do not say it is on the way or that you will send it.", rn = "outreach-tool:send-signup-form", Vi = 10080 * 60 * 1e3;
async function Wi(n, e, t = {}) {
  var I, w, b, g;
  if (!e.accountPhone)
    return JSON.stringify({ error: "No Ten Four number is configured to send from." });
  const i = await n.outreachSession.findUnique({
    where: { id: e.sessionId },
    select: { accountId: !0, prospectPhone: !0 }
  });
  if (!i || i.accountId !== e.accountId)
    return JSON.stringify({ error: "No active signup session for this prospect." });
  await Mn(n, i.accountId, i.prospectPhone);
  const o = await n.outreachSession.findUnique({
    where: { id: e.sessionId },
    select: {
      id: !0,
      accountId: !0,
      status: !0,
      prospectPhone: !0,
      customerId: !0,
      signupToken: !0
    }
  });
  if (!o || o.accountId !== e.accountId || o.prospectPhone !== i.prospectPhone)
    return JSON.stringify({ error: "No active signup session for this prospect." });
  if (o.status === "SIGNED_UP")
    return JSON.stringify({
      error: "This prospect already signed up — no form to send. Congratulate them instead."
    });
  const r = `sms.reply:outreach-form:${o.id}:${e.triggerId ?? "initial"}`;
  if (await n.outbox.findUnique({
    where: { idempotencyKey: r },
    select: { id: !0 }
  }))
    return (w = (I = t.logger) == null ? void 0 : I.log) == null || w.call(I, rn, "signup form already sent on this turn — skipping", {
      sessionId: o.id
    }), JSON.stringify({ success: !0, sentTo: "the prospect", reused: !0, note: Ge });
  const s = await n.customer.upsert({
    where: {
      accountId_phone: { accountId: e.accountId, phone: o.prospectPhone }
    },
    create: {
      accountId: e.accountId,
      name: o.prospectPhone,
      phone: o.prospectPhone,
      identityId: o.prospectPhone,
      contactStatus: "PROSPECT",
      consentSource: "outreach",
      lastSeenAt: /* @__PURE__ */ new Date()
    },
    update: { lastSeenAt: /* @__PURE__ */ new Date() },
    select: { id: !0, doNotText: !0, consentStatus: !0 }
  });
  if (s.doNotText || s.consentStatus === "opted_out")
    return JSON.stringify({
      error: "This number has opted out of Ten Four texts — the link cannot be sent. They can text START to this number to opt back in."
    });
  if (s.consentStatus !== "opted_in")
    return JSON.stringify({
      error: "The signup link cannot be texted until this number opts in. Ask them to text START to the Ten Four number, then try again."
    });
  const d = `Here's your Ten Four signup link — everything we talked about is already filled in: ${`${e.frontendUrl}/outreach/signup/${o.signupToken}`}`, u = `sms:${o.prospectPhone}`, l = await n.conversation.upsert({
    where: { accountId_threadKey: { accountId: e.accountId, threadKey: u } },
    create: {
      accountId: e.accountId,
      customerId: s.id,
      participantPhone: o.prospectPhone,
      participantType: "CUSTOMER",
      type: "SMS",
      threadKey: u,
      state: "ACTIVE",
      lastMessageAt: /* @__PURE__ */ new Date(),
      stateChangedAt: /* @__PURE__ */ new Date()
    },
    update: { lastMessageAt: /* @__PURE__ */ new Date(), customerId: s.id },
    select: { id: !0 }
  }), { body: m } = await Hi(n, l.id, d);
  if (await n.outbox.findUnique({
    where: { idempotencyKey: r },
    select: { id: !0 }
  }))
    return JSON.stringify({ success: !0, sentTo: "the prospect", reused: !0, note: Ge });
  await n.outreachSession.update({
    where: { id: o.id },
    data: {
      tokenExpiresAt: new Date(Date.now() + Vi),
      status: "FORM_SENT",
      formSentAt: /* @__PURE__ */ new Date(),
      customerId: s.id
    }
  });
  const h = await n.message.create({
    data: {
      conversationId: l.id,
      accountId: e.accountId,
      direction: "OUTBOUND",
      senderType: "SYSTEM",
      fromNumber: e.accountPhone,
      toNumber: o.prospectPhone,
      body: m,
      status: "processing",
      approvedBy: "system",
      approvedAt: /* @__PURE__ */ new Date()
    },
    select: { id: !0 }
  });
  return await n.outbox.upsert({
    where: { idempotencyKey: r },
    create: {
      aggregateType: "message",
      aggregateId: h.id,
      eventType: "sms.reply",
      accountId: e.accountId,
      priority: 10,
      payload: {
        messageId: h.id,
        to: o.prospectPhone,
        from: e.accountPhone,
        body: m,
        accountId: e.accountId
      },
      idempotencyKey: r
    },
    update: {}
  }), (g = (b = t.logger) == null ? void 0 : b.log) == null || g.call(b, rn, "texted signup form to prospect", { sessionId: o.id }), JSON.stringify({ success: !0, sentTo: "the prospect", note: Ge });
}
const Ki = "outreach-tool:send-page-link";
function zi(n, e = {}) {
  var o, r;
  const t = (n.page ?? "").trim(), i = It[t];
  return i ? ((r = (o = e.logger) == null ? void 0 : o.log) == null || r.call(o, Ki, "resolved page link", { page: t }), JSON.stringify({ success: !0, page: t, url: i, note: "Include this URL in your reply." })) : JSON.stringify({
    error: `Unknown page "${n.page ?? ""}"`,
    pages: Object.keys(It)
  });
}
async function ka(n, e, t, i) {
  var s;
  const { prisma: o, logger: r } = i, a = { logger: r };
  switch (n) {
    case "record_prospect_info":
      return qi(
        o,
        { fields: e.fields },
        { accountId: t.accountId, sessionId: t.sessionId, frontendUrl: t.frontendUrl },
        a
      );
    case "send_signup_form":
      return Wi(
        o,
        {
          accountId: t.accountId,
          sessionId: t.sessionId,
          accountPhone: t.accountPhone,
          frontendUrl: t.frontendUrl,
          triggerId: t.triggerId
        },
        a
      );
    case "send_page_link":
      return zi({ page: e.page }, a);
    case "answer_directly":
      return JSON.stringify({ success: !0 });
    default:
      return (s = r == null ? void 0 : r.warn) == null || s.call(r, "outreach-tools:execute", "unknown tool call", { tool: n }), JSON.stringify({ error: `Unknown tool: ${n}` });
  }
}
async function Oa(n, e, t) {
  if (!t) return null;
  const o = (await n.user.findMany({
    where: { accountId: e, status: "ACTIVE", mobilePhone: { not: null } },
    select: {
      id: !0,
      name: !0,
      role: !0,
      mobilePhone: !0,
      canGenerateInvoices: !0,
      canMarkInvoicePaid: !0,
      canCancelJobs: !0
    }
  })).find((r) => Re(r.mobilePhone, t));
  return o ? {
    userId: o.id,
    name: o.name,
    // Fail CLOSED: only an explicit 'OWNER' grants owner privileges. Any other /
    // unexpected value (a future enum member, an out-of-band write) resolves to the
    // least-privileged role. This reads straight from the DB (not a signed claim).
    accountRole: o.role === "OWNER" ? "OWNER" : "MEMBER",
    canGenerateInvoices: o.canGenerateInvoices,
    canMarkInvoicePaid: o.canMarkInvoicePaid,
    canCancelJobs: o.canCancelJobs
  } : null;
}
const Gi = ["google", "facebook", "yelp"], Qi = {
  google: "googleReviewUrl",
  facebook: "facebookReviewUrl",
  yelp: "yelpReviewUrl"
};
function Zi(n, e) {
  if (!n) return null;
  const t = Qi[e];
  if (!t) return null;
  const i = n[t];
  return i && i.trim().length > 0 ? i : null;
}
async function _a(n, e, t) {
  const i = await n.reviewFollowupSettings.findUnique({
    where: { accountId: e },
    select: { googleReviewUrl: !0, facebookReviewUrl: !0, yelpReviewUrl: !0 }
  });
  if (!i) return [];
  const o = t.replace(/\/+$/, ""), r = [];
  for (const a of Gi) {
    if (!Zi(i, a)) continue;
    const s = await n.reviewLink.upsert({
      where: { accountId_platform: { accountId: e, platform: a } },
      create: { accountId: e, platform: a },
      update: {},
      select: { code: !0 }
    });
    r.push({ platform: a, url: `${o}/r/${s.code}` });
  }
  return r;
}
const Qe = 1e3;
function $a(n, e = zn) {
  const t = () => n.from(e);
  async function i(r) {
    const a = [];
    for (let s = 0; ; s += Qe) {
      const { data: c, error: d } = await t().list(r, { limit: Qe, offset: s });
      if (d) throw new Error(`memory storage list failed (${r}): ${d.message}`);
      const u = c ?? [];
      if (a.push(...u), u.length < Qe) break;
    }
    return a;
  }
  async function o(r, a) {
    var c, d;
    const s = await i(r);
    for (const u of s) {
      if (!u.name || u.name === ".emptyFolderPlaceholder") continue;
      const l = r ? `${r}/${u.name}` : u.name;
      if (u.id == null && !u.metadata) {
        await o(l, a);
        continue;
      }
      a.push({
        key: l,
        size: Number(((c = u.metadata) == null ? void 0 : c.size) ?? 0),
        updatedAt: u.updated_at ?? null,
        contentType: (d = u.metadata) == null ? void 0 : d.mimetype
      });
    }
  }
  return {
    async list(r) {
      const a = [], s = r.endsWith("/") ? r.slice(0, -1) : r;
      return await o(s, a), a;
    },
    async download(r) {
      const { data: a, error: s } = await t().download(r);
      if (s) {
        const c = s.statusCode ?? s.status;
        if (String(c) === "404" || /not found/i.test(s.message)) return null;
        throw new Error(`memory storage download failed (${r}): ${s.message}`);
      }
      return a ? { bytes: Buffer.from(await a.arrayBuffer()) } : null;
    },
    async upload(r, a, s) {
      const { error: c } = await t().upload(r, a, { contentType: s, upsert: !0 });
      if (c) throw new Error(`memory storage upload failed (${r}): ${c.message}`);
    },
    async createIfAbsent(r, a, s) {
      const { error: c } = await t().upload(r, a, { contentType: s, upsert: !1 });
      if (!c) return !0;
      const d = c, u = d.code ?? d.error, l = String(d.statusCode ?? d.status ?? "");
      if (["ResourceAlreadyExists", "KeyAlreadyExists", "Duplicate", "already_exists"].includes(u ?? "") || (l === "400" || l === "409") && /already exists/i.test(c.message)) return !1;
      throw new Error(`memory storage create failed (${r}): ${c.message}`);
    },
    async remove(r) {
      if (r.length === 0) return;
      const { error: a } = await t().remove(r);
      if (a && !/not found/i.test(a.message))
        throw new Error(`memory storage remove failed: ${a.message}`);
    },
    async move(r, a) {
      const { error: s } = await t().move(r, a);
      if (s) throw new Error(`memory storage move failed (${r} → ${a}): ${s.message}`);
    },
    async signedUrl(r, a) {
      const { data: s, error: c } = await t().createSignedUrl(r, a);
      return c || !(s != null && s.signedUrl) ? null : s.signedUrl;
    }
  };
}
function Da(n = () => /* @__PURE__ */ new Date()) {
  const e = /* @__PURE__ */ new Map();
  return {
    objects: e,
    async list(t) {
      const i = [], o = t.endsWith("/") || t === "" ? t : `${t}/`;
      for (const [r, a] of e)
        r.startsWith(o) && i.push({ key: r, size: a.bytes.length, updatedAt: a.updatedAt, contentType: a.contentType });
      return i.sort((r, a) => r.key.localeCompare(a.key));
    },
    async download(t) {
      const i = e.get(t);
      return i ? { bytes: i.bytes, contentType: i.contentType } : null;
    },
    async upload(t, i, o) {
      e.set(t, { bytes: Buffer.from(i), contentType: o, updatedAt: n().toISOString() });
    },
    async createIfAbsent(t, i, o) {
      return e.has(t) ? !1 : (e.set(t, { bytes: Buffer.from(i), contentType: o, updatedAt: n().toISOString() }), !0);
    },
    async remove(t) {
      for (const i of t) e.delete(i);
    },
    async move(t, i) {
      const o = e.get(t);
      if (!o) throw new Error(`memory storage move failed: ${t} not found`);
      e.delete(t), e.set(i, o);
    },
    async signedUrl(t) {
      return e.has(t) ? `memory://${t}?signed` : null;
    }
  };
}
export {
  vt as ADMIN_INVOICE_PENDING_REVIEW_EMAIL_EVENT,
  wt as ADMIN_REVIEW_ITEM_CREATED_EVENT,
  ct as ANNUAL_INTERVAL_MONTHS,
  gt as AVAILABILITY_WINDOW_DAYS,
  ue as BUNDLED_TIER_CONFIGS,
  ss as CUSTOMER_LIST_PAGE_SIZE,
  as as CUSTOMER_LIST_STAGE_TABS,
  qe as DEFAULT_ANNUAL_DISCOUNT_PERCENT,
  wo as DEFAULT_CUSTOMER_ACTIVITY_LIMIT,
  dt as DEFAULT_GROWTH_CAP_USD,
  Eo as INVOICE_DELIVERY_EVENT_TYPES,
  jt as INVOICE_DRAFTED_INTERNAL_EVENT,
  ls as INVOICE_LIST_PAGE_SIZE,
  ms as INVOICE_LIST_STAGE_TABS,
  be as InvoiceInputError,
  Pn as KNOWLEDGE_DIR,
  Mo as MANUAL_MODE_BLOCKED_ASSISTANT_TOOLS,
  Gn as MAX_OCCURRENCES_PER_EVENT,
  Ot as MEETING_AI_QUOTA_MAX_ATTEMPTS,
  He as MEMORY_CAT_MAX_CHARS,
  Vt as MEMORY_PATH_MAX_DEPTH,
  Ht as MEMORY_PATH_MAX_LENGTH,
  Sn as MEMORY_SEED_DOCUMENTS,
  wa as MEMORY_SEED_PATHS,
  va as MemoryFs,
  Pe as MemoryNotFoundError,
  C as MemoryPathError,
  En as MemoryQuotaError,
  uo as NEEDS_YOU_SNOOZE_MAX_MS,
  Cs as PAYABLE_INVOICE_STATUSES,
  js as PLATFORM_BILLING_INTERVALS,
  fn as PROFILE_GAP_FIELDS,
  sr as REVIEW_FOLLOWUP_DEFAULT_DELAY_DAYS,
  Gi as REVIEW_PLATFORMS,
  x as SERVICES_PATH,
  nn as SERVICES_TABLE_HEADER,
  hn as SETUP_CHECKLIST_ITEMS,
  As as SETUP_CHECKLIST_ORDER,
  Yi as SMS_FIRST_CONTACT_FOOTER,
  Uo as TIER_FEATURE_KEYS,
  Ro as TIER_FEATURE_REGISTRY,
  vn as TIER_ORDER,
  Ko as accountSmsMessageId,
  Fs as addBillingPeriod,
  Oo as addOneYearUtc,
  $s as adminStatusBadgeRole,
  ut as annualFeeUsd,
  $o as annualMonthlyEquivalentUsd,
  _o as annualSavingsUsd,
  Hi as appendSmsFirstContactFooter,
  Ws as applyAccountUsageOverrides,
  mn as applyInvoiceChipFilters,
  Bs as applyPlatformBillingDiscounts,
  vr as approveInvoice,
  ns as buildAvailabilityContext,
  Ps as buildCustomerActivity,
  Ds as buildHomeQueue,
  ya as buildInvoiceInReviewAckBody,
  ha as buildInvoicePendingReviewAlertBody,
  fa as buildInvoiceUrl,
  pa as buildReviewRequestText,
  xe as buildTaxBasis,
  Xe as calculateInvoiceTotals,
  eo as calculateTaxOffInvoicePatch,
  Qn as calendarOccurrenceStart,
  ts as calendarWindowWhere,
  Xt as can,
  Tr as cancelInvoice,
  lr as cancelJob,
  ko as cancelRunnableInvoiceDeliveryEvents,
  ia as claimMeetingAiUsageSlot,
  is as clearDraftSalesTaxForAccount,
  ri as completeHandoff,
  ca as composeAddress,
  tt as computeInvoiceBalance,
  ta as computeMeterState,
  oa as computeOverageUsd,
  pn as conversationActivityAt,
  yn as conversationActivityKind,
  mo as conversationNeedsYouCandidate,
  hs as countForInvoiceStage,
  us as countForStage,
  at as createBookingToken,
  nr as createCustomer,
  Da as createInMemoryMemoryStorage,
  gr as createInvoiceForAssistant,
  No as createInvoiceFromTemplate,
  rr as createJob,
  $a as createSupabaseMemoryStorage,
  go as customerActivityMeetingAt,
  Ae as customerMemoryPath,
  Rs as customerNeedsBookingIntake,
  Ls as cycleSubscriptionFeeUsd,
  un as discountedTaxBase,
  fr as editInvoice,
  cn as enqueueAdminInvoicePendingReviewEmail,
  os as enqueueAdminReviewItemCreated,
  yr as enqueueInvoiceDraftedNotification,
  ar as enqueueReviewFollowup,
  vo as ensureDefaultInvoiceTemplate,
  ba as executeAssistantTool,
  Ea as executeCustomerTool,
  _n as executeMemoryTool,
  ka as executeOutreachTool,
  es as expandCalendarOccurrences,
  xn as fanoutAdminPush,
  ds as filterAndSortCustomers,
  ys as filterAndSortInvoices,
  Ms as filterQueueTableRows,
  Yo as formatInvoiceForAccount,
  Le as formatJobForAccount,
  Vo as formatUsPhone,
  sa as formatUsPhoneInput,
  xo as getQueue,
  Ce as hasBillableOverageRate,
  ps as invoiceAttention,
  rs as invoiceCarriesTax,
  et as invoiceDueDateOf,
  Tn as invoiceStageForAccount,
  ua as isCustomerFacingConversation,
  Nt as isInactiveCustomer,
  Ys as isManualMode,
  J as isMarkdownPath,
  On as isMemoryTool,
  At as isNeedsYouSnoozeActive,
  Ns as isProfileComplete,
  ws as isReminderDue,
  ks as isSetupChecklistComplete,
  Ss as isSetupChecklistItemKey,
  _s as isSetupClassReminderId,
  Wt as isTextPath,
  aa as isValidUsPhone,
  Je as jobStageForAccount,
  kr as listCustomers,
  Mr as listPendingInvoices,
  Dr as listRecentConversations,
  Na as loadKnowledgeDocsFromMemory,
  Ta as loadServicesFromMemory,
  Mn as lockOutreachProspect,
  er as lookupCustomer,
  mr as markInvoicePaid,
  Tt as matchesInvoiceDateFilter,
  ln as matchesInvoiceStage,
  De as memoryBasename,
  ga as memoryDirname,
  oi as messageCustomer,
  na as metersForceManualMode,
  Sa as migrateAccountMemory,
  Fi as mirrorCustomerCardToMemory,
  Mi as mirrorFormsToMemory,
  _i as mirrorKnowledgeDocToMemory,
  Di as mirrorServicesToMemory,
  ji as mirrorTeamToMemory,
  gs as moneyInvoiceFiguresMode,
  Co as monthKeyUtc,
  Vs as monthStartUtc,
  U as normalizeMemoryPath,
  Nn as normalizePhone,
  ra as outreachPricingFactsBlock,
  H as parseMemoryDocument,
  Si as parseServicesMarkdown,
  Re as phonesMatch,
  ma as pickConversationForJob,
  da as pickDefaultConversationId,
  Ts as profileGapLabels,
  ho as profileGaps,
  Js as proratedAnnualCreditUsd,
  Es as reconcileSetupChecklistStatus,
  In as recordActivity,
  So as recordInvoicePayment,
  qi as recordProspectInfo,
  gn as refreshBookingTokenPrefill,
  Aa as removeKnowledgeDocFromMemory,
  Ci as renderCustomerCard,
  ot as renderServicesTable,
  $n as renderTree,
  ki as replaceServicesTable,
  Ti as requestOwnerInput,
  ne as resolveAccountPhones,
  Oa as resolveAccountUser,
  bs as resolveConversationNeedsYouSignal,
  Ks as resolveLlmBudgetUsd,
  hr as resolveSubscriptionPerkDiscount,
  zs as resolveTierEntitlements,
  _a as resolveTrackedReviewLinks,
  Hs as resolveUsageCapUsd,
  Zi as reviewPlatformDestination,
  no as rollupCustomerStats,
  zo as sendAccountAccountSms,
  Ar as sendBookingLink,
  An as sendBookingLinkToCustomer,
  Ia as sendForm,
  zi as sendPageLink,
  Wi as sendSignupForm,
  Yt as serializeMemoryDocument,
  Ei as servicePriceText,
  $i as serviceRowsFromDb,
  po as setupChecklistItem,
  Os as setupChecklistRemaining,
  Te as slugifyMemoryName,
  la as sortJobsNewestFirst,
  vs as sortNeedsYouItems,
  Us as splitCustomerDisplayName,
  Do as subOneYearUtc,
  Is as summarizeInvoicesMoney,
  _r as summarizeToday,
  lt as tierAnnualDiscountPercent,
  Lo as tierAnnualFeeUsd,
  Qs as tierAnnualMonthlyEquivalentUsd,
  Gs as tierAnnualSavingsUsd,
  Zs as tierFeeUsd,
  Jo as tierHasFeature,
  Xs as tierMaxGroupChats,
  xs as tierMonthlyAiMeetings,
  je as tierMonthlyFeeUsd,
  qs as tierRank,
  ea as tiersWithFeature,
  fs as toggleInvoiceSort,
  cs as toggleSort,
  dr as updateJobStatus,
  bn as usPhoneDigits,
  to as validateInvoiceMoneyInputs,
  wr as writeInvoice
};
